import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Action: any;
  Any: any;
  Date: any;
  DateTime: any;
  EmptyObject: any;
  Long: any;
  Metadata: any;
  PaginationCursor: any;
  Payload: any;
  Void: any;
};

export type AcKalp = {
  adults: Scalars['Int'];
  children: Scalars['Int'];
  employmentType: EmploymentType;
  housingType: HousingType;
  income: Scalars['Int'];
  selfAssessedHomeCost?: InputMaybe<Scalars['Int']>;
  selfAssessedTotalMonthlyLoanCost?: InputMaybe<Scalars['Int']>;
  selfAssessedTransportCost?: InputMaybe<Scalars['Int']>;
};

export type AcceptCreditSpaceQuotationInput = {
  payoutAmount: Scalars['Float'];
};

export type AcceptCreditSpaceQuotationResponse = {
  __typename?: 'AcceptCreditSpaceQuotationResponse';
  id: Scalars['String'];
  preapproved: Scalars['Boolean'];
};

export type AcceptGroupInvitationResponse = {
  __typename?: 'AcceptGroupInvitationResponse';
  success: Scalars['Boolean'];
};

export type AcceptMonthlyPayChangeResponse = MutationResponse & {
  __typename?: 'AcceptMonthlyPayChangeResponse';
  code: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum AccessType {
  OpenBanking = 'OPEN_BANKING',
  Other = 'OTHER'
}

export type Accommodation = {
  __typename?: 'Accommodation';
  accommodationType: AccomodationType;
  monthlyCost: MoneyMinor;
};

export type AccommodationInput = {
  accommodationType: AccomodationType;
  monthlyCost: MoneyMinorInput;
};

export enum AccomodationType {
  House = 'House',
  Lodger = 'Lodger',
  Rental = 'Rental',
  Tenant = 'Tenant',
  TenantOwnership = 'TenantOwnership'
}

export type Account = {
  __typename?: 'Account';
  /** The balance data of the account. */
  balance: AccountBalance;
  /**
   * The cards that belong to this account. If this account does not have any cards
   * connected to it the array will be empty.
   */
  cards: Array<Card>;
  /** The customer's ID. */
  customerId: Scalars['String'];
  /** The account's ID. */
  id: Scalars['String'];
  /** The current status of the account. */
  status: AccountStatus;
};

export type AccountBalance = {
  __typename?: 'AccountBalance';
  /**
   * The available amount on this account. Excludes reserved amounts, so represents how much money is currently available to be spent.
   * This amount is in minor units, usually 1/100th of the "normal" currency.
   */
  available: Scalars['Int'];
  /** The currency unit of the amounts. */
  currency: Currency;
  /**
   * The total amount on this account. Includes reserved amounts. For example if you have 1000 kr on your account,
   * and buy food for 500 kr, this field will still show 1000 kr for a few days, since it's calculated as
   * (available + reserved = 500 + 500 = 1000). This amount is in minor units, usually 1/100 of the "normal" currency.
   */
  total: Scalars['Int'];
};

export type AccountBox = {
  __typename?: 'AccountBox';
  account: TinkAccount;
  credential: TinkCredentialV3;
  id: Scalars['String'];
  provider: TinkProvider;
};

export type AccountCheckInput = {
  app: Scalars['String'];
  appUrl?: InputMaybe<Scalars['String']>;
  inputProvider?: InputMaybe<Scalars['String']>;
  inputUsername?: InputMaybe<Scalars['String']>;
  redirectUrl: Scalars['String'];
};

export type AccountCheckLinkResponse = {
  __typename?: 'AccountCheckLinkResponse';
  tinkLink: Scalars['String'];
};

export type AccountCheckReportAccount = {
  __typename?: 'AccountCheckReportAccount';
  accountNumber: Scalars['String'];
  accountNumberSignature: Scalars['String'];
  iban: Scalars['String'];
  name: Scalars['String'];
  rixIdentifier?: Maybe<AccountCheckReportRixIdentifier>;
  tinkId: Scalars['String'];
};

export type AccountCheckReportIdentity = {
  __typename?: 'AccountCheckReportIdentity';
  name?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
};

export type AccountCheckReportInput = {
  app: Scalars['String'];
  id: Scalars['String'];
};

export type AccountCheckReportResponse = {
  __typename?: 'AccountCheckReportResponse';
  account: AccountCheckReportAccount;
  financialInstitutionId?: Maybe<Scalars['String']>;
  financialInstitutionName: Scalars['String'];
  identity: AccountCheckReportIdentity;
  providerName: Scalars['String'];
};

export type AccountCheckReportRixIdentifier = {
  __typename?: 'AccountCheckReportRixIdentifier';
  accountNumber: Scalars['String'];
  clearingNumber: Scalars['String'];
};

export type AccountContactInformation = {
  __typename?: 'AccountContactInformation';
  email?: Maybe<EmailAddress>;
  phone?: Maybe<MobilePhoneNumber>;
};

export type AccountCredit = {
  __typename?: 'AccountCredit';
  accountBQID: Scalars['String'];
  availableWithdrawalMethods?: Maybe<Array<Scalars['String']>>;
  bankAccountDetails?: Maybe<BankAccountDetails>;
  contactInformation: ContactInformation;
  created?: Maybe<Scalars['String']>;
  creditLimit: CreditLimit;
  currentBankgiro?: Maybe<Scalars['String']>;
  customerName: CustomerName;
  effectiveInterestRate?: Maybe<Scalars['Float']>;
  fundingOrganization?: Maybe<FundingOrganization>;
  id: Scalars['ID'];
  interestRate: Scalars['Float'];
  ssn?: Maybe<Scalars['String']>;
  status: AccountCreditStatus;
  trustlyAccountId?: Maybe<Scalars['String']>;
  usedAmount: UsedAmount;
};

export type AccountCreditApplication = {
  __typename?: 'AccountCreditApplication';
  address?: Maybe<Address>;
  contactInformation?: Maybe<ContactInformation>;
  created?: Maybe<Scalars['String']>;
  creditLimit?: Maybe<CreditLimit>;
  effectiveInterestRate?: Maybe<Scalars['Float']>;
  fundingOrganization?: Maybe<FundingOrganization>;
  id: Scalars['ID'];
  interestRate?: Maybe<Scalars['Float']>;
  loanNumber?: Maybe<Scalars['String']>;
  signedContractDate?: Maybe<Scalars['String']>;
  ssn?: Maybe<Ssn>;
  status?: Maybe<ApplicationStatus>;
};

export type AccountCreditApplicationData = {
  __typename?: 'AccountCreditApplicationData';
  address?: Maybe<Address>;
  contactInformation?: Maybe<ContactInformation>;
  created?: Maybe<Scalars['String']>;
  creditLimit?: Maybe<Scalars['Float']>;
  currency?: Maybe<Currency>;
  fundingOrganization?: Maybe<FundingOrganization>;
  id: Scalars['ID'];
  interestRate?: Maybe<InterestRate>;
  loanNumber?: Maybe<Scalars['String']>;
  signedContractDate?: Maybe<Scalars['String']>;
  ssn?: Maybe<Ssn>;
  status?: Maybe<ApplicationStatus>;
};

export enum AccountCreditCampaign {
  ElectricityCampaign = 'ElectricityCampaign',
  ZeroInterestTwoMonths = 'ZeroInterestTwoMonths'
}

export type AccountCreditData = {
  __typename?: 'AccountCreditData';
  accountBQID: Scalars['String'];
  bankAccountDetails?: Maybe<BankAccountDetails>;
  contactInformation: ContactInformation;
  creditLimit: Scalars['Float'];
  currency: Currency;
  currentBankgiro: Scalars['String'];
  customerName: CustomerName;
  fundingOrganization: FundingOrganization;
  id: Scalars['ID'];
  interestRate: Scalars['Float'];
  ssn: Scalars['String'];
  status: AccountCreditStatus;
  trustlyAccountId?: Maybe<Scalars['String']>;
  usedAmount: Scalars['Float'];
};

export enum AccountCreditDecision {
  Approved = 'APPROVED',
  Denied = 'DENIED'
}

export type AccountCreditIncrease = {
  __typename?: 'AccountCreditIncrease';
  address: Address;
  contactInformation: ContactInformation;
  created: Scalars['String'];
  creditLimit?: Maybe<CurrencyAmount>;
  effectiveInterestRate?: Maybe<Scalars['Float']>;
  fundingOrganization: FundingOrganization;
  id: Scalars['String'];
  interestRate?: Maybe<Scalars['Float']>;
  loanNumber: Scalars['ID'];
  signedContractDate?: Maybe<Scalars['String']>;
  ssn: Ssn;
  status: AccountCreditIncreaseStatusV2;
};

export enum AccountCreditIncreaseStatusV2 {
  Archived = 'ARCHIVED',
  AwaitingSignature = 'AWAITING_SIGNATURE',
  Completed = 'COMPLETED',
  Denied = 'DENIED',
  InProgress = 'IN_PROGRESS',
  InProgressNordiska = 'IN_PROGRESS_NORDISKA',
  MakeQuotation = 'MAKE_QUOTATION',
  Started = 'STARTED'
}

export type AccountCreditInvoices = {
  __typename?: 'AccountCreditInvoices';
  invoiceList: Array<Invoice>;
};

export type AccountCreditInvoicesV2 = {
  __typename?: 'AccountCreditInvoicesV2';
  invoices: Array<Invoice>;
};

export enum AccountCreditStatus {
  ActiveState = 'ActiveState',
  ArchivedState = 'ArchivedState',
  PayoutInProgressState = 'PayoutInProgressState'
}

export type AccountCreditTransaction = {
  __typename?: 'AccountCreditTransaction';
  amount: Scalars['Float'];
  bookDate: Scalars['String'];
  id: Scalars['Int'];
  method: TransactionMethod;
  transactionType: TransactionType;
};

export type AccountCreditTransactions = {
  __typename?: 'AccountCreditTransactions';
  transactions: Array<AccountCreditTransaction>;
};

export enum AccountExclusion {
  Aggregation = 'AGGREGATION',
  None = 'NONE',
  PfmAndSearch = 'PFM_AND_SEARCH',
  PfmData = 'PFM_DATA'
}

export type AccountFilter = {
  status?: InputMaybe<Array<AccountStatus>>;
};

export enum AccountState {
  Active = 'Active',
  Canceled = 'Canceled',
  Creating = 'Creating',
  Frozen = 'Frozen'
}

export enum AccountStatus {
  /** The account is temporarily blocked from use. */
  Blocked = 'BLOCKED',
  /** The account is permanently closed. */
  Closed = 'CLOSED',
  /** Default status. */
  Ok = 'OK'
}

export type Achievement = {
  __typename?: 'Achievement';
  /**
   * All possible achievements codes:
   * keep.budget.tier-1, keep.budget.tier-2, keep.budget.tier-3, keep.budget.tier-4, keep.budget.tier-5, keep.budget.tier-6, keep.no-expense.tier-1, keep.no-expense.tier-2, keep.no-expense.tier-3, keep.no-expense.tier-4, keep.no-expense.tier-5, keep.no-expense.tier-6, goal.savings.tier-1, goal.savings.tier-2, goal.savings.tier-3, goal.savings.tier-4, goal.savings.tier-5, goal.savings.tier-6, goal.health-index.tier-1, goal.health-index.tier-2, goal.health-index.tier-3, goal.health-index.tier-4, goal.health-index.tier-5, goal.health-index.tier-6, unlock.connect, unlock.health-index, unlock.fixed-costs, unlock.budget, unlock.loan-index, unlock.savings, unlock.card, unlock.groups, unlock.invite-a-friend
   */
  code: Scalars['String'];
  numberOfTimes: NumberOfTimes;
};

export type AchievementProgress = {
  __typename?: 'AchievementProgress';
  /** If null, then the achievement is not achieved yet */
  achievedAt?: Maybe<Scalars['String']>;
  achievement: Achievement;
  /** How many occurence of the same achievements. Only for keep-no-expense and keep-budget */
  occurence?: Maybe<Scalars['Int']>;
  progress: AchievementTypeResponse;
  /** If null, then the achievement is not seen yet */
  seenAt?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['String']>;
};

export enum AchievementType {
  KeepStreak = 'KEEP_STREAK',
  ReachValue = 'REACH_VALUE',
  Unlock = 'UNLOCK'
}

export type AchievementTypeResponse = KeepStreakAchievementType | ReachValueAchievementType | UnlockAchievementType;

export type AchievementsResponse = {
  __typename?: 'AchievementsResponse';
  achievements: Array<AchievementProgress>;
  newAchievements: Array<AchievementProgress>;
};

export type ActionTransaction = {
  __typename?: 'ActionTransaction';
  amount: CurrencyDenominatedAmount;
  category?: Maybe<TinkCategory>;
  categoryId: Scalars['String'];
  date: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  merchant?: Maybe<Merchant>;
  systemTags: Array<Scalars['String']>;
  transactionTags?: Maybe<Array<TransactionTag>>;
  type?: Maybe<ActionTransactionType>;
};

export type ActionTransactionType = ActionTransactionTypeLoan | ActionTransactionTypeSubscription;

export type ActionTransactionTypeLoan = {
  __typename?: 'ActionTransactionTypeLoan';
  id: Scalars['String'];
};

export type ActionTransactionTypeSubscription = {
  __typename?: 'ActionTransactionTypeSubscription';
  id: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type ActivatePayfreeMonthResponse = MutationResponse & {
  __typename?: 'ActivatePayfreeMonthResponse';
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type AddBankAccountToAccountCreditInput = {
  accountNumber: Scalars['String'];
  financialInstitutionId?: InputMaybe<Scalars['String']>;
};

export type AddBankAccountToAccountCreditResponse = {
  __typename?: 'AddBankAccountToAccountCreditResponse';
  autoStartToken: Scalars['String'];
  status?: Maybe<CreditDirectDebitAccountStatus>;
};

export type AddCredentialResponse = CardMutationResponse & {
  __typename?: 'AddCredentialResponse';
  code: Scalars['String'];
  credential?: Maybe<TinkCredential>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type AddGroupExpenseResponse = {
  __typename?: 'AddGroupExpenseResponse';
  success: Scalars['Boolean'];
};

export type AddMultipleGroupExpenseResponse = {
  __typename?: 'AddMultipleGroupExpenseResponse';
  expenseIds: Array<Scalars['String']>;
};

export type AddProviderResponse = CardMutationResponse & {
  __typename?: 'AddProviderResponse';
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type AddTransactionTagResponse = {
  __typename?: 'AddTransactionTagResponse';
  success: Scalars['Boolean'];
};

export type AddWebAccountCreditApplicationResponse = {
  __typename?: 'AddWebAccountCreditApplicationResponse';
  decision?: Maybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  street: Scalars['String'];
  streetExtra: Scalars['String'];
  streetExtra2: Scalars['String'];
  zip: Scalars['String'];
};

export type AgentApplicationResponse = {
  __typename?: 'AgentApplicationResponse';
  success: Scalars['Boolean'];
};

export type AmortizationPeriod = {
  __typename?: 'AmortizationPeriod';
  chronoUnit: ChronoUnitField;
  length: Scalars['Int'];
};

export type AmortizationPeriodInput = {
  chronoUnit: ChronoUnitInput;
  length: Scalars['Int'];
};

export type AmortizationStatusInput = {
  sessionId: Scalars['String'];
  token: Scalars['String'];
};

export type Amount = {
  __typename?: 'Amount';
  amount: Scalars['Float'];
  currency: Scalars['String'];
};

export type Annuity = {
  __typename?: 'Annuity';
  amount: MoneyMinor;
};

export type AppAccountCreditApplicationBasicResponse = {
  __typename?: 'AppAccountCreditApplicationBasicResponse';
  decision: AccountCreditDecision;
  id?: Maybe<Scalars['String']>;
};

export type AppFeedExpenseChart = {
  __typename?: 'AppFeedExpenseChart';
  averageSpentPerDayAmount: Scalars['Float'];
  currentMonthDatasets: Array<Scalars['Float']>;
  currentMonthLabels: Array<Scalars['Int']>;
  previousMonthDatasets: Array<Scalars['Float']>;
  spentPercentageComparedToPreviousMonth: Scalars['Float'];
  totalExpensesAmountForCurrentMonth: Scalars['Float'];
};

export type AppStartInfo = {
  __typename?: 'AppStartInfo';
  autoStartToken: Scalars['String'];
};

export type AppleInAppProvisioningInput = {
  certificates: Array<Scalars['String']>;
  nonce: Scalars['String'];
  nonceSignature: Scalars['String'];
};

export type AppleInAppProvisioningTokenResponse = {
  __typename?: 'AppleInAppProvisioningTokenResponse';
  activationData: Scalars['String'];
  encryptedPassData: Scalars['String'];
  ephemeralPublicKey: Scalars['String'];
};

export enum AppleWalletTestCard {
  Card1 = 'CARD1',
  Card2 = 'CARD2',
  Card3 = 'CARD3',
  Card4 = 'CARD4',
  Card5 = 'CARD5',
  Card6 = 'CARD6'
}

export enum ApplicationStatus {
  AccountCreditCreated = 'ACCOUNT_CREDIT_CREATED',
  AccountCreditDenied = 'ACCOUNT_CREDIT_DENIED',
  AccountCreditIncomplete = 'ACCOUNT_CREDIT_INCOMPLETE',
  AwaitingSignature = 'AWAITING_SIGNATURE',
  CreatingAccountCredit = 'CREATING_ACCOUNT_CREDIT',
  MakeLoanQuotation = 'MAKE_LOAN_QUOTATION',
  PreparingForLoanQuotation = 'PREPARING_FOR_LOAN_QUOTATION',
  SigningInProgress = 'SIGNING_IN_PROGRESS',
  Started = 'STARTED'
}

export type ApplyForAccountCreditInput = {
  appliedWithCampaign?: InputMaybe<AccountCreditCampaign>;
  channel: Scalars['String'];
  email: Scalars['String'];
  employmentLength: Scalars['Int'];
  kalp: KalpData;
  phoneNumber: Scalars['String'];
  trackingId?: InputMaybe<Scalars['String']>;
};

export type ApplyForBasicAccountCreditInput = {
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type ApplySubscriptionBasicPlanSuccess = {
  __typename?: 'ApplySubscriptionBasicPlanSuccess';
  subscriptionId: Scalars['String'];
};

export type ApplySubscriptionPlanFail = {
  __typename?: 'ApplySubscriptionPlanFail';
  /** The http status code */
  code: Scalars['String'];
};

export type ApplySubscriptionPlanResponse = ApplySubscriptionBasicPlanSuccess | ApplySubscriptionPlanFail | ApplySubscriptionPlanSuccess;

export type ApplySubscriptionPlanSuccess = {
  __typename?: 'ApplySubscriptionPlanSuccess';
  appStartInfo: AppStartInfo;
  /** The UUID used to query for the signature status, see 'subscriptionSignatureStatus' query. */
  signatureId: Scalars['String'];
};

export type ApplySubscriptionPlanV3Fail = {
  __typename?: 'ApplySubscriptionPlanV3Fail';
  /** The http status code */
  code: Scalars['String'];
};

export type ApplySubscriptionPlanV3Response = ApplySubscriptionPlanV3Fail | ApplySubscriptionPlanV3Success;

export type ApplySubscriptionPlanV3Success = {
  __typename?: 'ApplySubscriptionPlanV3Success';
  appStartInfo: AppStartInfo;
  /** The UUID used to query for the signature status, see 'subscriptionSignatureStatus' query. */
  signatureId: Scalars['String'];
};

export type ArchiveGroupResponse = {
  __typename?: 'ArchiveGroupResponse';
  success: Scalars['Boolean'];
};

export enum AuthLaunchType {
  MobileBankId = 'MOBILE_BANK_ID',
  Unavailable = 'UNAVAILABLE'
}

export enum AuthLaunchUsageType {
  App = 'APP',
  Web = 'WEB'
}

export type AuthRequestInput = {
  ipAddress?: InputMaybe<Scalars['String']>;
  usage: AuthRequestUsage;
};

export type AuthRequestUsage = {
  ssn?: InputMaybe<Scalars['String']>;
  usageType: AuthLaunchUsageType;
};

export enum AuthStatus {
  Failure = 'FAILURE',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type AuthZendeskUserResponse = {
  __typename?: 'AuthZendeskUserResponse';
  jwt: Scalars['String'];
};

export type AuthenticateWithGoogleInput = {
  code: Scalars['String'];
};

export type AuthenticateWithGoogleResponse = {
  __typename?: 'AuthenticateWithGoogleResponse';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AutoTopupBankIdSignatureResponse = {
  __typename?: 'AutoTopupBankIdSignatureResponse';
  state: BankIdSignatureState;
};

export type AutoTopupRule = {
  __typename?: 'AutoTopupRule';
  /**
   * This is an array with at least 1 element that shows where the user should topup from.
   * If the array contains multiple elements, the first one is the highest prority (first to
   * topup money from).
   */
  sources: Array<AutoTopupSource>;
  /** This is the threshold where we automatically topup the user */
  threshold: MonetaryAmount;
  /** This is how much to topup the account with. */
  topupAmount: MonetaryAmount;
};

export type AutoTopupRuleInput = {
  /**
   * This is an array with at least 1 element that shows where the user should topup from.
   * If the array contains multiple elements, the first one is the highest prority (first to
   * topup money from).
   */
  sources: Array<AutoTopupSource>;
  /** This is the threshold where we automatically topup the user */
  threshold: MonetaryAmountInput;
  /** This is how much to topup the account with. */
  topupAmount: MonetaryAmountInput;
};

export enum AutoTopupSource {
  Extra = 'EXTRA',
  Savings = 'SAVINGS'
}

export type AutoTopupStatus = {
  __typename?: 'AutoTopupStatus';
  /** `true` if and only if auto topup is active, `false` otherwise */
  active: Scalars['Boolean'];
  /**
   * The rule that decides how we should auto-topup the user.
   * If this is `null` that means that the user has never used auto-topup before.
   */
  rule?: Maybe<AutoTopupRule>;
};

export type Available = {
  __typename?: 'Available';
  currency: Currency;
  value: Scalars['Int'];
};

export type Balance = {
  __typename?: 'Balance';
  currency: Currency;
  value: Scalars['Int'];
};

export type BankAccountDetails = {
  __typename?: 'BankAccountDetails';
  accountNumber?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  financialInstitutionId?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
};

export enum BankIdSignatureState {
  Failed = 'FAILED',
  Signed = 'SIGNED',
  WaitingForSignature = 'WAITING_FOR_SIGNATURE'
}

export type BankIdSigningInfo = {
  __typename?: 'BankIdSigningInfo';
  appStartInfo: AppStartInfo;
  id: Scalars['String'];
};

export enum BlocketPaymentResponseType {
  Failed = 'Failed',
  PaymentCompleted = 'PaymentCompleted',
  PaymentPending = 'PaymentPending',
  TokenCreated = 'TokenCreated'
}

export enum BlocketPaymentType {
  FullAmount = 'FullAmount',
  InvoiceAmount = 'InvoiceAmount'
}

export type BlocketProduct = {
  __typename?: 'BlocketProduct';
  adminFee: MonetaryAmount;
  fundingOrganization?: Maybe<FundingOrganization>;
  hasUnseen: Scalars['Boolean'];
  /** The image of the product as a URL, e.g. "https://checkout-cdn.bynk.se/1f6dc44b-5372-41e9-a217-bb6d0a9854ae/cover.jpg". */
  image: Scalars['String'];
  /** Interest as a decimal, e.g. 0.07 */
  interest: Scalars['Float'];
  invoices: Array<Invoice>;
  isPartialPaymentPossible: Scalars['Boolean'];
  numberOfMonths: Scalars['Int'];
  purchase: Purchase;
  rockerProduct: RockerProduct;
  setupFee: MonetaryAmount;
  title: Scalars['String'];
  totalDebt: TransactionAmount;
  type?: Maybe<Scalars['String']>;
};

export type BlocketProductsAction = {
  __typename?: 'BlocketProductsAction';
  engagements: Array<BlocketProduct>;
};

export type BudgetCredit = {
  __typename?: 'BudgetCredit';
  adults: Scalars['Int'];
  children: Scalars['Int'];
  employmentLength?: Maybe<EmploymentLength>;
  employmentType?: Maybe<EmploymentType>;
  housingType?: Maybe<HousingType>;
  income: Amount;
  renegotiateLoansAmount?: Maybe<Amount>;
  totalHouseholdCost?: Maybe<Amount>;
};

export type BudgetFilter = {
  __typename?: 'BudgetFilter';
  accounts?: Maybe<Array<Scalars['String']>>;
  categories?: Maybe<Array<Scalars['String']>>;
  freeTextQuery?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type BudgetRequestInput = {
  amount: Scalars['Int'];
  startingDay: Scalars['Int'];
};

export type BudgetSpecification = {
  __typename?: 'BudgetSpecification';
  amount: MonetaryAmount;
  archived: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  periodicity?: Maybe<Periodicity>;
  reserveUpcomingRecurringCosts: Scalars['Boolean'];
};

export type BudgetSuggestion = {
  __typename?: 'BudgetSuggestion';
  amount: MonetaryAmount;
};

export type BudgetV3Data = {
  __typename?: 'BudgetV3Data';
  budgetedAmount: MonetaryAmount;
  spentPerDay: MonetaryAmount;
  spentToday: MonetaryAmount;
  suggestedDailyBudget: MonetaryAmount;
  totalSpent: MonetaryAmount;
};

export type BudgetV3Input = {
  day: Scalars['String'];
};

export type BudgetV3Response = {
  __typename?: 'BudgetV3Response';
  budgetSettings?: Maybe<BudgetV3Settings>;
  budgetSuggestion?: Maybe<MonetaryAmount>;
  combined?: Maybe<BudgetV3Data>;
  id: Scalars['String'];
  nonRecurring?: Maybe<BudgetV3Data>;
  recurring?: Maybe<BudgetV3Data>;
};

export type BudgetV3Settings = {
  __typename?: 'BudgetV3Settings';
  reserveUpcomingRecurringCosts: Scalars['Boolean'];
};

export type CanApplyForAccountCredit = {
  __typename?: 'CanApplyForAccountCredit';
  qualified: Scalars['Boolean'];
};

export type CancelApplicationResponse = {
  __typename?: 'CancelApplicationResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Card = {
  accountId: Scalars['String'];
  cardRenewalStatus?: Maybe<CardRenewalStatus>;
  customerId: Scalars['String'];
  digitalLayout: CardDigitalLayout;
  expiration?: Maybe<CardExpiration>;
  id: Scalars['String'];
  maskedCardNumber: Scalars['String'];
  /** The model of the card, e.g. "Blue", "Black", or "Biometric". */
  model: CardModel;
  regionAndEcommBlocking: RegionsAndEcomm;
  status: CardStatus;
};

export type CardAvailabilityResponse = {
  __typename?: 'CardAvailabilityResponse';
  biometric: Scalars['Boolean'];
  physical: Scalars['Boolean'];
};

export enum CardDigitalLayout {
  Default = 'DEFAULT',
  Premium = 'PREMIUM'
}

export type CardExpiration = {
  __typename?: 'CardExpiration';
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type CardFeatureFlags = {
  __typename?: 'CardFeatureFlags';
  beta?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Boolean']>;
  card?: Maybe<Scalars['Boolean']>;
  powerUser?: Maybe<Scalars['Boolean']>;
  revolvingCredit?: Maybe<Scalars['Boolean']>;
  splitBill?: Maybe<Scalars['Boolean']>;
  travelInsurance?: Maybe<Scalars['Boolean']>;
  /** `true` if the user should be visible as a Rocker contact, false otherwise. */
  visible: Scalars['Boolean'];
};

export type CardForWalletExtension = {
  __typename?: 'CardForWalletExtension';
  accountId: Scalars['String'];
  cardHolderName: Scalars['String'];
  cardType: CardTypeWallet;
  id: Scalars['String'];
  suffix: Scalars['String'];
};

export type CardKycAnswersResponse = {
  __typename?: 'CardKycAnswersResponse';
  estimatedMonthlyDepositRange?: Maybe<EstimatedMonthlyDepositRange>;
  gamblingInfo?: Maybe<GamblingInfo>;
  otherCitizenships?: Maybe<Array<Scalars['String']>>;
  reasonsForUsingCard?: Maybe<Array<CardUsageReason>>;
  sourcesOfFunds?: Maybe<Array<FundsSource>>;
};

export type CardKycAnswersResponseV2 = {
  __typename?: 'CardKycAnswersResponseV2';
  latestKycSubmission: KycSubmission;
  needsToUpdateKyc: Scalars['Boolean'];
};

export type CardKycAnswersV2 = {
  __typename?: 'CardKycAnswersV2';
  estimatedMonthlyDepositRange?: Maybe<EstimatedMonthlyDepositRangeV2>;
  gamblingInfo?: Maybe<GamblingInfo>;
  otherCitizenships?: Maybe<Array<Scalars['String']>>;
  reasonsForUsingCard?: Maybe<Array<CardUsageReason>>;
  sourcesOfFunds?: Maybe<Array<FundsSource>>;
};

export enum CardModel {
  Biometric = 'BIOMETRIC',
  Physical = 'PHYSICAL',
  Unknown = 'UNKNOWN',
  Virtual = 'VIRTUAL'
}

export type CardMutationResponse = {
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum CardOnboardingStatus {
  Completed = 'COMPLETED',
  CustomerIsPep = 'CUSTOMER_IS_PEP',
  Pending = 'PENDING',
  Started = 'STARTED'
}

export type CardOnboardingStatusResponse = {
  __typename?: 'CardOnboardingStatusResponse';
  created: Scalars['String'];
  onboardingId: Scalars['String'];
  status: CardOnboardingStatus;
};

export type CardPan = {
  __typename?: 'CardPan';
  /** The URL to get the card PAN data. */
  cardDataUrl: Scalars['String'];
  /** The token to use for the cardDataUrl. */
  token: Scalars['String'];
};

export type CardPinEncryptionData = {
  __typename?: 'CardPinEncryptionData';
  controlId: Scalars['String'];
  encryptionKey: Scalars['String'];
};

export enum CardRenewalStatus {
  DoNotRenew = 'DO_NOT_RENEW',
  Renew = 'RENEW'
}

export enum CardStatus {
  /**
   * The card has been blocked by the user or by CST. A card in this state can be
   * unblocked by the user at any time.
   */
  Blocked = 'BLOCKED',
  /** The card is permanently closed from being used. */
  Closed = 'CLOSED',
  /** The card has expired. */
  Expired = 'EXPIRED',
  /**
   * The card has been temporarily locked. A card in this state should be treated
   * the same as blocked, but can not be unblocked by the user.
   */
  Locked = 'LOCKED',
  /** The card was reported lost by the customer. */
  Lost = 'LOST',
  /** The card is OK */
  Ok = 'OK',
  /** The card was reported stolen by the customer. */
  Stolen = 'STOLEN'
}

export type CardTransaction = {
  __typename?: 'CardTransaction';
  amount: TransactionAmount;
  merchant: CardTransactionMerchant;
  merchantAmount: CardTransactionMerchantAmount;
  metadata?: Maybe<Scalars['Metadata']>;
  timestamp: Scalars['String'];
  transactionId: Scalars['String'];
  transactionType: CardTransactionType;
};

export type CardTransactionMerchant = {
  __typename?: 'CardTransactionMerchant';
  category: CardTransactionMerchantCategory;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CardTransactionMerchantAmount = {
  __typename?: 'CardTransactionMerchantAmount';
  currency: Scalars['String'];
  value: Scalars['Int'];
};

export type CardTransactionMerchantCategory = {
  __typename?: 'CardTransactionMerchantCategory';
  mcc?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type CardTransactionMerchantCategoryInput = {
  mcc?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type CardTransactionMerchantInput = {
  category?: InputMaybe<CardTransactionMerchantCategoryInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export enum CardTransactionType {
  Auth = 'AUTH',
  Capture = 'CAPTURE'
}

export type CardTransactions = {
  __typename?: 'CardTransactions';
  page: Scalars['Int'];
  transactions: Array<Maybe<CardTransaction>>;
};

export enum CardType {
  Physical = 'PHYSICAL',
  Virtual = 'VIRTUAL'
}

export enum CardTypeWallet {
  Biometric = 'BIOMETRIC',
  Physical = 'PHYSICAL',
  Virtual = 'VIRTUAL'
}

export enum CardUsageReason {
  DailyPurchases = 'DAILY_PURCHASES',
  ExtraCard = 'EXTRA_CARD',
  ExtraCardForCertainPurchases = 'EXTRA_CARD_FOR_CERTAIN_PURCHASES',
  UseRockerExtra = 'USE_ROCKER_EXTRA',
  UseRockerSavings = 'USE_ROCKER_SAVINGS'
}

export enum CardWithdrawalStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  PayingOut = 'PAYING_OUT',
  SelectingAccount = 'SELECTING_ACCOUNT'
}

export type CardWithdrawalStatusResponse = {
  __typename?: 'CardWithdrawalStatusResponse';
  amount: MonetaryAmount;
  foreignAccountId: Scalars['String'];
  id: Scalars['String'];
  nationalIdNumber: NationalIdNumber;
  payload: TruslyPayload;
  status: CardWithdrawalStatus;
};

export type Cashback = {
  __typename?: 'Cashback';
  amountToBePaidOut: MoneyMinor;
  maxAmountPerMonth: MoneyMinor;
  maxAmountPerPeriod: MoneyMinor;
  maxPercentage: Scalars['Float'];
  percentage: Scalars['Float'];
  status: CashbackStatus;
  totalPaidOut: MoneyMinor;
};

export type CashbackFail = {
  __typename?: 'CashbackFail';
  reason: CashbackFailReason;
};

export enum CashbackFailReason {
  NoCard = 'NO_CARD',
  Other = 'OTHER'
}

export type CashbackReferralV2 = {
  __typename?: 'CashbackReferralV2';
  pendingReferralsCount: Scalars['Int'];
  referralLink: Scalars['String'];
  referralProgress?: Maybe<ReferralProgress>;
  referredCount: Scalars['Int'];
  rewardsEarnedThroughReferrals: RewardsEarnedThroughReferrals;
};

export type CashbackResponse = Cashback | CashbackFail;

export enum CashbackStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type CashbackV3Response = {
  __typename?: 'CashbackV3Response';
  amountToBePaidOut: Array<MonthlyAmount>;
  maxAmountPerMonth: MonetaryAmount;
  maxPercentage: Scalars['String'];
  percentage: Scalars['String'];
  status: CashbackStatus;
  totalPaidOut: MonetaryAmount;
};

export type Categorization = {
  categoryId: Scalars['String'];
  transactionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CategorizeTransactionsInput = {
  categorizationList: Array<Categorization>;
};

export type CategorizeTransactionsResponse = {
  __typename?: 'CategorizeTransactionsResponse';
  success: Scalars['Boolean'];
};

export type CategorySum = {
  __typename?: 'CategorySum';
  categoryId?: Maybe<Scalars['String']>;
  numberOfTransactions?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['Float']>;
  sum?: Maybe<Sum>;
};

export enum CategoryType {
  Expenses = 'EXPENSES',
  Income = 'INCOME',
  Transfers = 'TRANSFERS'
}

export type ChangeMonthlyPayLoanDetails = MutationResponse & {
  __typename?: 'ChangeMonthlyPayLoanDetails';
  administrationFee: Scalars['Float'];
  amortizationPeriod: Scalars['Int'];
  amount: Scalars['Float'];
  code: Scalars['String'];
  effectiveInterestRate: Scalars['Float'];
  monthlyPay: Scalars['Float'];
  nominalInterestRate: Scalars['Float'];
  payplans?: Maybe<Array<Scalars['String']>>;
  setupFee: Scalars['Float'];
  success: Scalars['Boolean'];
  totalToPay: Scalars['Float'];
};

export type CheckEmailVerifiedResponse = {
  __typename?: 'CheckEmailVerifiedResponse';
  isVerified: Scalars['Boolean'];
};

export enum Children {
  FiveChildren = 'FiveChildren',
  FourChildren = 'FourChildren',
  NoChildren = 'NoChildren',
  OneChild = 'OneChild',
  SixOrMore = 'SixOrMore',
  ThreeChildren = 'ThreeChildren',
  TwoChildren = 'TwoChildren'
}

export enum ChronoUnit {
  Months = 'MONTHS',
  Years = 'YEARS'
}

export type ChronoUnitField = {
  __typename?: 'ChronoUnitField';
  name: ChronoUnit;
};

export type ChronoUnitInput = {
  name: ChronoUnit;
};

export type CoApplicant = {
  __typename?: 'CoApplicant';
  CoApplicant: CoApplicantData;
};

export type CoApplicantApplicationData = {
  __typename?: 'CoApplicantApplicationData';
  accommodation: Accommodation;
  contactDetails: ContactDetails;
  /** SSN of the co-applicant */
  nin: Scalars['String'];
  occupation: Occupation;
  personalDetails: PersonalDetails;
};

export type CoApplicantData = {
  __typename?: 'CoApplicantData';
  complements?: Maybe<Array<Message>>;
  message: Scalars['String'];
};

export type CoApplicantDataInput = {
  accommodation: AccommodationInput;
  contactDetails: ContactDetailsInput;
  /** SSN of the co-applicant */
  nin: Scalars['String'];
  occupation: OccupationInput;
  personalDetails: PersonalDetailsInput;
};

export type CommonTransaction = {
  __typename?: 'CommonTransaction';
  categoryId: Scalars['String'];
  count: Scalars['Int'];
  description: Scalars['String'];
  sum: MoneyMinor;
  transactions?: Maybe<Array<MinimumTransaction>>;
};

export type CommonTransactionsInput = {
  accountIds: Array<Scalars['String']>;
  categories: Array<Scalars['String']>;
  from: Scalars['String'];
  limit: Scalars['Int'];
  query: Scalars['String'];
  until: Scalars['String'];
  whereAppearsAtLeast: Scalars['Int'];
};

export type CompareResult = {
  __typename?: 'CompareResult';
  averageValue: Scalars['Float'];
  period: Scalars['String'];
  resolution: StatisticsResolution;
  statisticsDataId: Scalars['String'];
  userValue: Scalars['Float'];
};

export type Comparison = {
  __typename?: 'Comparison';
  endDateIncl: Scalars['String'];
  money: MoneyMinor;
  period: Scalars['String'];
  startDateIncl: Scalars['String'];
};

export type ComparisonsInput = {
  periodFilter: PeriodFilter;
  queryType: StatisticsType;
  resolution: StatisticsResolution;
};

export type Complements = {
  __typename?: 'Complements';
  Complements: ComplementsData;
};

export type ComplementsData = {
  __typename?: 'ComplementsData';
  values?: Maybe<Array<Message>>;
};

export type ConsentReviewResponse = {
  __typename?: 'ConsentReviewResponse';
  code: Scalars['String'];
  id: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ConsentReviewV2 = {
  __typename?: 'ConsentReviewV2';
  body: Scalars['String'];
  id: Scalars['String'];
  review: ReviewResponse;
  type: ConsentType;
};

export type ConsentToRockerContact = {
  __typename?: 'ConsentToRockerContact';
  isVisible: Scalars['Boolean'];
};

export type ConsentToRockerContactInput = {
  isVisible: Scalars['Boolean'];
};

export enum ConsentType {
  Connect = 'CONNECT',
  ConnectMarketing = 'CONNECT_MARKETING',
  Subscription = 'SUBSCRIPTION',
  Unknown = 'UNKNOWN'
}

export type Consolidate = {
  __typename?: 'Consolidate';
  ofTotalToConsolidate: MoneyMinor;
};

export type ConsolidateDebts = {
  __typename?: 'ConsolidateDebts';
  ConsolidateDebts: ConsolidateDebtsData;
};

export type ConsolidateDebtsData = {
  __typename?: 'ConsolidateDebtsData';
  amount: CurrencyAmount;
};

export type ConsolidateInput = {
  ofTotalToConsolidate: MoneyMinorInput;
};

export type Contact = {
  __typename?: 'Contact';
  phoneNumber?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type ContactDetails = {
  __typename?: 'ContactDetails';
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type ContactDetailsInput = {
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type ContactInformation = {
  __typename?: 'ContactInformation';
  email: Scalars['String'];
  phone: Phone;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type CostShare = {
  __typename?: 'CostShare';
  amount: MonetaryAmount;
  participantId: Scalars['String'];
};

export type CostShareInput = {
  amount: MonetaryAmountInput;
  participantId: Scalars['String'];
};

export enum Country {
  Abw = 'ABW',
  Afg = 'AFG',
  Ago = 'AGO',
  Aia = 'AIA',
  Ala = 'ALA',
  Alb = 'ALB',
  And = 'AND',
  Are = 'ARE',
  Arg = 'ARG',
  Arm = 'ARM',
  Asm = 'ASM',
  Ata = 'ATA',
  Atf = 'ATF',
  Atg = 'ATG',
  Aus = 'AUS',
  Aut = 'AUT',
  Aze = 'AZE',
  Bdi = 'BDI',
  Bel = 'BEL',
  Ben = 'BEN',
  Bes = 'BES',
  Bfa = 'BFA',
  Bgd = 'BGD',
  Bgr = 'BGR',
  Bhr = 'BHR',
  Bhs = 'BHS',
  Bih = 'BIH',
  Blm = 'BLM',
  Blr = 'BLR',
  Blz = 'BLZ',
  Bmu = 'BMU',
  Bol = 'BOL',
  Bra = 'BRA',
  Brb = 'BRB',
  Brn = 'BRN',
  Btn = 'BTN',
  Bvt = 'BVT',
  Bwa = 'BWA',
  Caf = 'CAF',
  Can = 'CAN',
  Cck = 'CCK',
  Che = 'CHE',
  Chl = 'CHL',
  Chn = 'CHN',
  Civ = 'CIV',
  Cmr = 'CMR',
  Cod = 'COD',
  Cog = 'COG',
  Cok = 'COK',
  Col = 'COL',
  Com = 'COM',
  Cpv = 'CPV',
  Cri = 'CRI',
  Cub = 'CUB',
  Cuw = 'CUW',
  Cxr = 'CXR',
  Cym = 'CYM',
  Cyp = 'CYP',
  Cze = 'CZE',
  Deu = 'DEU',
  Dji = 'DJI',
  Dma = 'DMA',
  Dnk = 'DNK',
  Dom = 'DOM',
  Dza = 'DZA',
  Ecu = 'ECU',
  Egy = 'EGY',
  Eri = 'ERI',
  Esh = 'ESH',
  Esp = 'ESP',
  Est = 'EST',
  Eth = 'ETH',
  Fin = 'FIN',
  Fji = 'FJI',
  Flk = 'FLK',
  Fra = 'FRA',
  Fro = 'FRO',
  Fsm = 'FSM',
  Gab = 'GAB',
  Gbr = 'GBR',
  Geo = 'GEO',
  Ggy = 'GGY',
  Gha = 'GHA',
  Gib = 'GIB',
  Gin = 'GIN',
  Glp = 'GLP',
  Gmb = 'GMB',
  Gnb = 'GNB',
  Gnq = 'GNQ',
  Grc = 'GRC',
  Grd = 'GRD',
  Grl = 'GRL',
  Gtm = 'GTM',
  Guf = 'GUF',
  Gum = 'GUM',
  Guy = 'GUY',
  Hkg = 'HKG',
  Hmd = 'HMD',
  Hnd = 'HND',
  Hrv = 'HRV',
  Hti = 'HTI',
  Hun = 'HUN',
  Idn = 'IDN',
  Imn = 'IMN',
  Ind = 'IND',
  Iot = 'IOT',
  Irl = 'IRL',
  Irn = 'IRN',
  Irq = 'IRQ',
  Isl = 'ISL',
  Isr = 'ISR',
  Ita = 'ITA',
  Jam = 'JAM',
  Jey = 'JEY',
  Jor = 'JOR',
  Jpn = 'JPN',
  Kaz = 'KAZ',
  Ken = 'KEN',
  Kgz = 'KGZ',
  Khm = 'KHM',
  Kir = 'KIR',
  Kna = 'KNA',
  Kor = 'KOR',
  Kwt = 'KWT',
  Lao = 'LAO',
  Lbn = 'LBN',
  Lbr = 'LBR',
  Lby = 'LBY',
  Lca = 'LCA',
  Lie = 'LIE',
  Lka = 'LKA',
  Lso = 'LSO',
  Ltu = 'LTU',
  Lux = 'LUX',
  Lva = 'LVA',
  Mac = 'MAC',
  Maf = 'MAF',
  Mar = 'MAR',
  Mco = 'MCO',
  Mda = 'MDA',
  Mdg = 'MDG',
  Mdv = 'MDV',
  Mex = 'MEX',
  Mhl = 'MHL',
  Mkd = 'MKD',
  Mli = 'MLI',
  Mlt = 'MLT',
  Mmr = 'MMR',
  Mne = 'MNE',
  Mng = 'MNG',
  Mnp = 'MNP',
  Moz = 'MOZ',
  Mrt = 'MRT',
  Msr = 'MSR',
  Mtq = 'MTQ',
  Mus = 'MUS',
  Mwi = 'MWI',
  Mys = 'MYS',
  Myt = 'MYT',
  Nam = 'NAM',
  Ncl = 'NCL',
  Ner = 'NER',
  Nfk = 'NFK',
  Nga = 'NGA',
  Nic = 'NIC',
  Niu = 'NIU',
  Nld = 'NLD',
  Nor = 'NOR',
  Npl = 'NPL',
  Nru = 'NRU',
  Nzl = 'NZL',
  Omn = 'OMN',
  Pak = 'PAK',
  Pan = 'PAN',
  Pcn = 'PCN',
  Per = 'PER',
  Phl = 'PHL',
  Plw = 'PLW',
  Png = 'PNG',
  Pol = 'POL',
  Pri = 'PRI',
  Prk = 'PRK',
  Prt = 'PRT',
  Pry = 'PRY',
  Pse = 'PSE',
  Pyf = 'PYF',
  Qat = 'QAT',
  Reu = 'REU',
  Rou = 'ROU',
  Rus = 'RUS',
  Rwa = 'RWA',
  Sau = 'SAU',
  Sdn = 'SDN',
  Sen = 'SEN',
  Sgp = 'SGP',
  Sgs = 'SGS',
  Shn = 'SHN',
  Sjm = 'SJM',
  Slb = 'SLB',
  Sle = 'SLE',
  Slv = 'SLV',
  Smr = 'SMR',
  Som = 'SOM',
  Spm = 'SPM',
  Srb = 'SRB',
  Ssd = 'SSD',
  Stp = 'STP',
  Sur = 'SUR',
  Svk = 'SVK',
  Svn = 'SVN',
  Swe = 'SWE',
  Swz = 'SWZ',
  Sxm = 'SXM',
  Syc = 'SYC',
  Syr = 'SYR',
  Tca = 'TCA',
  Tcd = 'TCD',
  Tgo = 'TGO',
  Tha = 'THA',
  Tjk = 'TJK',
  Tkl = 'TKL',
  Tkm = 'TKM',
  Tls = 'TLS',
  Ton = 'TON',
  Tto = 'TTO',
  Tun = 'TUN',
  Tur = 'TUR',
  Tuv = 'TUV',
  Twn = 'TWN',
  Tza = 'TZA',
  Uga = 'UGA',
  Ukr = 'UKR',
  Umi = 'UMI',
  Ury = 'URY',
  Usa = 'USA',
  Uzb = 'UZB',
  Vat = 'VAT',
  Vct = 'VCT',
  Ven = 'VEN',
  Vgb = 'VGB',
  Vir = 'VIR',
  Vnm = 'VNM',
  Vut = 'VUT',
  Wlf = 'WLF',
  Wsm = 'WSM',
  Yem = 'YEM',
  Zaf = 'ZAF',
  Zmb = 'ZMB',
  Zwe = 'ZWE'
}

export type CreateFirebasePushIdentifierAction = {
  __typename?: 'CreateFirebasePushIdentifierAction';
  firebasePushIdentifiers?: Maybe<FirebaseIdentifier>;
  result?: Maybe<Scalars['String']>;
};

export type CreateFirebasePushIdentifierRequest = GatewayResponse & {
  __typename?: 'CreateFirebasePushIdentifierRequest';
  created?: Maybe<Scalars['String']>;
  msgType?: Maybe<Scalars['String']>;
  partition?: Maybe<Scalars['Int']>;
  payload?: Maybe<CreateFirebasePushIdentifierAction>;
  requestId?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type CreateGroupInvitation = {
  __typename?: 'CreateGroupInvitation';
  invitationId: Scalars['String'];
  phone: Scalars['String'];
  resultStatus: CreateGroupInvitationStatus;
};

export type CreateGroupInvitationResponse = {
  __typename?: 'CreateGroupInvitationResponse';
  invitations: Array<CreateGroupInvitation>;
};

export enum CreateGroupInvitationStatus {
  AlreadyInvited = 'ALREADY_INVITED',
  Invited = 'INVITED'
}

export type CreateGroupResponse = {
  __typename?: 'CreateGroupResponse';
  groupId: Scalars['String'];
};

export type CreateImageReceiptInput = {
  image: Scalars['String'];
  tinkTxId: Scalars['String'];
};

export type CreateImageReceiptV2Response = {
  __typename?: 'CreateImageReceiptV2Response';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CreateInvitationRequestInput = {
  invitations: Array<InvitationInput>;
};

export type CreateNewApplicationResponse = {
  __typename?: 'CreateNewApplicationResponse';
  applicationId: Scalars['String'];
  mayApply: Scalars['Boolean'];
};

export type CreateSplitPaymentGroupRequestV4 = {
  message?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  paymentRequests: Array<PaymentRequestGroupToBeCreatedV2>;
  transactions: Array<SplitPaymentTransactionInputV4>;
};

export type CreateSplitPaymentGroupResponseV3 = {
  __typename?: 'CreateSplitPaymentGroupResponseV3';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CreateSystemTagInput = {
  tags: Array<Scalars['String']>;
  transactionId: Scalars['String'];
};

export type CreateSystemTagResponse = {
  __typename?: 'CreateSystemTagResponse';
  success: Scalars['Boolean'];
};

export enum CredentialStatus {
  Authenticating = 'AUTHENTICATING',
  AuthenticationError = 'AUTHENTICATION_ERROR',
  AwaitingMobileBankidAuthentication = 'AWAITING_MOBILE_BANKID_AUTHENTICATION',
  AwaitingSupplementalInformation = 'AWAITING_SUPPLEMENTAL_INFORMATION',
  AwaitingThirdPartyAppAuthentication = 'AWAITING_THIRD_PARTY_APP_AUTHENTICATION',
  Created = 'CREATED',
  Deleted = 'DELETED',
  PermanentError = 'PERMANENT_ERROR',
  SessionExpired = 'SESSION_EXPIRED',
  TemporaryError = 'TEMPORARY_ERROR',
  Updated = 'UPDATED',
  Updating = 'UPDATING'
}

export enum CredentialType {
  Keyfob = 'KEYFOB',
  MobileBankid = 'MOBILE_BANKID',
  Password = 'PASSWORD',
  ThirdPartyApp = 'THIRD_PARTY_APP'
}

export enum CreditDirectDebitAccountStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Idle = 'IDLE',
  InProgress = 'IN_PROGRESS',
  WaitingForSignature = 'WAITING_FOR_SIGNATURE'
}

export type CreditDirectDebitAccountStatusResponse = {
  __typename?: 'CreditDirectDebitAccountStatusResponse';
  status: CreditDirectDebitAccountStatus;
};

export type CreditLimit = {
  __typename?: 'CreditLimit';
  amount: Scalars['Float'];
  currency: Scalars['String'];
};

export type CreditSpaceApplication = {
  __typename?: 'CreditSpaceApplication';
  address?: Maybe<Address>;
  amortizationPeriod: Scalars['Int'];
  appliedAmount: Amount;
  availableEngagementLimit?: Maybe<Scalars['String']>;
  bankAccount?: Maybe<Scalars['String']>;
  budget?: Maybe<BudgetCredit>;
  contactInformation?: Maybe<ContactInformation>;
  customerName?: Maybe<CustomerName>;
  employer?: Maybe<Scalars['String']>;
  fundingOrganization?: Maybe<FundingOrganization>;
  id: Scalars['String'];
  loanDetails?: Maybe<LoanDetails>;
  signedAt?: Maybe<Scalars['String']>;
  state?: Maybe<CreditSpaceState>;
  validThrough: Scalars['String'];
};

export type CreditSpaceApplicationInput = {
  email: Scalars['String'];
  employer?: InputMaybe<Scalars['String']>;
  employmentLength: Scalars['Int'];
  isLaidOff?: InputMaybe<Scalars['Boolean']>;
  kalp: KalpData;
  phoneNumber: Scalars['String'];
};

export enum CreditSpaceApplicationSigningStatus {
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Signed = 'SIGNED'
}

export type CreditSpaceApplicationSigningStatusResponse = {
  __typename?: 'CreditSpaceApplicationSigningStatusResponse';
  status: CreditSpaceApplicationSigningStatus;
};

export enum CreditSpaceState {
  Accepted = 'ACCEPTED',
  Created = 'CREATED',
  Denied = 'DENIED',
  LoanCreated = 'LOAN_CREATED',
  PreparingForLoanQuotation = 'PREPARING_FOR_LOAN_QUOTATION',
  PreparingLoanQuotation = 'PREPARING_LOAN_QUOTATION',
  Unknown = 'UNKNOWN',
  WaitingForQuotationResponse = 'WAITING_FOR_QUOTATION_RESPONSE'
}

export enum Currency {
  Eur = 'EUR',
  Sek = 'SEK'
}

export type CurrencyAmount = {
  __typename?: 'CurrencyAmount';
  amount: Scalars['Int'];
  currency: Scalars['String'];
};

export type CurrencyAmountInput = {
  amount: Scalars['Int'];
  currency: Scalars['String'];
};

export type CurrencyDenominatedAmount = {
  __typename?: 'CurrencyDenominatedAmount';
  amount: Scalars['Float'];
  currency: Scalars['String'];
  unit: Scalars['String'];
};

export type CurrencyDenominatedAmountInput = {
  amount: Scalars['Int'];
  currency: Scalars['String'];
  unit: Scalars['String'];
};

export type CustomClaims = {
  __typename?: 'CustomClaims';
  marketCountry?: Maybe<Scalars['String']>;
  user: UserClaims;
};

export type CustomerData = {
  __typename?: 'CustomerData';
  bynkPoints: Scalars['Int'];
  bynkScore?: Maybe<Scalars['Int']>;
  canTakeTopup: Scalars['Boolean'];
  currentBankgiro?: Maybe<Scalars['String']>;
  currentOcr?: Maybe<Scalars['String']>;
  disabled: DisabledFeatures;
  hasLoanHistory?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  inquiries?: Maybe<Inquiries>;
  invoices?: Maybe<Array<Invoice>>;
  latestIncome?: Maybe<LatestIncome>;
  lights?: Maybe<Lights>;
  loan?: Maybe<LoanData>;
  loanProtection?: Maybe<LoanProtection>;
  memberId?: Maybe<Scalars['String']>;
  monthlyFee?: Maybe<Scalars['Int']>;
  monthlyPayOptions?: Maybe<Array<MonthlyPayOption>>;
  payfreeMonth?: Maybe<PayfreeMonthData>;
  pointsToAmortization?: Maybe<Array<Scalars['Any']>>;
  reminderFee?: Maybe<Scalars['Int']>;
  terms?: Maybe<Scalars['Int']>;
  transactions?: Maybe<Array<Transaction>>;
  ucReport?: Maybe<UcReport>;
};

export type CustomerInfo = {
  __typename?: 'CustomerInfo';
  emailAddress?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
};

export type CustomerInvoicesResponse = {
  __typename?: 'CustomerInvoicesResponse';
  invoices: Array<Invoice>;
};

export type CustomerName = {
  __typename?: 'CustomerName';
  firstNames?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
};

export type DebtBalance = {
  __typename?: 'DebtBalance';
  debtType: DebtType;
  money: DebtBalanceAmount;
};

export type DebtBalanceAmount = {
  __typename?: 'DebtBalanceAmount';
  amount: Scalars['Int'];
  currency: Scalars['String'];
  unit: Scalars['String'];
};

export type DebtBalanceAmountInput = {
  amount: Scalars['Int'];
  currency: Scalars['String'];
  unit: Scalars['String'];
};

export type DebtSummary = {
  __typename?: 'DebtSummary';
  money: DebtBalanceAmount;
  nextReminderCanBeSentAt?: Maybe<Scalars['String']>;
  participantId: Scalars['String'];
};

export enum DebtType {
  IsOwed = 'IS_OWED',
  OwesOthers = 'OWES_OTHERS'
}

/** Describes a deep link attached to this notification. */
export type DeepLinkNotificationAttachment = {
  __typename?: 'DeepLinkNotificationAttachment';
  /** For example, 'rockerapp://transaction/details?transactionId=abc-123&entityId=123456&isRockerTransaction=true' */
  link: Scalars['String'];
};

export type DeleteBudgetResponse = {
  __typename?: 'DeleteBudgetResponse';
  success: Scalars['Boolean'];
};

export type DeleteCredentialResponse = CardMutationResponse & {
  __typename?: 'DeleteCredentialResponse';
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DeleteCustomerDataResponse = {
  __typename?: 'DeleteCustomerDataResponse';
  success: Scalars['Boolean'];
};

export type DeleteGroupExpenseResponse = {
  __typename?: 'DeleteGroupExpenseResponse';
  success: Scalars['Boolean'];
};

export type DeleteImageReceiptV2Response = {
  __typename?: 'DeleteImageReceiptV2Response';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type DeleteTransactionReceiptsResponse = {
  __typename?: 'DeleteTransactionReceiptsResponse';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type DeleteTransactionTagResponse = {
  __typename?: 'DeleteTransactionTagResponse';
  success: Scalars['Boolean'];
};

export type Description = {
  __typename?: 'Description';
  display?: Maybe<Scalars['String']>;
  original?: Maybe<Scalars['String']>;
};

export type Detail = {
  __typename?: 'Detail';
  amount: Scalars['Float'];
  t: Scalars['String'];
  text: Scalars['String'];
};

export type DetailedAccessLimited = {
  __typename?: 'DetailedAccessLimited';
  /** Feature code. Eg: rocker-organize.upload-receipt */
  feature: Scalars['String'];
  remainingUsages: RemainingUsages;
  type: DetailedAccessType;
};

export type DetailedAccessMissingAccess = {
  __typename?: 'DetailedAccessMissingAccess';
  /** Feature code. Eg: rocker-organize.upload-receipt */
  feature: Scalars['String'];
  type: DetailedAccessType;
};

export type DetailedAccessOutOfLimits = {
  __typename?: 'DetailedAccessOutOfLimits';
  feature: Scalars['String'];
  noRemainingUsages: OutOfLimitsUsages;
  type: DetailedAccessType;
};

export enum DetailedAccessType {
  Limited = 'LIMITED',
  MissingAccess = 'MISSING_ACCESS',
  OutOfLimits = 'OUT_OF_LIMITS',
  Unlimited = 'UNLIMITED'
}

export type DetailedAccessUnlimited = {
  __typename?: 'DetailedAccessUnlimited';
  endsAt?: Maybe<Scalars['String']>;
  /** Feature code. Eg: rocker-organize.upload-receipt */
  feature: Scalars['String'];
  maxNumber?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
  tier?: Maybe<Scalars['Int']>;
  type: DetailedAccessType;
};

export type DetailedGroupInvitationResponse = {
  __typename?: 'DetailedGroupInvitationResponse';
  groupIcon: Scalars['String'];
  groupId: Scalars['String'];
  groupName: Scalars['String'];
  id: Scalars['String'];
  inviter: Participant;
  status: InvitationStatus;
};

export type DetailedGroupResponse = {
  __typename?: 'DetailedGroupResponse';
  created: Scalars['String'];
  groupIcon: Scalars['String'];
  groupId: Scalars['String'];
  groupName: Scalars['String'];
  groupStatus: GroupStatus;
  latestTransactions: Array<GroupTransaction>;
  myParticipantId: Scalars['String'];
  myTotalExpenseShare: MonetaryAmount;
  participants: Array<ParticipantDetailed>;
  updated: Scalars['String'];
};

export type DetailsAccessDetails = DetailedAccessLimited | DetailedAccessMissingAccess | DetailedAccessOutOfLimits | DetailedAccessUnlimited;

export type DigitizationData = {
  __typename?: 'DigitizationData';
  digitizationData: Scalars['String'];
};

export enum Direction {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type DisableAutotopupResponse = {
  __typename?: 'DisableAutotopupResponse';
  code: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DisabledFeatures = {
  __typename?: 'DisabledFeatures';
  accountcredit: Scalars['Boolean'];
  bynkstore: Scalars['Boolean'];
  loyaltypoints: Scalars['Boolean'];
  swishAccountCredit: Scalars['Boolean'];
};

export type EditExpenseRequestInput = {
  category: Scalars['String'];
  description: Scalars['String'];
  split: SplitInput;
};

export type EditGroupRequestInput = {
  icon: Scalars['String'];
  name: Scalars['String'];
};

export type EditGroupResponse = {
  __typename?: 'EditGroupResponse';
  groupId: Scalars['String'];
};

export type EmailAddress = {
  __typename?: 'EmailAddress';
  value?: Maybe<Scalars['String']>;
};

export type EmailSubscriptionGroup = {
  __typename?: 'EmailSubscriptionGroup';
  channel: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  status: EmailSubscriptionGroupStatus;
};

export type EmailSubscriptionGroupOption = {
  __typename?: 'EmailSubscriptionGroupOption';
  id: Scalars['String'];
  name: EmailSubscriptionGroupOptionName;
};

export enum EmailSubscriptionGroupOptionName {
  AiSummaryMonthlySummary = 'AISummaryMonthlySummary',
  FinanceSummaryMonthlySummary = 'FinanceSummaryMonthlySummary',
  FinanceSummaryWeeklySummary = 'FinanceSummaryWeeklySummary',
  IndexUpdateHealthIndex = 'IndexUpdateHealthIndex',
  IndexUpdateInterestRateIndex = 'IndexUpdateInterestRateIndex'
}

export enum EmailSubscriptionGroupStatus {
  Subscribed = 'Subscribed',
  Uknown = 'Uknown',
  Unsubscribed = 'Unsubscribed'
}

export type EmailSubscriptionResponse = {
  __typename?: 'EmailSubscriptionResponse';
  status: EmailSubscriptionStatus;
};

export enum EmailSubscriptionStatus {
  Subscribed = 'subscribed',
  Unknown = 'unknown',
  Unsubscribed = 'unsubscribed'
}

export enum EmploymentLength {
  LessThanSixMonths = 'LessThanSixMonths',
  MoreThanTwoYears = 'MoreThanTwoYears',
  OneToTwoYears = 'OneToTwoYears',
  SixToTwelveMonths = 'SixToTwelveMonths',
  Unknown = 'Unknown'
}

export enum EmploymentType {
  EarlyPensioner = 'EARLY_PENSIONER',
  Hourly = 'HOURLY',
  Pensioner = 'PENSIONER',
  Permanent = 'PERMANENT',
  SelfEmployed = 'SELF_EMPLOYED',
  Student = 'STUDENT',
  Unemployed = 'UNEMPLOYED',
  Vacancy = 'VACANCY'
}

export type EmptyResponse = GatewayResponse & {
  __typename?: 'EmptyResponse';
  action?: Maybe<Scalars['EmptyObject']>;
  created?: Maybe<Scalars['String']>;
  msgType?: Maybe<Scalars['String']>;
  partition?: Maybe<Scalars['Int']>;
  requestId?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type EnableAutoTopupResponse = {
  __typename?: 'EnableAutoTopupResponse';
  appStartInfo: AppStartInfo;
  signatureId: Scalars['String'];
};

export enum EstimatedMonthlyDepositRange {
  Between_10000And_30000 = 'BETWEEN_10000_AND_30000',
  Between_30000And_60000 = 'BETWEEN_30000_AND_60000',
  Between_60000And_100000 = 'BETWEEN_60000_AND_100000',
  LessThan_10000 = 'LESS_THAN_10000',
  MoreThan_100000 = 'MORE_THAN_100000'
}

export enum EstimatedMonthlyDepositRangeV2 {
  AtLeast_100000Sek = 'AT_LEAST_100000_SEK',
  AtMost_10000Sek = 'AT_MOST_10000_SEK',
  Between_10000And_30000Sek = 'BETWEEN_10000_AND_30000_SEK',
  Between_30000And_60000Sek = 'BETWEEN_30000_AND_60000_SEK',
  Between_60000And_100000Sek = 'BETWEEN_60000_AND_100000_SEK'
}

export type Expense = {
  __typename?: 'Expense';
  category: Scalars['String'];
  created: Scalars['String'];
  description: Scalars['String'];
  expenseAmount: MonetaryAmount;
  expenseId: Scalars['String'];
  foreignTransactionId?: Maybe<Scalars['String']>;
  payer: Scalars['String'];
  split: Split;
  transactionType: GroupTransactionType;
};

export type ExpenseRequestInput = {
  category: Scalars['String'];
  description: Scalars['String'];
  foreignTransactionId?: InputMaybe<Scalars['String']>;
  paidAt: Scalars['String'];
  split: SplitInput;
};

export type ExpenseRequestInputForBatch = {
  amount: MonetaryAmountInput;
  category: Scalars['String'];
  description: Scalars['String'];
  foreignTransactionId?: InputMaybe<Scalars['String']>;
  paidAt: Scalars['String'];
};

export type Expenses = {
  __typename?: 'Expenses';
  amount: Scalars['Int'];
  currency: Scalars['String'];
  unit: Scalars['String'];
};

export type ExpirationDate = {
  __typename?: 'ExpirationDate';
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type FetchAccountCreditInvoiceResponse = {
  __typename?: 'FetchAccountCreditInvoiceResponse';
  action?: Maybe<AccountCreditInvoices>;
  created: Scalars['String'];
  msgType: Scalars['String'];
  partition: Scalars['Int'];
  requestId: Scalars['String'];
  user: Scalars['String'];
};

export type FetchApplicationDataResponse = {
  __typename?: 'FetchApplicationDataResponse';
  adress?: Maybe<Address>;
  amortizationPeriod?: Maybe<Scalars['Int']>;
  appliedAmount?: Maybe<CurrencyAmount>;
  /** Any outstanding interest on an already present loan. Only present when doing a topup / LAC. */
  approximationOfOutstandingInterest?: Maybe<Scalars['Float']>;
  bankAccount?: Maybe<Scalars['String']>;
  budget?: Maybe<LoanBudget>;
  contactInformation?: Maybe<ContactInformation>;
  /** The current debt of the user. Only present when doing a topup / LAC. */
  currentDebt?: Maybe<Scalars['Float']>;
  customerName?: Maybe<CustomerName>;
  fundingOrganization: Scalars['String'];
  id: Scalars['String'];
  loanDetails?: Maybe<LoanDetails>;
  proofOfIncomeRequired: Scalars['Boolean'];
  state: LoanApplicationState;
  validThrough: Scalars['String'];
};

export type FetchBlocketProductsResponse = GatewayResponse & {
  __typename?: 'FetchBlocketProductsResponse';
  action: BlocketProductsAction;
  created?: Maybe<Scalars['String']>;
  msgType?: Maybe<Scalars['String']>;
  partition?: Maybe<Scalars['Int']>;
  requestId?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type FetchCustomerInvoicesResponse = GatewayResponse & {
  __typename?: 'FetchCustomerInvoicesResponse';
  action?: Maybe<InvoiceList>;
  created?: Maybe<Scalars['String']>;
  msgType?: Maybe<Scalars['String']>;
  partition?: Maybe<Scalars['Int']>;
  requestId?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type FetchPaymentStatusAction = SwishFailed | SwishPaymentCompleted | SwishPaymentStatus | SwishTokenCreatedResponse;

export type FetchSwishPaymentTokenResponse = {
  __typename?: 'FetchSwishPaymentTokenResponse';
  errors?: Maybe<Array<Maybe<SwishPaymentErrorMessage>>>;
  message?: Maybe<BlocketPaymentResponseType>;
  token?: Maybe<Scalars['String']>;
};

/** TYPE OF RESPONSE FROM BACKEND TO GATEWAY */
export type FetchSwishStatusResponse = GatewayResponse & {
  __typename?: 'FetchSwishStatusResponse';
  action?: Maybe<FetchPaymentStatusAction>;
  created?: Maybe<Scalars['String']>;
  msgType?: Maybe<Scalars['String']>;
  partition?: Maybe<Scalars['Int']>;
  requestId?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type FinancialHealth = {
  __typename?: 'FinancialHealth';
  lastCalendarMonthSavingsRatio?: Maybe<Scalars['Float']>;
  longTermSavingsRatio?: Maybe<Scalars['Float']>;
  period: Scalars['String'];
  recurringCostRatio?: Maybe<Scalars['Float']>;
  savingsRatio?: Maybe<Scalars['Float']>;
  shortTermSavingsRatio?: Maybe<Scalars['Float']>;
  totalScore?: Maybe<Scalars['Float']>;
  weightedMovingAverageSavingsRatio?: Maybe<Scalars['Float']>;
};

export type FinancialHealthInput = {
  fromIncl?: InputMaybe<Scalars['String']>;
  resolution?: InputMaybe<FinancialHealthResolution>;
  toExcl?: InputMaybe<Scalars['String']>;
};

export enum FinancialHealthResolution {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  MonthlyAdjusted = 'MONTHLY_ADJUSTED',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type FinancialHealthResponse = {
  __typename?: 'FinancialHealthResponse';
  history: Array<FinancialHealth>;
  isAcceptableData: Scalars['Boolean'];
  scoreThresholds: ScoreThresholds;
};

export type FinancialInsightsInput = {
  accountIdIn?: InputMaybe<Array<Scalars['String']>>;
  /** If true, returns mock data. This is used for the Economic Health mock preview */
  mock?: InputMaybe<Scalars['Boolean']>;
  periodFilter?: InputMaybe<PeriodFilter>;
  resolution?: InputMaybe<StatisticsResolution>;
  statisticsDataId?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  types?: InputMaybe<Array<StatisticsType>>;
};

export type FirebaseIdentifier = {
  __typename?: 'FirebaseIdentifier';
  firebaseId?: Maybe<Scalars['String']>;
  insertedAt?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ForeignBankTransfer = {
  account: Scalars['String'];
};

export enum FundingOrganization {
  Bynk = 'Bynk',
  Nordiska = 'Nordiska',
  Penser = 'Penser'
}

export enum FundsSource {
  Dividends = 'DIVIDENDS',
  Gambling = 'GAMBLING',
  InheritanceOrGift = 'INHERITANCE_OR_GIFT',
  Insurance = 'INSURANCE',
  SalaryOrPension = 'SALARY_OR_PENSION',
  Sales = 'SALES',
  Savings = 'SAVINGS',
  SelfEmployment = 'SELF_EMPLOYMENT',
  Subsidies = 'SUBSIDIES'
}

export enum GamblingActivity {
  Casino = 'CASINO',
  OnlinePoker = 'ONLINE_POKER',
  Other = 'OTHER',
  SportsBetting = 'SPORTS_BETTING'
}

export enum GamblingFrequence {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum GamblingHistory {
  AtLeast_48Months = 'AT_LEAST_48_MONTHS',
  AtMost_12Months = 'AT_MOST_12_MONTHS',
  Between_12And_24Months = 'BETWEEN_12_AND_24_MONTHS',
  Between_24And_48Months = 'BETWEEN_24_AND_48_MONTHS'
}

export enum GamblingIncome {
  AtLeast_100000Sek = 'AT_LEAST_100000_SEK',
  AtMost_10000Sek = 'AT_MOST_10000_SEK',
  Between_10000And_50000Sek = 'BETWEEN_10000_AND_50000_SEK',
  Between_50000And_100000Sek = 'BETWEEN_50000_AND_100000_SEK'
}

export type GamblingInfo = {
  __typename?: 'GamblingInfo';
  activity: GamblingActivity;
  averageMonthlyIncomeFromGambling: GamblingIncome;
  frequency: GamblingFrequence;
  maxProfitLastTwelveMonths: GamblingMaxProfit;
  profitHistoryMonths: GamblingHistory;
};

export type GamblingInfoInput = {
  activity: GamblingActivity;
  averageMonthlyIncomeFromGambling: GamblingIncome;
  frequency: GamblingFrequence;
  maxProfitLastTwelveMonths: GamblingMaxProfit;
  profitHistoryMonths: GamblingHistory;
};

export enum GamblingMaxProfit {
  AtLeast_500000Sek = 'AT_LEAST_500000_SEK',
  AtMost_10000Sek = 'AT_MOST_10000_SEK',
  Between_10000And_100000Sek = 'BETWEEN_10000_AND_100000_SEK',
  Between_100000And_500000Sek = 'BETWEEN_100000_AND_500000_SEK'
}

export type GatewayResponse = {
  created?: Maybe<Scalars['String']>;
  msgType?: Maybe<Scalars['String']>;
  partition?: Maybe<Scalars['Int']>;
  requestId?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type GetAccountsResponse = {
  __typename?: 'GetAccountsResponse';
  accounts?: Maybe<Array<Maybe<TinkAccount>>>;
};

export type GetAuthResponse = {
  __typename?: 'GetAuthResponse';
  /** QR code data used to launch Mobile Bankid app - exists in status PENDING and is updated every second. */
  qrAuthData?: Maybe<Scalars['String']>;
  rockerJwt?: Maybe<Scalars['String']>;
  status: AuthStatus;
};

export type GetGoogleStatusResponse = {
  __typename?: 'GetGoogleStatusResponse';
  status: GoogleAuthenticationStatus;
};

export type GetInsuranceStatusResponse = {
  __typename?: 'GetInsuranceStatusResponse';
  id: Scalars['String'];
  insurance?: Maybe<Insurance>;
  isEnabled: Scalars['Boolean'];
  isFreePeriod: Scalars['Boolean'];
};

export type GmailSearchQueryInput = {
  date: Scalars['String'];
  description: Scalars['String'];
  originalAmount: CurrencyDenominatedAmountInput;
};

export type GmailSearchQueryResponse = {
  __typename?: 'GmailSearchQueryResponse';
  query: Scalars['String'];
};

export enum GoogleAuthenticationStatus {
  Authenticated = 'AUTHENTICATED',
  RequiresAuthentication = 'REQUIRES_AUTHENTICATION'
}

export type GoogleInAppProvisioningInput = {
  clientDeviceId: Scalars['String'];
  clientWalletAccountId: Scalars['String'];
};

export type GoogleInAppProvisioningTokenResponse = {
  __typename?: 'GoogleInAppProvisioningTokenResponse';
  action: DigitizationData;
};

export type GrantedUsages = {
  __typename?: 'GrantedUsages';
  grantedUsages: Scalars['Int'];
  type: Scalars['String'];
};

export type GroupDebtsResponse = {
  __typename?: 'GroupDebtsResponse';
  debtType: DebtType;
  debts: Array<DebtSummary>;
};

export type GroupResponse = {
  __typename?: 'GroupResponse';
  groups: Array<GroupSummary>;
};

export type GroupSettlementStatusResponse = {
  __typename?: 'GroupSettlementStatusResponse';
  status: HttpSettleUpStatus;
};

export enum GroupStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type GroupSummary = {
  __typename?: 'GroupSummary';
  created: Scalars['String'];
  groupIcon: Scalars['String'];
  groupId: Scalars['String'];
  groupName: Scalars['String'];
  groupStatus: GroupStatus;
  myParticipantId: Scalars['String'];
  participants: Array<Participant>;
  updated: Scalars['String'];
};

export type GroupTransaction = Expense | TransferBetweenParticipants;

export type GroupTransactionDetails = {
  __typename?: 'GroupTransactionDetails';
  group: GroupSummary;
  transaction: GroupTransaction;
};

export enum GroupTransactionType {
  Expense = 'EXPENSE',
  TransferBetweenParticipants = 'TRANSFER_BETWEEN_PARTICIPANTS'
}

export enum GroupUserType {
  ExternalUser = 'EXTERNAL_USER',
  RockerUser = 'ROCKER_USER'
}

export type GroupsCountResponse = {
  __typename?: 'GroupsCountResponse';
  activeGroups: Scalars['Int'];
  archivedGroups: Scalars['Int'];
  pendingInvitations: Scalars['Int'];
  totalGroups: Scalars['Int'];
};

export enum HousingType {
  House = 'HOUSE',
  Lodger = 'LODGER',
  Rental = 'RENTAL',
  TenantOwnership = 'TENANT_OWNERSHIP'
}

export type HttpDebtThatIOweOthersInput = {
  money: DebtBalanceAmountInput;
  participantId: Scalars['String'];
};

export enum HttpSettleUpStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  PayingOut = 'PAYING_OUT',
  SignatureExpired = 'SIGNATURE_EXPIRED',
  WaitingForSignature = 'WAITING_FOR_SIGNATURE'
}

export type HttpTransaction = {
  __typename?: 'HttpTransaction';
  accountId: Scalars['String'];
  /** eg Privatkonto, Privat Spar, etc */
  accountName?: Maybe<Scalars['String']>;
  /** eg SEB, Swedbank, etc */
  bankName?: Maybe<Scalars['String']>;
  category?: Maybe<TinkCategory>;
  categoryId: Scalars['String'];
  categoryType: CategoryType;
  date: Scalars['String'];
  description: Scalars['String'];
  direction: Direction;
  dispensableAmount?: Maybe<Scalars['Float']>;
  entityId: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  group?: Maybe<TransactionSplitGroup>;
  id: Scalars['String'];
  lastModified: Scalars['String'];
  merchant?: Maybe<Merchant>;
  metadata: Scalars['Metadata'];
  notes?: Maybe<Scalars['String']>;
  originalAmount: CurrencyDenominatedAmount;
  originalDate: Scalars['String'];
  originalDescription: Scalars['String'];
  parts?: Maybe<Array<TransactionPart>>;
  pending: Scalars['Boolean'];
  pendingId?: Maybe<Scalars['String']>;
  settlementAmount: CurrencyDenominatedAmount;
  systemTags: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  timestamp: Scalars['String'];
  transactionTags?: Maybe<Array<TransactionTag>>;
  txType: Scalars['String'];
  upcoming?: Maybe<Scalars['Boolean']>;
  userId: Scalars['String'];
  userModified?: Maybe<Scalars['Boolean']>;
  userSetNotes?: Maybe<Scalars['String']>;
};

export type IconImages = {
  __typename?: 'IconImages';
  icon: Scalars['String'];
};

export type Identity = {
  __typename?: 'Identity';
  value?: Maybe<Scalars['String']>;
};

export type ImageReceipt = {
  __typename?: 'ImageReceipt';
  image: Scalars['String'];
  txId: Scalars['String'];
};

export type InboxMessage = {
  __typename?: 'InboxMessage';
  attachments: Array<InboxMessageAttachment>;
  body: Scalars['String'];
  id: Scalars['String'];
  readAt?: Maybe<Scalars['String']>;
  sender: InboxMessageSender;
  sentAt: Scalars['String'];
  subject: Scalars['String'];
};

export type InboxMessageAttachment = {
  __typename?: 'InboxMessageAttachment';
  contentType: Scalars['String'];
  fileName: Scalars['String'];
  id: Scalars['String'];
  size: Scalars['Int'];
};

export type InboxMessageSender = {
  __typename?: 'InboxMessageSender';
  email: Scalars['String'];
  name: Scalars['String'];
};

export type Income = {
  __typename?: 'Income';
  amount: Scalars['Int'];
  currency: Scalars['String'];
  unit: Scalars['String'];
};

export type IncreaseAccountCreditLimitFail = {
  __typename?: 'IncreaseAccountCreditLimitFail';
  id?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
};

export type IncreaseAccountCreditLimitInput = {
  email: Scalars['String'];
  employmentLength: Scalars['Int'];
  kalp: AcKalp;
  phoneNumber: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};

export type IncreaseAccountCreditLimitNotFound = {
  __typename?: 'IncreaseAccountCreditLimitNotFound';
  failureReason: Scalars['String'];
  ssn: Scalars['String'];
};

export type IncreaseAccountCreditLimitNotQualified = {
  __typename?: 'IncreaseAccountCreditLimitNotQualified';
  decision: Scalars['String'];
  id?: Maybe<Scalars['String']>;
};

export type IncreaseAccountCreditLimitResponse = IncreaseAccountCreditLimitFail | IncreaseAccountCreditLimitNotFound | IncreaseAccountCreditLimitNotQualified | IncreaseAccountCreditLimitSuccess;

export type IncreaseAccountCreditLimitSuccess = {
  __typename?: 'IncreaseAccountCreditLimitSuccess';
  id?: Maybe<Scalars['String']>;
  newInterest: Scalars['Float'];
  newLimit: Money;
};

export type InitTrustlyAccountSelectionResponse = {
  __typename?: 'InitTrustlyAccountSelectionResponse';
  id: Scalars['String'];
  url: Scalars['String'];
};

export type InitiateNotificationsResponse = {
  __typename?: 'InitiateNotificationsResponse';
  success: Scalars['Boolean'];
};

export type InitiateSavingsV2DepositPayload = SavingsV2DepositMethodPayloadCard | SavingsV2DepositMethodPayloadSwish | SavingsV2DepositMethodPayloadTrustly;

export type InitiateSavingsV2DepositRequestInput = {
  amount: MoneyMinorInput;
  method: SavingsV2DepositMethod;
};

export type InitiateSavingsV2DepositResponse = {
  __typename?: 'InitiateSavingsV2DepositResponse';
  payload: InitiateSavingsV2DepositPayload;
  transactionId: Scalars['String'];
};

export type InitiateSavingsV2OnboardingRequestInput = {
  email: Scalars['String'];
  kycAnswers: SavingsV2KycAnswersInput;
  transferPenserSavings: Scalars['Boolean'];
  withdrawalAccount: Scalars['String'];
};

export type InitiateSavingsV2OnboardingResponse = {
  __typename?: 'InitiateSavingsV2OnboardingResponse';
  autoStartToken: Scalars['String'];
};

export type InitiateSavingsV2WithdrawalCardRequestInput = {
  money: MoneyMinorInput;
};

export type InitiateSavingsV2WithdrawalCardResponse = {
  __typename?: 'InitiateSavingsV2WithdrawalCardResponse';
  bankIdSigningInfo: BankIdSigningInfo;
  transferId: Scalars['String'];
};

export type InitiateSavingsV2WithdrawalMethodInput = {
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  type: SavingsV2WithdrawalMethod;
};

export type InitiateSavingsV2WithdrawalPayload = SavingsV2WithdrawalMethodCard | SavingsV2WithdrawalMethodSeBankPayout | SavingsV2WithdrawalMethodTrustly;

export type InitiateSavingsV2WithdrawalRequestInput = {
  amount: MoneyMinorInput;
  method: InitiateSavingsV2WithdrawalMethodInput;
};

export type InitiateSavingsV2WithdrawalResponse = {
  __typename?: 'InitiateSavingsV2WithdrawalResponse';
  payload: InitiateSavingsV2WithdrawalPayload;
  transactionId: Scalars['String'];
};

export type Inquiries = {
  __typename?: 'Inquiries';
  count?: Maybe<Scalars['Int']>;
};

export type Insurance = {
  __typename?: 'Insurance';
  created: Scalars['String'];
  lastCharged?: Maybe<InsuranceCharge>;
  lastDisabled?: Maybe<Scalars['String']>;
  lastEnabled: Scalars['String'];
};

export type InsuranceCharge = {
  __typename?: 'InsuranceCharge';
  amount?: Maybe<Scalars['String']>;
  at?: Maybe<Scalars['String']>;
};

export type InterestRate = {
  __typename?: 'InterestRate';
  effective: Scalars['Float'];
  nominal: Scalars['Float'];
};

export type InterestRateTier = {
  __typename?: 'InterestRateTier';
  endingBalance: MoneyMinor;
  interestRate: Scalars['Float'];
};

export type Interval = {
  __typename?: 'Interval';
  days: Scalars['Int'];
  hours: Scalars['Int'];
  minutes: Scalars['Int'];
  months: Scalars['Int'];
  seconds: Scalars['Int'];
  years: Scalars['Int'];
};

export type IntlAuthUrl = {
  __typename?: 'IntlAuthUrl';
  url: Scalars['String'];
};

export type IntlCustomer = {
  __typename?: 'IntlCustomer';
  email?: Maybe<Scalars['String']>;
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  verifiedEmail?: Maybe<Scalars['String']>;
  verifiedPhone?: Maybe<Scalars['String']>;
};

export type IntlToken = {
  __typename?: 'IntlToken';
  idToken: Scalars['String'];
  refreshToken: Scalars['String'];
  state?: Maybe<Scalars['String']>;
};

export type InvalidExistingLoansToConsolidate = {
  __typename?: 'InvalidExistingLoansToConsolidate';
  message: Scalars['String'];
};

export type InvalidExistingLoansTotalAmount = {
  __typename?: 'InvalidExistingLoansTotalAmount';
  message: Scalars['String'];
};

export type InvalidMonthlyIncome = {
  __typename?: 'InvalidMonthlyIncome';
  message: Scalars['String'];
};

export type InvitationInfo = {
  __typename?: 'InvitationInfo';
  canReinvite: Scalars['Boolean'];
  phone: Scalars['String'];
  status: InvitationStatus;
};

export type InvitationInput = {
  nickname: Scalars['String'];
  phone: Scalars['String'];
};

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type Invoice = {
  __typename?: 'Invoice';
  autoGiro: Scalars['Boolean'];
  bankgiro: Scalars['String'];
  details: Array<Maybe<Detail>>;
  dueDate: Scalars['String'];
  expired?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  invoiceAmount: Scalars['Float'];
  isExtraAmortization?: Maybe<Scalars['Boolean']>;
  issueDate: Scalars['String'];
  lastPayDate?: Maybe<Scalars['String']>;
  merchantId?: Maybe<Scalars['String']>;
  ocr: Scalars['String'];
  paid: Scalars['Float'];
  payments?: Maybe<Array<Maybe<PaymentsDetails>>>;
  status: InvoiceStatus;
  title?: Maybe<Scalars['String']>;
  unseen?: Maybe<Scalars['Boolean']>;
};

export type InvoiceList = {
  __typename?: 'InvoiceList';
  invoiceList?: Maybe<Array<Maybe<Invoice>>>;
};

export enum InvoiceStatus {
  Due = 'Due',
  Overdue = 'Overdue',
  Paid = 'Paid',
  Pending = 'Pending',
  Postponed = 'Postponed',
  Replaced = 'Replaced',
  Unknown = 'Unknown'
}

export type Kalp = {
  adults: Scalars['Int'];
  children: Scalars['Int'];
  employmentType: EmploymentType;
  housingType: HousingType;
  income: Scalars['Int'];
  renegotiateLoansAmount: Scalars['Int'];
};

export type KalpData = {
  adults: Scalars['Int'];
  children: Scalars['Int'];
  employmentType: EmploymentType;
  housingType: HousingType;
  /** Income in MAJOR unit */
  income: Scalars['Float'];
  renegotiateLoansAmount?: InputMaybe<Scalars['Int']>;
};

export type KeepStreakAchievementType = {
  __typename?: 'KeepStreakAchievementType';
  achievementType: AchievementType;
  period: Scalars['String'];
};

export type KycSubmission = {
  __typename?: 'KycSubmission';
  answers: CardKycAnswersV2;
  submittedAt: Scalars['String'];
};

export enum Language {
  Fi = 'FI',
  Sv = 'SV'
}

export type LatestIncome = {
  __typename?: 'LatestIncome';
  amount?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type LaunchInfo = {
  __typename?: 'LaunchInfo';
  autoStartToken?: Maybe<Scalars['String']>;
  launchType: AuthLaunchType;
  /** QR code data used to launch Mobile Bankid app */
  qrAuthData?: Maybe<Scalars['String']>;
};

export type Lights = {
  __typename?: 'Lights';
  creditCount?: Maybe<Scalars['Int']>;
  creditIncomeRatio?: Maybe<Scalars['Int']>;
  creditInquiries?: Maybe<Scalars['Int']>;
  creditUsed?: Maybe<Scalars['Int']>;
};

export enum ListenSwishPaymentResponseType {
  PaymentPending = 'PaymentPending',
  TokenCreated = 'TokenCreated',
  TransferFailed = 'TransferFailed',
  TransferSucceeded = 'TransferSucceeded'
}

export type LoanApplicationData = {
  __typename?: 'LoanApplicationData';
  accommodation: Accommodation;
  amortizationPeriod: AmortizationPeriod;
  coApplicantData?: Maybe<CoApplicantApplicationData>;
  consolidate?: Maybe<Consolidate>;
  contactDetails: ContactDetails;
  loanPurpose?: Maybe<LoanPurpose>;
  occupation: Occupation;
  personalDetails: PersonalDetails;
  totalAmount: MoneyMinor;
};

export type LoanApplicationMissing = {
  __typename?: 'LoanApplicationMissing';
  /** Workaround for a GraphQL bug where empty types crash during runtime. Ignore this. */
  _?: Maybe<Scalars['Any']>;
};

export type LoanApplicationResumed = {
  __typename?: 'LoanApplicationResumed';
  id: Scalars['String'];
  locked: Scalars['Boolean'];
  resumed: Scalars['Boolean'];
};

export enum LoanApplicationState {
  /** Quotation has been accepted by the user. */
  Accepted = 'Accepted',
  /** Waiting on back office to approve the application. */
  AwaitingAdministratorResolution = 'AwaitingAdministratorResolution',
  AwaitingManualApproval = 'AwaitingManualApproval',
  /** The customer has initiated the signing of bill of debt. */
  AwaitingSignature = 'AwaitingSignature',
  /** The loan is currently being created on the back-end. */
  CreateLoan = 'CreateLoan',
  /** Not allowed to take a loan. */
  Denied = 'Denied',
  /** The loan has been created. */
  LoanCreated = 'LoanCreated',
  /** (Same as PreparingLoanQuotation) Gathering information from the user. */
  PreparingForLoanQuotation = 'PreparingForLoanQuotation',
  /** (Same as PreparingForLoanQuotation) Gathering information from the user. */
  PreparingLoanQuotation = 'PreparingLoanQuotation',
  /** Waiting for the user to accept the offer. */
  WaitingForQuotationResponse = 'WaitingForQuotationResponse'
}

export enum LoanApplicationStatus {
  ApplicationDataAdded = 'ApplicationDataAdded',
  CanceledByPartner = 'CanceledByPartner',
  DeclinedByAllPartners = 'DeclinedByAllPartners',
  Deleted = 'Deleted',
  Done = 'Done',
  Error = 'Error',
  Expired = 'Expired',
  New = 'New',
  QuoteSelected = 'QuoteSelected',
  QuotesRejected = 'QuotesRejected',
  RequestForQuoteSent = 'RequestForQuoteSent'
}

export type LoanBrokerApplicationResponse = {
  __typename?: 'LoanBrokerApplicationResponse';
  applicationData?: Maybe<LoanApplicationData>;
  applicationId: Scalars['String'];
  createdAt: Scalars['String'];
  loanId?: Maybe<Scalars['String']>;
  status: LoanApplicationStatus;
  updatedAt?: Maybe<Scalars['String']>;
};

export type LoanBrokerQuote = {
  __typename?: 'LoanBrokerQuote';
  amortizationPeriod: AmortizationPeriod;
  amount: MoneyMinor;
  amountToSolveExternal?: Maybe<MoneyMinor>;
  conditions?: Maybe<Array<LoanBrokerQuoteConditions>>;
  /** imageUrl was used for test. To be removed */
  imageUrl?: Maybe<Scalars['String']>;
  interestRateEffective: Scalars['Float'];
  interestRateNominal: Scalars['Float'];
  monthlyFee: MoneyMinor;
  monthlyInstallment: MonthlyInstallment;
  partnerBank: PartnerBanks;
  setupFee: MoneyMinor;
  totalCost: MoneyMinor;
  validTo?: Maybe<Scalars['String']>;
};

export type LoanBrokerQuoteConditions = CoApplicant | Complements | ConsolidateDebts;

export type LoanBrokerQuoteDecisionResponse = {
  __typename?: 'LoanBrokerQuoteDecisionResponse';
  partnerBank: PartnerBanks;
  signingLink?: Maybe<Scalars['String']>;
};

export type LoanBrokerQuotesResponse = {
  __typename?: 'LoanBrokerQuotesResponse';
  pending: Scalars['Int'];
  quotes?: Maybe<Array<LoanBrokerQuote>>;
};

export type LoanBrokerStateResponse = {
  __typename?: 'LoanBrokerStateResponse';
  creditReportsRequested: Scalars['Boolean'];
  declines: Scalars['Int'];
  done: Scalars['Boolean'];
  offers: Scalars['Int'];
  requests: Scalars['Int'];
};

export type LoanBudget = {
  __typename?: 'LoanBudget';
  adults: Scalars['Int'];
  children: Scalars['Int'];
  employmentType: EmploymentType;
  housingType?: Maybe<HousingType>;
  income: CurrencyAmount;
  renegotiateLoansAmount: CurrencyAmount;
  totalHouseholdCost: CurrencyAmount;
};

export type LoanData = {
  __typename?: 'LoanData';
  debt: Scalars['Float'];
  initialInterestRate: Scalars['Float'];
  inkassoFee: Scalars['Float'];
  interestRate: Scalars['Float'];
  lateFee: Scalars['Float'];
  monthlyCost: Scalars['Float'];
  monthlyFee: Scalars['Float'];
  reminderFee: Scalars['Float'];
  setupFee: Scalars['Float'];
};

export type LoanDetails = {
  __typename?: 'LoanDetails';
  administrationFee: Scalars['Float'];
  amortizationPeriod: Scalars['Int'];
  amount: Scalars['Float'];
  effectiveInterestRate: Scalars['Float'];
  loanNumber: Scalars['String'];
  nominalInterestRate: Scalars['Float'];
  setupFee: Scalars['Float'];
  totalToPay: Scalars['Float'];
};

export type LoanExists = {
  __typename?: 'LoanExists';
  cannotTakeTopupReason?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type LoanFeesV2 = {
  __typename?: 'LoanFeesV2';
  collectionFee: Scalars['Int'];
  delayFee: Scalars['Int'];
  monthlyFee: Scalars['Int'];
  reminderFee: Scalars['Int'];
  setupFee: Scalars['Int'];
};

export type LoanPredictionModelVersionDetails = {
  __typename?: 'LoanPredictionModelVersionDetails';
  accuracy: Scalars['Float'];
  isDefault: Scalars['Boolean'];
  releaseDate: Scalars['Date'];
  version: Scalars['String'];
};

export type LoanPredictionQuotaExceeded = {
  __typename?: 'LoanPredictionQuotaExceeded';
  message: Scalars['String'];
};

export type LoanPredictionResponse = LoanPredictionQuotaExceeded | LoanPredictionValidationError | RangedLoanPredictionResult;

export type LoanPredictionResult = {
  __typename?: 'LoanPredictionResult';
  bounds: PredictedInterestRateBounds;
  likelihood: Scalars['Float'];
};

export type LoanPredictionResultSpan = {
  __typename?: 'LoanPredictionResultSpan';
  amount: Scalars['Int'];
  loanPrediction: LoanPredictionResult;
};

export type LoanPredictionSequenceResponse = LoanPredictionQuotaExceeded | LoanPredictionValidationError | RangedLoanPredictionResultSequence;

export type LoanPredictionValidationError = {
  __typename?: 'LoanPredictionValidationError';
  errors: Array<ValidationErrorDetails>;
};

export type LoanProtection = {
  __typename?: 'LoanProtection';
  startDate?: Maybe<Scalars['String']>;
};

export enum LoanPurpose {
  Consolidation = 'Consolidation',
  Consumption = 'Consumption',
  Healthcare = 'Healthcare',
  Other = 'Other',
  Renovation = 'Renovation',
  TripOrVacation = 'TripOrVacation',
  Vehicle = 'Vehicle'
}

export type LoanTerminationAmountResponse = {
  __typename?: 'LoanTerminationAmountResponse';
  amount: Scalars['Float'];
};

export type LoanTransactionsDescriptionsResult = {
  __typename?: 'LoanTransactionsDescriptionsResult';
  excluded: Array<Scalars['String']>;
  included: Array<Scalars['String']>;
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Coordinates>;
  placeId?: Maybe<Scalars['String']>;
};

export enum MaritalStatus {
  Divorced = 'Divorced',
  LivingTogether = 'LivingTogether',
  Married = 'Married',
  Single = 'Single'
}

export type MarkAchievementsAsSeenResponse = {
  __typename?: 'MarkAchievementsAsSeenResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type MarkAsUsingAppResponse = {
  __typename?: 'MarkAsUsingAppResponse';
  success: Scalars['Boolean'];
};

export type MarkMessageAsReadInput = {
  messageId: Scalars['String'];
};

export type MarkMessageAsReadResponse = {
  __typename?: 'MarkMessageAsReadResponse';
  success: Scalars['Boolean'];
};

export type MarkNotificationsReadResponse = {
  __typename?: 'MarkNotificationsReadResponse';
  success: Scalars['Boolean'];
};

export type MarkPageVisitInput = {
  page: PageVisit;
};

export type MarkPageVisitResponse = {
  __typename?: 'MarkPageVisitResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum Market {
  De = 'DE',
  Nl = 'NL',
  Se = 'SE'
}

export type MaxNumberBased = {
  __typename?: 'MaxNumberBased';
  type: Scalars['String'];
  value: Scalars['Float'];
};

export type Member = {
  __typename?: 'Member';
  bankAccounts?: Maybe<Array<Maybe<Scalars['Any']>>>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['Any']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  firstUsed2021AppAt?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  insertedAt: Scalars['String'];
  isBanned?: Maybe<Scalars['Any']>;
  isVerified?: Maybe<Scalars['Any']>;
  itemsForSale?: Maybe<Array<Maybe<Scalars['Any']>>>;
  lastName?: Maybe<Scalars['String']>;
  lastUcUpdateAt?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['Any']>;
  properties: Scalars['Any'];
  reputation?: Maybe<Scalars['Any']>;
  shippingAddresses: Array<Maybe<Scalars['Any']>>;
  ssn: Scalars['String'];
  streetAddressLine1?: Maybe<Scalars['String']>;
  streetAddressLine2?: Maybe<Scalars['String']>;
  streetAddressLine3?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  verifiedIdentities?: Maybe<Array<Maybe<Scalars['Any']>>>;
};

export type MemberInfo = {
  __typename?: 'MemberInfo';
  result: Scalars['String'];
  user: Member;
};

export type MemberInfoResponse = GatewayResponse & {
  __typename?: 'MemberInfoResponse';
  created?: Maybe<Scalars['String']>;
  msgType?: Maybe<Scalars['String']>;
  partition?: Maybe<Scalars['Int']>;
  payload?: Maybe<MemberInfo>;
  requestId?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type Merchant = {
  __typename?: 'Merchant';
  category?: Maybe<Scalars['String']>;
  contact?: Maybe<MerchantContact>;
  location?: Maybe<MerchantLocation>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  suggestionReference?: Maybe<Scalars['String']>;
};

export enum MerchantChangesProblem {
  IncorrectAddress = 'INCORRECT_ADDRESS',
  IncorrectLogo = 'INCORRECT_LOGO',
  IncorrectName = 'INCORRECT_NAME',
  MissingLogo = 'MISSING_LOGO'
}

export type MerchantContact = {
  __typename?: 'MerchantContact';
  phoneNumber?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type MerchantLocation = {
  __typename?: 'MerchantLocation';
  address?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Coordinates>;
  placeId?: Maybe<Scalars['String']>;
};

export type Message = {
  __typename?: 'Message';
  lang: Language;
  text: Scalars['String'];
};

export type MessageAttachmentInput = {
  attachmentId: Scalars['String'];
  messageId: Scalars['String'];
};

export type MinimumTransaction = {
  __typename?: 'MinimumTransaction';
  accountId?: Maybe<Scalars['String']>;
  amount: MoneyMinor;
  categoryId: Scalars['String'];
  categoryType?: Maybe<Scalars['String']>;
  date: Scalars['String'];
  description: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  merchant?: Maybe<Merchant>;
  originalDescription: Scalars['String'];
};

export type MobilePhoneNumber = {
  __typename?: 'MobilePhoneNumber';
  given?: Maybe<Scalars['String']>;
};

export type MobileWalletActivationCodeResponse = {
  __typename?: 'MobileWalletActivationCodeResponse';
  activationData: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type MonetaryAmount = {
  __typename?: 'MonetaryAmount';
  amount: Scalars['Int'];
  currency: Scalars['String'];
  unit: MonetaryAmountUnit;
};

export type MonetaryAmountInput = {
  amount: Scalars['Int'];
  currency: Scalars['String'];
  unit: MonetaryAmountUnit;
};

export enum MonetaryAmountUnit {
  Major = 'MAJOR',
  Minor = 'MINOR'
}

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Int'];
  currency: Scalars['String'];
};

export type MoneyMinor = {
  __typename?: 'MoneyMinor';
  amount: Scalars['Long'];
  currency: Scalars['String'];
  unit: Scalars['String'];
};

export type MoneyMinorInput = {
  amount: Scalars['Long'];
  currency: Scalars['String'];
  unit: Scalars['String'];
};

export type MonthlyAmount = {
  __typename?: 'MonthlyAmount';
  cashback: MonetaryAmount;
  yearMonth: Scalars['String'];
};

export type MonthlyInstallment = Annuity | Serial;

export type MonthlyPayOption = {
  __typename?: 'MonthlyPayOption';
  amount: Scalars['Int'];
  terms: Scalars['Int'];
};

export type MultipleExpenseRequestInput = {
  expenses: Array<ExpenseRequestInputForBatch>;
  split: SplitInput;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptCreditSpaceQuotation?: Maybe<AcceptCreditSpaceQuotationResponse>;
  acceptGroupInvitation: AcceptGroupInvitationResponse;
  acceptMonthlyPayChange?: Maybe<AcceptMonthlyPayChangeResponse>;
  activatePayfreeMonth?: Maybe<ActivatePayfreeMonthResponse>;
  addBankAccountToAccountCredit: AddBankAccountToAccountCreditResponse;
  addCredential: AddCredentialResponse;
  addGroupExpense: AddGroupExpenseResponse;
  addMultipleGroupExpenses: AddMultipleGroupExpenseResponse;
  addProviderTinkLink: AddProviderResponse;
  addTransactionTag: AddTransactionTagResponse;
  addWebAccountCreditApplication?: Maybe<AddWebAccountCreditApplicationResponse>;
  addWebAccountCreditApplicationIncrease?: Maybe<AddWebAccountCreditApplicationResponse>;
  appAccountCreditApplicationBasic: AppAccountCreditApplicationBasicResponse;
  appAccountCreditApplicationIncrease: IncreaseAccountCreditLimitResponse;
  applyAgentLoanApplicationNoRegistrationNumber?: Maybe<AgentApplicationResponse>;
  applyAgentLoanApplicationWithRegistrationNumber?: Maybe<AgentApplicationResponse>;
  /** @deprecated Use applyForSubscriptionPlanV3 instead */
  applyForSubscriptionPlanV2: ApplySubscriptionPlanResponse;
  applyForSubscriptionPlanV3: ApplySubscriptionPlanV3Response;
  approveConsent: ConsentReviewResponse;
  archiveGroup: ArchiveGroupResponse;
  authenticateWithGoogle?: Maybe<AuthenticateWithGoogleResponse>;
  cancelApplication?: Maybe<Scalars['Void']>;
  cancelApplicationV2: CancelApplicationResponse;
  cancelSplitPaymentGroupV2: SplitPaymentAnswerResponse;
  categorizeTransactions: CategorizeTransactionsResponse;
  changeMonthlyPay: ChangeMonthlyPayLoanDetails;
  completeSplitPaymentV2: SplitPaymentAnswerResponse;
  createFirebasePushIdentifierRequest?: Maybe<CreateFirebasePushIdentifierRequest>;
  createGroup: CreateGroupResponse;
  createGroupInvitation: CreateGroupInvitationResponse;
  createImageReceiptV2?: Maybe<CreateImageReceiptV2Response>;
  createMember?: Maybe<MemberInfoResponse>;
  createNewApplication: CreateNewApplicationResponse;
  /** Trigger the creation of a spending analysis poem or return the current status of the poem creation process.  */
  createSpendingAnalysisPoem: SpendingAnalysisPoemResponse;
  /** Updated Mutations */
  createSplitPaymentGroupV4: CreateSplitPaymentGroupResponseV3;
  createSystemTag: CreateSystemTagResponse;
  deleteBudgetV2: DeleteBudgetResponse;
  deleteCredential: DeleteCredentialResponse;
  deleteCustomerData: DeleteCustomerDataResponse;
  deleteGroupExpense: DeleteGroupExpenseResponse;
  deleteImageReceiptV2?: Maybe<DeleteImageReceiptV2Response>;
  deleteTransactionReceipts?: Maybe<DeleteTransactionReceiptsResponse>;
  deleteTransactionTag: DeleteTransactionTagResponse;
  disableAutotopup: DisableAutotopupResponse;
  editGroup: EditGroupResponse;
  enableAutoTopup: EnableAutoTopupResponse;
  freezeCard: Card;
  initTrustlyAccountSelection: InitTrustlyAccountSelectionResponse;
  initiateSavingsV2Deposit: InitiateSavingsV2DepositResponse;
  initiateSavingsV2Onboarding: InitiateSavingsV2OnboardingResponse;
  initiateSavingsV2Withdrawal: InitiateSavingsV2WithdrawalResponse;
  initiateSavingsV2WithdrawalCard: InitiateSavingsV2WithdrawalCardResponse;
  /** Calculate the probability of the customer getting a loan offer or denial. */
  loanPrediction: LoanPredictionResponse;
  /** Calculate the sequence of loan predictions for all available versions. */
  loanPredictionSequence: LoanPredictionSequenceResponse;
  markAchievementsAsSeen: MarkAchievementsAsSeenResponse;
  markAsUsingApp: MarkAsUsingAppResponse;
  markMessageAsRead: MarkMessageAsReadResponse;
  markNotificationsRead: MarkNotificationsReadResponse;
  markPageVisit: MarkPageVisitResponse;
  /** @deprecated Use onboardUserForCardV5 */
  onboardUserForCardV3: OnboardUserForCardResponse;
  /** @deprecated Use onboardUserForCardV5 */
  onboardUserForCardV4: OnboardUserForCardResponse;
  onboardUserForCardV5: OnboardUserForCardResponse;
  optOutCardPrompt?: Maybe<Scalars['Boolean']>;
  /** Replace a card */
  orderCard: Card;
  payInvoice: PayInvoiceResponse;
  payoutAccountCredit: PayoutAccountCreditResponse;
  /** Initiates mobile bank ID authentication and returns a temporary JWT that can be used to get authentication result. */
  postAuth: PostAuthResponse;
  refreshCredential: RefreshCredentialResponse;
  refreshCredentialV2: RefreshCredentialResponseV2;
  refreshCredentials: RefreshCredentialsResponse;
  refreshProviderTinkLink: RefreshProviderResponse;
  registerDeviceForNotifications: RegisterDeviceForNotificationsResponse;
  rejectConsent: ConsentReviewResponse;
  rejectGroupInvitation: RejectGroupInvitationResponse;
  rejectSplitPaymentV2: SplitPaymentAnswerResponse;
  removeCreditApplication: Scalars['String'];
  removeTag?: Maybe<TagMutationResponse>;
  /** Replace a card */
  replaceCard: ReplaceCardPayload;
  /** Replace a card for free */
  replaceCardFree: ReplaceCardFreeResponse;
  root?: Maybe<Scalars['String']>;
  sendApplicationData: SendApplicationDataResponse;
  /** Create a new Credit Space application */
  sendCreditSpaceApplication: SendCreditSpaceApplicationResponse;
  sendQuotesDecision?: Maybe<SendQuotesDecisionResponse>;
  sendSettlementReminders: SendSettlementRemindersResponse;
  sendSettlementRequest: SendSettlementRequestResponse;
  sendVerificationEmail: SendVerificationEmailResponse;
  setBudgetV2: SetBudgetResponse;
  setCardPin: SetCardPinResponse;
  setIntlEmail: IntlCustomer;
  setIntlPhone: IntlCustomer;
  setNotificationPreferences: NotificationPreferences;
  signAppAccountCreditApplicationIncrease: SignAppAccountCreditApplicationIncreaseResponse;
  signCreditSpaceApplication: SignCreditSpaceApplicationResponse;
  signWebAccountCreditApplication: SignWebAccountCreditApplicationResponse;
  signWebAccountCreditApplicationIncrease: SignWebAccountCreditApplicationIncreaseResponse;
  startCardWithdrawal: StartCardWithdrawalResponse;
  startRevolvingCredit: StartRevolvingCreditResponse;
  startSwish: StartSwishResponse;
  suggestMerchantChanges: SuggestMerchantChangesResponse;
  terminateCustomer: TerminateCustomerResponse;
  terminateCustomerV2: TerminateCustomerResponse;
  toggleConsentToRockerContactV2: ConsentToRockerContact;
  transferRockerToRocker: TransferRockerToRockerResponse;
  triggerYearlyReview: TriggerYearlyReviewResponse;
  trustlyAccountSelectedWithdraw: TrustlyAccountSelectedWithdrawResponse;
  unarchiveGroup: UnarchiveGroupResponse;
  unfreezeCard: Card;
  updateAccount: UpdateAccountResponse;
  updateBudget: UpdateBudgetResponse;
  updateCardKycAnswers: UpdateCardKycResponse;
  updateCardKycAnswersV2: UpdateCardKycResponse;
  updateCustomerInfo?: Maybe<UpdateCustomerInfoResponse>;
  updateCustomerInfoV2: UpdateCustomerInfoV2Response;
  updateGroupExpense: UpdateGroupExpenseResponse;
  updateNotificationsPreferences: PushNotificationsPreferences;
  updateRegionsAndEcomm: Card;
  updateSavingsV2KYC: UpdateSavingsV2KycResponse;
  updateTransaction: TransactionMutationResponse;
  updateTransactionTags: UpdateTransactionTagsResponse;
  verifyCodeEmail: VerifyCodeEmailResponse;
};


export type MutationAcceptCreditSpaceQuotationArgs = {
  acceptCreditSpaceQuotationInput: AcceptCreditSpaceQuotationInput;
  token: Scalars['String'];
};


export type MutationAcceptGroupInvitationArgs = {
  invitationId: Scalars['String'];
};


export type MutationAcceptMonthlyPayChangeArgs = {
  id: Scalars['String'];
  token: Scalars['String'];
};


export type MutationActivatePayfreeMonthArgs = {
  id?: InputMaybe<Scalars['String']>;
  monthlyPayChange?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationAddBankAccountToAccountCreditArgs = {
  input: AddBankAccountToAccountCreditInput;
};


export type MutationAddCredentialArgs = {
  fields?: InputMaybe<Scalars['Any']>;
  providerName: Scalars['String'];
  token: Scalars['String'];
};


export type MutationAddGroupExpenseArgs = {
  expense: ExpenseRequestInput;
  groupId: Scalars['String'];
};


export type MutationAddMultipleGroupExpensesArgs = {
  expenses: MultipleExpenseRequestInput;
  groupId: Scalars['String'];
};


export type MutationAddProviderTinkLinkArgs = {
  provider?: InputMaybe<Scalars['String']>;
  theme?: InputMaybe<TinkTheme>;
  token: Scalars['String'];
  username?: InputMaybe<Scalars['String']>;
};


export type MutationAddTransactionTagArgs = {
  transactionId: Scalars['String'];
  transactionTag: Scalars['String'];
};


export type MutationAddWebAccountCreditApplicationArgs = {
  input: ApplyForAccountCreditInput;
};


export type MutationAddWebAccountCreditApplicationIncreaseArgs = {
  input: ApplyForAccountCreditInput;
};


export type MutationAppAccountCreditApplicationBasicArgs = {
  input: ApplyForBasicAccountCreditInput;
};


export type MutationAppAccountCreditApplicationIncreaseArgs = {
  input: IncreaseAccountCreditLimitInput;
};


export type MutationApplyAgentLoanApplicationNoRegistrationNumberArgs = {
  downPayment: Scalars['Int'];
  email: Scalars['String'];
  employer?: InputMaybe<Scalars['String']>;
  employmentType?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  interest: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  meterIndication: Scalars['Int'];
  modelYear: Scalars['Int'];
  phoneNumber: Scalars['String'];
  ssn: Scalars['String'];
  token: Scalars['String'];
  utmTracking?: InputMaybe<UtmTracking>;
  vehicleModel: Scalars['String'];
  vehicleValue: Scalars['Int'];
};


export type MutationApplyAgentLoanApplicationWithRegistrationNumberArgs = {
  downPayment: Scalars['Int'];
  email: Scalars['String'];
  employer?: InputMaybe<Scalars['String']>;
  employmentType?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  interest: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  meterIndication: Scalars['Int'];
  phoneNumber: Scalars['String'];
  registrationNumber: Scalars['String'];
  ssn: Scalars['String'];
  token: Scalars['String'];
  utmTracking?: InputMaybe<UtmTracking>;
  vehicleValue: Scalars['Int'];
};


export type MutationApplyForSubscriptionPlanV2Args = {
  plan: SubscriptionPlanCode;
};


export type MutationApplyForSubscriptionPlanV3Args = {
  plan: SubscriptionPlanCode;
};


export type MutationApproveConsentArgs = {
  id: Scalars['String'];
  token: Scalars['String'];
};


export type MutationArchiveGroupArgs = {
  groupId: Scalars['String'];
};


export type MutationAuthenticateWithGoogleArgs = {
  data: AuthenticateWithGoogleInput;
  token: Scalars['String'];
};


export type MutationCancelApplicationArgs = {
  applicationId: Scalars['String'];
};


export type MutationCancelApplicationV2Args = {
  applicationId: Scalars['String'];
};


export type MutationCancelSplitPaymentGroupV2Args = {
  groupId: Scalars['String'];
  token: Scalars['String'];
};


export type MutationCategorizeTransactionsArgs = {
  input: CategorizeTransactionsInput;
};


export type MutationChangeMonthlyPayArgs = {
  amount: Scalars['Int'];
  id?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationCompleteSplitPaymentV2Args = {
  requestId: Scalars['String'];
  token: Scalars['String'];
};


export type MutationCreateFirebasePushIdentifierRequestArgs = {
  firebaseId: Scalars['String'];
  isActive: Scalars['Boolean'];
  token: Scalars['String'];
};


export type MutationCreateGroupArgs = {
  icon: Scalars['String'];
  name: Scalars['String'];
};


export type MutationCreateGroupInvitationArgs = {
  createInvitationRequest: CreateInvitationRequestInput;
  groupId: Scalars['String'];
};


export type MutationCreateImageReceiptV2Args = {
  input: CreateImageReceiptInput;
  token?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
};


export type MutationCreateMemberArgs = {
  token: Scalars['String'];
};


export type MutationCreateNewApplicationArgs = {
  adtractionId?: InputMaybe<Scalars['String']>;
  adwordsId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateSpendingAnalysisPoemArgs = {
  request: RequestSpendingAnalysisPoemInput;
};


export type MutationCreateSplitPaymentGroupV4Args = {
  splitPaymentRequest: CreateSplitPaymentGroupRequestV4;
  token: Scalars['String'];
};


export type MutationCreateSystemTagArgs = {
  input: CreateSystemTagInput;
};


export type MutationDeleteCredentialArgs = {
  credentialsId: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteGroupExpenseArgs = {
  expenseId: Scalars['String'];
  groupId: Scalars['String'];
};


export type MutationDeleteImageReceiptV2Args = {
  token?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
};


export type MutationDeleteTransactionReceiptsArgs = {
  token: Scalars['String'];
  transactionId: Scalars['String'];
};


export type MutationDeleteTransactionTagArgs = {
  transactionId: Scalars['String'];
  transactionTag: Scalars['String'];
};


export type MutationDisableAutotopupArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type MutationEditGroupArgs = {
  editGroupRequest: EditGroupRequestInput;
  groupId: Scalars['String'];
};


export type MutationEnableAutoTopupArgs = {
  rule: AutoTopupRuleInput;
};


export type MutationFreezeCardArgs = {
  cardId: Scalars['String'];
  token: Scalars['String'];
};


export type MutationInitiateSavingsV2DepositArgs = {
  request: InitiateSavingsV2DepositRequestInput;
};


export type MutationInitiateSavingsV2OnboardingArgs = {
  request: InitiateSavingsV2OnboardingRequestInput;
};


export type MutationInitiateSavingsV2WithdrawalArgs = {
  request: InitiateSavingsV2WithdrawalRequestInput;
};


export type MutationInitiateSavingsV2WithdrawalCardArgs = {
  request: InitiateSavingsV2WithdrawalCardRequestInput;
};


export type MutationLoanPredictionArgs = {
  request: RequestLoanPredictionInput;
};


export type MutationLoanPredictionSequenceArgs = {
  request: RequestLoanPredictionInput;
};


export type MutationMarkMessageAsReadArgs = {
  input: MarkMessageAsReadInput;
};


export type MutationMarkPageVisitArgs = {
  input: MarkPageVisitInput;
};


export type MutationOnboardUserForCardV3Args = {
  data: OnboardUserForCardInputV3;
};


export type MutationOnboardUserForCardV4Args = {
  data: OnboardUserForCardInputV4;
};


export type MutationOnboardUserForCardV5Args = {
  data: OnboardUserForCardInputV5;
};


export type MutationOptOutCardPromptArgs = {
  token: Scalars['String'];
};


export type MutationOrderCardArgs = {
  input: OrderCardInput;
};


export type MutationPayInvoiceArgs = {
  input: PayInvoiceInput;
};


export type MutationPayoutAccountCreditArgs = {
  amount: Scalars['Int'];
  method?: InputMaybe<PayoutAccountCreditMethod>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationPostAuthArgs = {
  input: AuthRequestInput;
};


export type MutationRefreshCredentialArgs = {
  authenticate?: InputMaybe<Scalars['Boolean']>;
  credentialsId: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};


export type MutationRefreshCredentialV2Args = {
  authenticate?: InputMaybe<Scalars['Boolean']>;
  credentialId: Scalars['String'];
};


export type MutationRefreshProviderTinkLinkArgs = {
  credentialsId: Scalars['String'];
  redirectUri: Scalars['String'];
};


export type MutationRegisterDeviceForNotificationsArgs = {
  firebaseId: Scalars['String'];
};


export type MutationRejectConsentArgs = {
  id: Scalars['String'];
  token: Scalars['String'];
};


export type MutationRejectGroupInvitationArgs = {
  invitationId: Scalars['String'];
};


export type MutationRejectSplitPaymentV2Args = {
  requestId: Scalars['String'];
  token: Scalars['String'];
};


export type MutationRemoveCreditApplicationArgs = {
  id: Scalars['String'];
  token: Scalars['String'];
};


export type MutationRemoveTagArgs = {
  tag: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};


export type MutationReplaceCardArgs = {
  input: ReplaceCardInput;
};


export type MutationReplaceCardFreeArgs = {
  input: ReplaceCardFreeInput;
};


export type MutationSendApplicationDataArgs = {
  id: Scalars['String'];
  input: SendApplicationDataInput;
};


export type MutationSendCreditSpaceApplicationArgs = {
  creditSpaceApplicationInput: CreditSpaceApplicationInput;
  token: Scalars['String'];
};


export type MutationSendQuotesDecisionArgs = {
  id: Scalars['String'];
  input: SendQuoteDecisionInput;
};


export type MutationSendSettlementRemindersArgs = {
  groupId: Scalars['String'];
  reminderReceivers: Array<Scalars['String']>;
};


export type MutationSendSettlementRequestArgs = {
  groupId: Scalars['String'];
  request: SettleUpRequestInput;
};


export type MutationSendVerificationEmailArgs = {
  email: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};


export type MutationSetBudgetV2Args = {
  input: SetBudgetV2Input;
};


export type MutationSetCardPinArgs = {
  controlId: Scalars['String'];
  encryptedPin: Scalars['String'];
  token: Scalars['String'];
};


export type MutationSetIntlEmailArgs = {
  email: Scalars['String'];
  token: Scalars['String'];
};


export type MutationSetIntlPhoneArgs = {
  phone: Scalars['String'];
  token: Scalars['String'];
};


export type MutationSetNotificationPreferencesArgs = {
  name: Scalars['String'];
  token: Scalars['String'];
  value: Scalars['Boolean'];
};


export type MutationSignCreditSpaceApplicationArgs = {
  token: Scalars['String'];
};


export type MutationStartCardWithdrawalArgs = {
  accountId: Scalars['String'];
  input: StartCardWithdrawalInput;
  token: Scalars['String'];
};


export type MutationStartRevolvingCreditArgs = {
  accountId: Scalars['String'];
  transferInput: StartRevolvingCreditInput;
};


export type MutationStartSwishArgs = {
  transferInput: SwishTransferInput;
};


export type MutationSuggestMerchantChangesArgs = {
  input: SuggestMerchantChangesInput;
  txId: Scalars['String'];
};


export type MutationTerminateCustomerArgs = {
  token: Scalars['String'];
};


export type MutationTerminateCustomerV2Args = {
  input: TerminateCustomerInput;
};


export type MutationToggleConsentToRockerContactV2Args = {
  input: ConsentToRockerContactInput;
  token: Scalars['String'];
};


export type MutationTransferRockerToRockerArgs = {
  input: TransferRockerToRockerInput;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationTrustlyAccountSelectedWithdrawArgs = {
  input: TrustlyAccountSelectedWithdrawInput;
};


export type MutationUnarchiveGroupArgs = {
  groupId: Scalars['String'];
};


export type MutationUnfreezeCardArgs = {
  cardId: Scalars['String'];
  token: Scalars['String'];
};


export type MutationUpdateAccountArgs = {
  accountId: Scalars['String'];
  body?: InputMaybe<UpdateAccountRequest>;
  token: Scalars['String'];
};


export type MutationUpdateBudgetArgs = {
  input: BudgetRequestInput;
};


export type MutationUpdateCardKycAnswersArgs = {
  input: UpdateCardKycInput;
};


export type MutationUpdateCardKycAnswersV2Args = {
  input: UpdateCardKycInputV2;
};


export type MutationUpdateCustomerInfoArgs = {
  emailAddress?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


export type MutationUpdateCustomerInfoV2Args = {
  emailAddress?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateGroupExpenseArgs = {
  expense: EditExpenseRequestInput;
  expenseId: Scalars['String'];
  groupId: Scalars['String'];
};


export type MutationUpdateNotificationsPreferencesArgs = {
  input: PushNotificationsPreferencesInput;
};


export type MutationUpdateRegionsAndEcommArgs = {
  data: UpdateRegionsAndEcommInput;
  token: Scalars['String'];
};


export type MutationUpdateSavingsV2KycArgs = {
  request: UpdateSavingsV2KycRequestInput;
};


export type MutationUpdateTransactionArgs = {
  payload: UpdateTransactionInput;
  token: Scalars['String'];
  transactionId: Scalars['String'];
};


export type MutationUpdateTransactionTagsArgs = {
  tags: Array<Scalars['String']>;
  transactionId: Scalars['String'];
};


export type MutationVerifyCodeEmailArgs = {
  code: Scalars['String'];
};

export type MutationResponse = {
  code: Scalars['String'];
  success: Scalars['Boolean'];
};

export type MutualContact = MutualNonRockerContact | MutualRockerContactV2;

export type MutualContactInput = {
  phones: Array<Scalars['String']>;
};

export type MutualNonRockerContact = {
  __typename?: 'MutualNonRockerContact';
  phone: Scalars['String'];
};

export type MutualRockerContactV2 = {
  __typename?: 'MutualRockerContactV2';
  memberId: Scalars['String'];
  phone: Scalars['String'];
};

export type Name = {
  __typename?: 'Name';
  firstNames: Scalars['String'];
  givenName?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
};

export type NationalIdNumber = {
  __typename?: 'NationalIdNumber';
  country: Country;
  value: Scalars['String'];
};

export type NotQualifiedForAccountCredit = {
  __typename?: 'NotQualifiedForAccountCredit';
  /** Marker type */
  _Any?: Maybe<Scalars['Any']>;
};

export type Notification = {
  __typename?: 'Notification';
  attachments: Array<NotificationAttachment>;
  body: Scalars['String'];
  /** The date & time when this notification was first created for the user. */
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  /** Time when the notification was read or null if unread. */
  readAt?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type NotificationAttachment = DeepLinkNotificationAttachment;

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** The cursor identifier of this edge, used for pagination. */
  cursor: Scalars['PaginationCursor'];
  /** The notification contained by this edge. */
  node: Notification;
};

export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  emailNewsletter: Scalars['Boolean'];
  emailOffers: Scalars['Boolean'];
  emailProductUpdates: Scalars['Boolean'];
  pushNews: Scalars['Boolean'];
  pushOffers: Scalars['Boolean'];
  pushProductUpdates: Scalars['Boolean'];
  smsNews: Scalars['Boolean'];
  smsOffers: Scalars['Boolean'];
  smsProductUpdates: Scalars['Boolean'];
};

export type NotificationPreferencesPayload = {
  __typename?: 'NotificationPreferencesPayload';
  notificationPreferences?: Maybe<NotificationsPreferences>;
  result?: Maybe<Scalars['String']>;
};

export type NotificationsPreferences = {
  __typename?: 'NotificationsPreferences';
  emailNewsletter?: Maybe<Scalars['Boolean']>;
  emailOffers?: Maybe<Scalars['Boolean']>;
  emailProductUpdates?: Maybe<Scalars['Boolean']>;
  insertedAt?: Maybe<Scalars['String']>;
  pushNews?: Maybe<Scalars['Boolean']>;
  pushOffers?: Maybe<Scalars['Boolean']>;
  pushProductUpdates?: Maybe<Scalars['Boolean']>;
  smsNews?: Maybe<Scalars['Boolean']>;
  smsOffers?: Maybe<Scalars['Boolean']>;
  smsProductUpdates?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type NumberBased = {
  __typename?: 'NumberBased';
  type: Scalars['String'];
  value: Scalars['Float'];
};

export enum NumberOfTimes {
  Many = 'MANY',
  One = 'ONE'
}

export type Occupation = {
  __typename?: 'Occupation';
  monthlyIncome: MoneyMinor;
  occupationType: OccupationType;
};

export type OccupationInput = {
  monthlyIncome: MoneyMinorInput;
  occupationType: OccupationTypeInput;
};

export type OccupationType = {
  __typename?: 'OccupationType';
  companyName?: Maybe<Scalars['String']>;
  companyPhone?: Maybe<Scalars['String']>;
  occupation_type_name: OccupationTypeName;
  since: Scalars['String'];
  to?: Maybe<Scalars['String']>;
};

export type OccupationTypeInput = {
  companyName?: InputMaybe<Scalars['String']>;
  companyPhone?: InputMaybe<Scalars['String']>;
  occupation_type_name: OccupationTypeName;
  since: Scalars['String'];
  /** Field required if OccupationTypeName is TemporaryEmployed */
  to?: InputMaybe<Scalars['String']>;
};

export enum OccupationTypeName {
  EarlyRetiree = 'EarlyRetiree',
  HourlyWorker = 'HourlyWorker',
  PartTimeEmployed = 'PartTimeEmployed',
  Permanent = 'Permanent',
  Retired = 'Retired',
  SelfEmployed = 'SelfEmployed',
  TemporaryEmployed = 'TemporaryEmployed'
}

export type OccurenceDayOf = {
  __typename?: 'OccurenceDayOf';
  maximum: Scalars['Float'];
  mean: Scalars['Int'];
  median: Scalars['Float'];
  minimum: Scalars['Float'];
};

export type Offer = {
  __typename?: 'Offer';
  interest: Scalars['Float'];
  loanAmount: Scalars['Float'];
};

export type OnboardUserForCardFail = {
  __typename?: 'OnboardUserForCardFail';
  code: Scalars['String'];
  reason: OnboardUserForCardFailReason;
};

export enum OnboardUserForCardFailReason {
  CustomerIsPep = 'CUSTOMER_IS_PEP',
  GamblingIncomeBlock = 'GAMBLING_INCOME_BLOCK',
  Unknown = 'UNKNOWN'
}

export type OnboardUserForCardInputV3 = {
  email: Scalars['String'];
  estimatedMonthlyDepositRange: EstimatedMonthlyDepositRange;
  /** ISO 3166-1 alpha-3 country code */
  otherCitizenships?: InputMaybe<Array<Scalars['String']>>;
  phone: Scalars['String'];
  reasonsForUsingCard: Array<CardUsageReason>;
  referredByCode?: InputMaybe<Scalars['String']>;
  sourcesOfFunds: Array<FundsSource>;
};

export type OnboardUserForCardInputV4 = {
  email: Scalars['String'];
  estimatedMonthlyDepositRange: EstimatedMonthlyDepositRangeV2;
  gamblingInfo?: InputMaybe<GamblingInfoInput>;
  /** ISO 3166-1 alpha-3 country code */
  otherCitizenships?: InputMaybe<Array<Scalars['String']>>;
  phone: Scalars['String'];
  reasonsForUsingCard: Array<CardUsageReason>;
  referredByCode?: InputMaybe<Scalars['String']>;
  sourcesOfFunds: Array<FundsSource>;
};

export type OnboardUserForCardInputV5 = {
  email: Scalars['String'];
  estimatedMonthlyDepositRange: EstimatedMonthlyDepositRangeV2;
  gamblingInfo?: InputMaybe<GamblingInfoInput>;
  /** ISO 3166-1 alpha-3 country code */
  otherCitizenships?: InputMaybe<Array<Scalars['String']>>;
  phone: Scalars['String'];
  reasonsForUsingCard: Array<CardUsageReason>;
  referredByCode?: InputMaybe<Scalars['String']>;
  sourcesOfFunds: Array<FundsSource>;
  subscriptionPlan: SubscriptionPlanCode;
};

export type OnboardUserForCardResponse = OnboardUserForCardFail | OnboardUserForCardSuccess;

export type OnboardUserForCardSuccess = {
  __typename?: 'OnboardUserForCardSuccess';
  onboardingId: Scalars['String'];
};

export type OrderCardInput = {
  cardType: CardModel;
  pinType?: InputMaybe<PinType>;
};

export type OriginalLoanPredictionRequest = {
  __typename?: 'OriginalLoanPredictionRequest';
  accommodationType: AccomodationType;
  children: Children;
  existingLoansToConsolidate: Scalars['Int'];
  existingLoansTotalAmount: Scalars['Int'];
  maritalStatus: MaritalStatus;
  monthlyIncome: Scalars['Int'];
  occupationType: OccupationTypeName;
  paymentRemark: Scalars['Boolean'];
};

export type OutOfLimitsUsages = {
  __typename?: 'OutOfLimitsUsages';
  recurring: Array<GrantedUsages>;
};

export enum PageVisit {
  FixedCosts = 'FIXED_COSTS',
  HealthIndex = 'HEALTH_INDEX'
}

export type Participant = {
  __typename?: 'Participant';
  balance: DebtBalance;
  name: Scalars['String'];
  participantId: Scalars['String'];
  status: ParticipantStatus;
};

export type ParticipantDetailed = {
  __typename?: 'ParticipantDetailed';
  balance: DebtBalance;
  invitation?: Maybe<InvitationInfo>;
  name: Scalars['String'];
  participantId: Scalars['String'];
  status: ParticipantStatus;
};

export type ParticipantFilter = {
  status: ParticipantStatusBff;
};

export enum ParticipantStatus {
  Active = 'ACTIVE',
  LeftGroup = 'LEFT_GROUP',
  Passive = 'PASSIVE'
}

export enum ParticipantStatusBff {
  /** Show ACTIVE participants. */
  Active = 'ACTIVE',
  /** Show ACTIVE and PASSIVE participants. */
  ActivePassive = 'ACTIVE_PASSIVE',
  /** Show ACTIVE, PASSIVE and LEFT_GROUP participants. */
  All = 'ALL'
}

export enum PartnerBanks {
  Avida = 'Avida',
  BankNorwegian = 'BankNorwegian',
  Banky = 'Banky',
  Coop = 'Coop',
  Marginalen = 'Marginalen',
  Nordax = 'Nordax',
  Northmill = 'Northmill',
  Nstart = 'Nstart',
  SevenDay = 'SevenDay',
  Svea = 'Svea',
  Unknown = 'Unknown'
}

export type PartnerLoanResponse = {
  __typename?: 'PartnerLoanResponse';
  amortizationPeriod: AmortizationPeriod;
  amount: CurrencyAmount;
  applicationId: Scalars['String'];
  disbursedAt: Scalars['String'];
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  partner: PartnerBanks;
  partnerLink: Scalars['String'];
};

export type PayInvoiceAmountInput = {
  currency: Scalars['String'];
  value: Scalars['Int'];
};

export type PayInvoiceInput = {
  amount: PayInvoiceAmountInput;
  ocr: Scalars['String'];
  ssn: Scalars['String'];
  userId: Scalars['String'];
};

export type PayInvoiceResponse = {
  __typename?: 'PayInvoiceResponse';
  requestId: Scalars['String'];
};

export enum PayInvoiceStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type PayInvoiceStatusResponse = {
  __typename?: 'PayInvoiceStatusResponse';
  status: PayInvoiceStatus;
  token?: Maybe<Scalars['String']>;
};

export type Payer = {
  __typename?: 'Payer';
  /** Date string, last time split bill that was performed with the contact */
  lastUsedAt: Scalars['String'];
  payer: PayerUser;
  /** Total amount of split bills performed with the contact */
  totalTimesUsed: Scalars['Int'];
};

export type PayerName = {
  __typename?: 'PayerName';
  firstNames: Scalars['String'];
  givenName: Scalars['String'];
  lastName: Scalars['String'];
};

export type PayerUser = {
  __typename?: 'PayerUser';
  /** null if the user is not a rocker customer */
  memberId?: Maybe<Scalars['String']>;
  name: PayerName;
  phone: Scalars['String'];
};

export type PayfreeMonthData = {
  __typename?: 'PayfreeMonthData';
  active: Scalars['Boolean'];
  canTake: Scalars['Boolean'];
  dueMonth?: Maybe<Scalars['String']>;
  invoiceStatus: Array<PayfreeMonthInvoiceStatus>;
  newRequiredMonthlyPay?: Maybe<Scalars['String']>;
  nextPossiblePayfreeMonth?: Maybe<Scalars['String']>;
  presentedMonth?: Maybe<Scalars['String']>;
  previousPayfreeMonths: Scalars['Int'];
};

export type PayfreeMonthInvoiceStatus = {
  __typename?: 'PayfreeMonthInvoiceStatus';
  month: Scalars['String'];
  status: Scalars['String'];
};

export type PaymentRequestGroupToBeCreatedV2 = {
  amount: MoneyMinorInput;
  user: PaymentRequestUserInfoV2;
};

export type PaymentRequestUserInfoV2 = {
  name: Scalars['String'];
  phone: Scalars['String'];
  userType: PaymentRequestUserTypeV2;
};

export type PaymentRequestUserTypeV2 = {
  /** memberId is required if userType is Rocker */
  memberId?: InputMaybe<Scalars['String']>;
  userType: UserType;
};

export type PaymentRequestV2 = {
  __typename?: 'PaymentRequestV2';
  amount: MoneyMinor;
  created: Scalars['String'];
  expires: Scalars['String'];
  id: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  payer: SplitPaymentPayerV2;
  status: SplitPaymentStatus;
  updated: Scalars['String'];
};

export type PaymentUpdatesCount = {
  __typename?: 'PaymentUpdatesCount';
  count: Scalars['Int'];
};

export type PaymentsDetails = {
  __typename?: 'PaymentsDetails';
  amount: Scalars['Float'];
  date: Scalars['String'];
};

export type PayoutAccountCreditMethod = {
  foreignBankTransfer: ForeignBankTransfer;
  signature: Scalars['String'];
};

export type PayoutAccountCreditResponse = {
  __typename?: 'PayoutAccountCreditResponse';
  code: Scalars['String'];
  id: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type PendingInvitationSummary = {
  __typename?: 'PendingInvitationSummary';
  created: Scalars['String'];
  groupIcon: Scalars['String'];
  groupName: Scalars['String'];
  id: Scalars['String'];
  participants: Array<Participant>;
};

export type PendingInvitationsResponse = {
  __typename?: 'PendingInvitationsResponse';
  invitations: Array<PendingInvitationSummary>;
};

export type PenserStatus = {
  __typename?: 'PenserStatus';
  isProbablyActivePenserSavingsCustomer: Scalars['Boolean'];
  offboardedAt?: Maybe<Scalars['String']>;
  onboardedAt?: Maybe<Scalars['String']>;
};

/** Graphql can not represent UNION as input. Here, we have either by interval (fromIncl, toIncl) OR by time period (periods) */
export type PeriodFilter = {
  /** Format 2022-12-31 */
  fromIncl?: InputMaybe<Scalars['String']>;
  periodType: PeriodType;
  periods?: InputMaybe<Array<Scalars['String']>>;
  /** Format 2022-12-31 */
  toIncl?: InputMaybe<Scalars['String']>;
};

export enum PeriodType {
  Interval = 'INTERVAL',
  TimePeriods = 'TIME_PERIODS'
}

export enum PeriodUnit {
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type Periodicity = {
  __typename?: 'Periodicity';
  end?: Maybe<Scalars['String']>;
  periodUnit?: Maybe<PeriodUnit>;
  start?: Maybe<Scalars['String']>;
};

export type PersonalDetails = {
  __typename?: 'PersonalDetails';
  children: Children;
  maritalStatus: MaritalStatus;
};

export type PersonalDetailsInput = {
  children: Children;
  maritalStatus: MaritalStatus;
};

export type Phone = {
  __typename?: 'Phone';
  given: Scalars['String'];
};

export type PhysicalCard = Card & {
  __typename?: 'PhysicalCard';
  accountId: Scalars['String'];
  cardRenewalStatus?: Maybe<CardRenewalStatus>;
  customerId: Scalars['String'];
  digitalLayout: CardDigitalLayout;
  expiration?: Maybe<CardExpiration>;
  id: Scalars['String'];
  maskedCardNumber: Scalars['String'];
  model: CardModel;
  pinStatus: PinStatus;
  regionAndEcommBlocking: RegionsAndEcomm;
  status: CardStatus;
};

export enum PinStatus {
  PinIsSet = 'PIN_IS_SET',
  WaitingForPin = 'WAITING_FOR_PIN'
}

export enum PinType {
  CustomerSetPin = 'CUSTOMER_SET_PIN',
  RandomPin = 'RANDOM_PIN'
}

export type PinUrlData = {
  __typename?: 'PinURLData';
  controlId: Scalars['String'];
  url: Scalars['String'];
};

export type Plan = {
  __typename?: 'Plan';
  cancellationPeriod?: Maybe<Interval>;
  code: SubscriptionPlanCode;
  /** Null means no commitment from the user */
  commitmentPeriod: Interval;
  features: Array<PlanFeature>;
  interval: Interval;
  planId: Scalars['String'];
  pricePerInterval: MoneyMinor;
  tier: Scalars['Int'];
};

export type PlanFeature = {
  __typename?: 'PlanFeature';
  code: Scalars['String'];
  configuration: PlanFeatureConfiguration;
};

export type PlanFeatureConfiguration = MaxNumberBased | NumberBased | RecurringQuota | TierBased | Unrestricted;

export type PostAuthResponse = {
  __typename?: 'PostAuthResponse';
  authJwt: Scalars['String'];
  launchInfo: LaunchInfo;
};

export type PredictedInterestRateBounds = {
  __typename?: 'PredictedInterestRateBounds';
  lower: Scalars['Float'];
  upper: Scalars['Float'];
};

export type PredictedMerchant = {
  __typename?: 'PredictedMerchant';
  category?: Maybe<Scalars['String']>;
  contact?: Maybe<Contact>;
  location?: Maybe<Location>;
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  suggestionReference?: Maybe<SuggestionReference>;
};

export type PredictedRecurringTransaction = {
  __typename?: 'PredictedRecurringTransaction';
  accountId?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  description?: Maybe<Description>;
  groupId?: Maybe<Scalars['String']>;
  merchant?: Maybe<PredictedMerchant>;
  predictedAmount?: Maybe<MoneyMinor>;
  predictedDate?: Maybe<Scalars['String']>;
};

export type PredictedRecurringTransactions = {
  __typename?: 'PredictedRecurringTransactions';
  nextPageToken?: Maybe<Scalars['String']>;
  predictedRecurringTransactions: Array<PredictedRecurringTransactionsGroup>;
};

export type PredictedRecurringTransactionsGroup = {
  __typename?: 'PredictedRecurringTransactionsGroup';
  id: Scalars['String'];
  period?: Maybe<RecurringPeriodLabel>;
  transactions?: Maybe<Array<Maybe<PredictedRecurringTransaction>>>;
};

export type PredictedRecurringTxsInput = {
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  pageSize?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
  predictionSpanDays?: InputMaybe<Scalars['Int']>;
};

export type PriceOffer = {
  __typename?: 'PriceOffer';
  matrix?: Maybe<Array<Offer>>;
};

export type PromotionCodeResponse = {
  __typename?: 'PromotionCodeResponse';
  code: Scalars['String'];
};

export enum PromotionCodeType {
  Bookbeat = 'BOOKBEAT',
  Readly = 'READLY'
}

export type PromotionLinkResponse = {
  __typename?: 'PromotionLinkResponse';
  url: Scalars['String'];
};

export enum ProvidersQuery {
  All = 'ALL',
  ExcludeTestProviders = 'EXCLUDE_TEST_PROVIDERS',
  OnlyTestProviders = 'ONLY_TEST_PROVIDERS'
}

export type Purchase = {
  __typename?: 'Purchase';
  merchantId?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['String']>;
  paymentMethod: Scalars['String'];
  price: MonetaryAmount;
  purchasedAt: Scalars['String'];
  transactionId: Scalars['String'];
};

export type PushNotificationsPreferences = {
  __typename?: 'PushNotificationsPreferences';
  hasAchievementPushesEnabled: Scalars['Boolean'];
  hasBudgetPushesEnabled: Scalars['Boolean'];
  hasFinancialHealthScorePushesEnabled: Scalars['Boolean'];
  hasPushesEnabled: Scalars['Boolean'];
};

export type PushNotificationsPreferencesInput = {
  hasAchievementPushesEnabled?: InputMaybe<Scalars['Boolean']>;
  hasBudgetPushesEnabled?: InputMaybe<Scalars['Boolean']>;
  hasFinancialHealthScorePushesEnabled?: InputMaybe<Scalars['Boolean']>;
  hasPushesEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type Query = {
  __typename?: 'Query';
  accountBoxes: Array<AccountBox>;
  accountCheckLink: AccountCheckLinkResponse;
  accountCheckReport: AccountCheckReportResponse;
  accountCreditApplication?: Maybe<AccountCreditApplication>;
  accountCreditIncrease?: Maybe<AccountCreditIncrease>;
  accountCreditInvoices: AccountCreditInvoicesV2;
  accountCreditTransactions: AccountCreditTransactions;
  accountCreditV2?: Maybe<AccountCredit>;
  /** The accounts that belong to this user. Return null if the user needs to be onboarded */
  accounts?: Maybe<Array<Account>>;
  achievements: AchievementsResponse;
  appleInAppProvisioningToken: AppleInAppProvisioningTokenResponse;
  authZendeskUser: AuthZendeskUserResponse;
  /** The current status of the user's auto topup feature. */
  autoTopupStatus: AutoTopupStatus;
  budgetSuggestion: BudgetSuggestion;
  budgetV3?: Maybe<BudgetV3Response>;
  canApplyForAccountCredit: CanApplyForAccountCredit;
  cardAvailability: CardAvailabilityResponse;
  cardFeatures: CardFeatureFlags;
  /** @deprecated Use cardKycAnswersV2 instead */
  cardKycAnswers: CardKycAnswersResponse;
  cardKycAnswersV2: CardKycAnswersResponseV2;
  cardOnboardingStatus: CardOnboardingStatusResponse;
  /** The card PAN data for a specific card that belongs to this user. */
  cardPan: CardPan;
  /**
   * Gets the encryption data (encryption key and control id) used to encrypt the card pin number.
   *
   * @param publicKey The public key used to generate the encryption key.
   */
  cardPinEncryptionData: CardPinEncryptionData;
  cardWithdrawalStatus: CardWithdrawalStatusResponse;
  cardsForWalletExtension: Array<Maybe<CardForWalletExtension>>;
  cashbackReferralV2?: Maybe<CashbackReferralV2>;
  checkEmailVerified: CheckEmailVerifiedResponse;
  commonTransactions: Array<CommonTransaction>;
  comparisons: Array<CompareResult>;
  credentialV2: TinkCredentialV3;
  credentialsV2: Array<TinkCredentialV3>;
  creditDirectDebitAccountStatus: CreditDirectDebitAccountStatusResponse;
  /** Get Credit Space application status. Returns null if no existing application */
  creditSpaceApplication?: Maybe<CreditSpaceApplication>;
  /** Get Credit Space application BankID status. */
  creditSpaceApplicationSigningStatus: CreditSpaceApplicationSigningStatusResponse;
  customerInvoices?: Maybe<CustomerInvoicesResponse>;
  detailedAccess: Array<DetailsAccessDetails>;
  emailSubscription: EmailSubscriptionResponse;
  emailSubscriptionGroupOptions: Array<EmailSubscriptionGroupOption>;
  emailSubscriptionGroups: Array<EmailSubscriptionGroup>;
  feedExpenseChart?: Maybe<AppFeedExpenseChart>;
  /**
   * @deprecated Use accountCreditInvoices instead. Since release 3.21.0
   * @deprecated Use accountCreditInvoices instead
   */
  fetchAccountCreditInvoices?: Maybe<FetchAccountCreditInvoiceResponse>;
  fetchAppleInAppProvisioningToken?: Maybe<AppleInAppProvisioningTokenResponse>;
  fetchApplicationData?: Maybe<FetchApplicationDataResponse>;
  /** @deprecated Use V2 instead. */
  fetchBlocketProducts?: Maybe<FetchBlocketProductsResponse>;
  fetchBlocketProductsV2: BlocketProductsAction;
  fetchMember?: Maybe<MemberInfoResponse>;
  fetchPaymentUpdates: PaymentUpdatesCount;
  fetchSwishPaymentToken?: Maybe<FetchSwishPaymentTokenResponse>;
  financialHealth: FinancialHealthResponse;
  financialInsights: Array<Statistics>;
  /**
   * @deprecated Use accountCreditApplication instead. Since release 3.21.0
   * @deprecated Use accountCreditApplication instead
   */
  getAccountCreditApplication?: Maybe<GetAccountCreditApplicationResponse>;
  getAccountCreditTransactions?: Maybe<GetAccountCreditTransactionsResponse>;
  getAccounts: Array<TinkAccount>;
  getAppAccountCreditApplicationIncrease?: Maybe<AccountCreditIncrease>;
  /** Provide the temporary authentication jwt to get the final one */
  getAuth: GetAuthResponse;
  getAutoTopupBankIdSigntureStatus: AutoTopupBankIdSignatureResponse;
  /**
   * @deprecated Use canApplyForAccountCredit instead. Since release 3.21.0
   * @deprecated Use canApplyForAccountCredit instead
   */
  getCanApplyForAccountCredit?: Maybe<GetCanApplyForAccountCreditResponse>;
  getCashbackV2: CashbackResponse;
  getCashbackV3?: Maybe<CashbackV3Response>;
  getConsentV2: Array<ConsentReviewV2>;
  getCustomerBySSN?: Maybe<GetCustomerBySsnResponse>;
  getGmailSearchQuery: GmailSearchQueryResponse;
  getGoogleStatus?: Maybe<GetGoogleStatusResponse>;
  getImageReceipt: ImageReceipt;
  getInsuranceStatus?: Maybe<GetInsuranceStatusResponse>;
  getLoanTerminationOffer?: Maybe<LoanTerminationAmountResponse>;
  getNotificationPreferences?: Maybe<GetNotificationPreferencesResponse>;
  getRecurringTransactions: RecurringTransactionsResponse;
  getRecurringTransactionsV2: RecurringTransactionsResponseV2;
  getTags: Array<Maybe<Scalars['String']>>;
  getTransaction: TinkTransaction;
  /** @deprecated Use transactionDetails instead */
  getTransactionDetails: HttpTransaction;
  getTransactionReceipts: Array<Maybe<Receipt>>;
  getTransactions: TransactionListResponse;
  getTransactionsV2: SearchAndFilterTransactionsResponse;
  getWalletTokensV2: WalletTokens;
  getWebAccountCredit?: Maybe<AccountCreditData>;
  getWebAccountCreditApplication?: Maybe<WebAccountCreditApplicationResponse>;
  getWebAccountCreditApplicationIncrease?: Maybe<WebAccountCreditApplicationResponse>;
  googleInAppProvisioningToken: DigitizationData;
  groupDebts: GroupDebtsResponse;
  groupDetails: DetailedGroupResponse;
  groupInvitationDetails: DetailedGroupInvitationResponse;
  groupInvitations: PendingInvitationsResponse;
  groupSettlementStatus: GroupSettlementStatusResponse;
  groupTransactionDetails?: Maybe<GroupTransactionDetails>;
  groupTransactionItem?: Maybe<GroupTransaction>;
  groupTransactions: Array<GroupTransaction>;
  groups: GroupResponse;
  groupsCount: GroupsCountResponse;
  inboxMessages: Array<InboxMessage>;
  initiateNotifications: InitiateNotificationsResponse;
  intlAuthUrl: IntlAuthUrl;
  intlCustomer: IntlCustomer;
  intlToken: IntlToken;
  invoicePdf: Scalars['String'];
  isIntlJwtValid: Scalars['Boolean'];
  /** Validate JWT and retrieve its custom claims */
  isJwtValid: CustomClaims;
  /** Get the latest loan prediction for the user; */
  lastLoanPrediction?: Maybe<RangedLoanPredictionResult>;
  listCategory: Array<TinkCategory>;
  loan: CustomerData;
  loanBrokerApplications: Array<LoanBrokerApplicationResponse>;
  loanBrokerQuoteDecision?: Maybe<LoanBrokerQuoteDecisionResponse>;
  loanBrokerQuotes: LoanBrokerQuotesResponse;
  loanBrokerState: LoanBrokerStateResponse;
  loanFeesV2: LoanFeesV2;
  /** Get the current default Loan Prediction model version; */
  loanPredictionModelVersion?: Maybe<LoanPredictionModelVersionDetails>;
  /** Get the loan prediction sequence for all available versions for the user; */
  loanPredictionSequence: Array<RangedLoanPredictionResult>;
  loanTransactionsDescriptions: LoanTransactionsDescriptionsResult;
  member?: Maybe<Member>;
  messageAttachment: Scalars['String'];
  mobileWalletActivationCode: MobileWalletActivationCodeResponse;
  mutualRockerContactsV2: Array<MutualContact>;
  notifications: Array<NotificationEdge>;
  notificationsPreferences: PushNotificationsPreferences;
  partnerLoan: Array<PartnerLoanResponse>;
  payInvoiceStatus: PayInvoiceStatusResponse;
  pinURL: PinUrlData;
  /** All of the available subscription plans */
  plans: Array<Plan>;
  predictedRecurringTransactions?: Maybe<PredictedRecurringTransactions>;
  promotionCode: PromotionCodeResponse;
  promotionLink: PromotionLinkResponse;
  providers: Array<TinkProvider>;
  quickBalance: MoneyMinor;
  quickBalanceToken: Scalars['String'];
  quickInsightsBeta?: Maybe<QuickInsightsBeta>;
  readFirebasePushIdentifierRequest?: Maybe<ReadFirebasePushIdentifierRequest>;
  recurringGroupTransactions: Array<RecurringTransactionGroup>;
  recurringInsights: Array<RecurringInsight>;
  recurringSubscriptionsLinks: Array<RecurringSubscriptionLink>;
  /** Get the remaining loan prediction quota for the user; */
  remainingLoanPredictionQuota?: Maybe<RemainingLoanPredictionQuota>;
  remoteConfig: RemoteConfig;
  /** Replace a card statud */
  replaceCardStatus: ReplaceCardStatusResponse;
  /** Deceptive name. Queries if there is an application, and if there is returns the ID and if it can be resumed or not. */
  resumeApplication?: Maybe<ResumeApplicationResponse>;
  /** Use revolvingCreditTransactionStatus to poll for the status after startRevolvingCredit */
  revolvingCreditTransactionStatus: RevolvingCreditTransactionStatusResponse;
  rockerPayDashboard: RockerPayDashboard;
  rockerPayDebt: RockerPayDebtResponse;
  rockerPayMerchants: Array<RockerPayMerchant>;
  rockerPayOffer?: Maybe<RockerPayOfferExtState>;
  rockerPayPaymentInvoices: RockerPayPaymentInvoicesResponse;
  rockerPayUnpaidInvoices: Array<RockerPayInvoiceWithOffer>;
  rockerToRockerStatus: RockerToRockerStatusResponse;
  root?: Maybe<Scalars['String']>;
  samsungPayProvisioningData: SamsungPayProvisioningData;
  savingsV2AccountTransactions: SavingsV2AccountTransactionsResponse;
  savingsV2Accounts: SavingsV2AccountsResponse;
  savingsV2Buffer: SavingsV2BufferResponse;
  savingsV2DepositStatus: SavingsV2DepositStatusResponse;
  savingsV2KycUpdateStatus: SavingsV2KycUpdateStatusResponse;
  savingsV2MigrationStatus?: Maybe<SavingsV2MigrationStatusResponse>;
  savingsV2OnboardingStatus: SavingsV2OnboardingStatusResponse;
  savingsV2Products: SavingsV2ProductsResponse;
  savingsV2WithdrawalCardStatus: SavingsV2WithdrawalCardStatusResponse;
  savingsV2WithdrawalStatus: SavingsV2WithdrawalStatusResponse;
  /** @deprecated Use searchAndFilterTransactionsV2 instead */
  searchAndFilterTransactions: SearchAndFilterTransactionsResponse;
  searchAndFilterTransactionsV2: SearchAndFilterTransactionsResponseV2;
  sellerBalance?: Maybe<SellerBalance>;
  signDisableInsurance: SignDisableInsuranceResponse;
  similarTransactions: Array<Maybe<TinkTransaction>>;
  /** @deprecated Use similarTransactionsV3 instead */
  similarTransactionsV2: Array<HttpTransaction>;
  similarTransactionsV3: Array<TinkTransactionV2>;
  /** Get the spending analysis poem for a member or return the current status of the poem creation process. */
  spendingAnalysisPoem: SpendingAnalysisPoemResponse;
  splitPaymentGroups: SplitPaymentGroupsV2;
  splitPaymentPayers: Array<Payer>;
  /** The user's current subscription plan. Returns null if the user does not have an active subscription. */
  subscription?: Maybe<Subscription>;
  subscriptionDryRun: SubscriptionDryRunResponse;
  /** @deprecated Use subscriptionOffersV2 instead */
  subscriptionOffers: Array<SubscriptionOffer>;
  subscriptionOffersV2: Array<SubscriptionOfferV2>;
  subscriptionSignatureStatus: SubscriptionSignatureStatusResponse;
  swipeActionTransactions: SwipeActionTransactionsResponse;
  swipeLoanTransactions: SwipeLoanTransactionsResponse;
  swipeTransactions: SwipeTransactionsResponse;
  temporaryPenserStatus: PenserStatus;
  terminationStatus: TerminationStatusResponse;
  transactionDetails: TinkTransactionV2;
  /** The transfers p2p receivers */
  transfersP2PReceivers: Array<TransferParticipantInfo>;
  /** The transfers p2p senders */
  transfersP2PSenders: Array<TransferParticipantInfo>;
  trustlyAccountSelectionStatus: TrustlyAccountSelectionStatusResponse;
  unreadCountMessages: UnreadCountMessagesResponse;
  unreadNotificationCount: Scalars['Int'];
  waitForSwish: WaitForSwishResponse;
  waitForSwishPaymentStatus?: Maybe<WaitForSwishPaymentStatusResponse>;
};


export type QueryAccountCheckLinkArgs = {
  accountCheckInput: AccountCheckInput;
};


export type QueryAccountCheckReportArgs = {
  accountCheckReportInput: AccountCheckReportInput;
};


export type QueryAccountsArgs = {
  filter?: AccountFilter;
  token?: InputMaybe<Scalars['String']>;
};


export type QueryAppleInAppProvisioningTokenArgs = {
  cardId: Scalars['String'];
  inAppProvisioningInput: AppleInAppProvisioningInput;
  testCard?: InputMaybe<AppleWalletTestCard>;
  token: Scalars['String'];
};


export type QueryBudgetV3Args = {
  input: BudgetV3Input;
};


export type QueryCardFeaturesArgs = {
  token: Scalars['String'];
};


export type QueryCardPanArgs = {
  cardId: Scalars['String'];
  token: Scalars['String'];
};


export type QueryCardPinEncryptionDataArgs = {
  publicKey: Scalars['String'];
  token: Scalars['String'];
};


export type QueryCardWithdrawalStatusArgs = {
  payoutId: Scalars['String'];
  token: Scalars['String'];
};


export type QueryCashbackReferralV2Args = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryCheckEmailVerifiedArgs = {
  email: Scalars['String'];
};


export type QueryCommonTransactionsArgs = {
  input: CommonTransactionsInput;
};


export type QueryComparisonsArgs = {
  input: ComparisonsInput;
};


export type QueryCredentialV2Args = {
  credentialId: Scalars['String'];
};


export type QueryCreditDirectDebitAccountStatusArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryCreditSpaceApplicationArgs = {
  token: Scalars['String'];
};


export type QueryCreditSpaceApplicationSigningStatusArgs = {
  token: Scalars['String'];
};


export type QueryCustomerInvoicesArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryDetailedAccessArgs = {
  token: Scalars['String'];
};


export type QueryFetchAccountCreditInvoicesArgs = {
  accountCreditID: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};


export type QueryFetchAppleInAppProvisioningTokenArgs = {
  inAppProvisioningInput: AppleInAppProvisioningInput;
  testCard?: InputMaybe<AppleWalletTestCard>;
  token: Scalars['String'];
};


export type QueryFetchApplicationDataArgs = {
  id: Scalars['String'];
  token: Scalars['String'];
};


export type QueryFetchBlocketProductsArgs = {
  filterUnseen?: InputMaybe<Scalars['Boolean']>;
  memberId: Scalars['String'];
  peek?: InputMaybe<Scalars['Boolean']>;
  token: Scalars['String'];
};


export type QueryFetchBlocketProductsV2Args = {
  filterUnseen?: InputMaybe<Scalars['Boolean']>;
  peek?: InputMaybe<Scalars['Boolean']>;
  token?: InputMaybe<Scalars['String']>;
};


export type QueryFetchMemberArgs = {
  token: Scalars['String'];
};


export type QueryFetchPaymentUpdatesArgs = {
  token: Scalars['String'];
};


export type QueryFetchSwishPaymentTokenArgs = {
  swishPaymentInfo?: InputMaybe<SwishPaymentInfo>;
  token: Scalars['String'];
};


export type QueryFinancialHealthArgs = {
  input: FinancialHealthInput;
};


export type QueryFinancialInsightsArgs = {
  input: FinancialInsightsInput;
};


export type QueryGetAccountCreditApplicationArgs = {
  token: Scalars['String'];
};


export type QueryGetAccountCreditTransactionsArgs = {
  accountCreditID: Scalars['String'];
  token: Scalars['String'];
};


export type QueryGetAccountsArgs = {
  skipCache?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetAuthArgs = {
  token: Scalars['String'];
};


export type QueryGetAutoTopupBankIdSigntureStatusArgs = {
  signatureId: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};


export type QueryGetCanApplyForAccountCreditArgs = {
  token: Scalars['String'];
};


export type QueryGetCashbackV2Args = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryGetConsentV2Args = {
  token: Scalars['String'];
};


export type QueryGetCustomerBySsnArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryGetGmailSearchQueryArgs = {
  token: Scalars['String'];
  transaction: GmailSearchQueryInput;
  transactionId: Scalars['String'];
};


export type QueryGetGoogleStatusArgs = {
  token: Scalars['String'];
};


export type QueryGetImageReceiptArgs = {
  token?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
};


export type QueryGetInsuranceStatusArgs = {
  id?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type QueryGetLoanTerminationOfferArgs = {
  date: Scalars['String'];
  id: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};


export type QueryGetNotificationPreferencesArgs = {
  token: Scalars['String'];
};


export type QueryGetRecurringTransactionsArgs = {
  input: RecurringTxsInput;
};


export type QueryGetRecurringTransactionsV2Args = {
  input: RecurringTxsInput;
};


export type QueryGetTagsArgs = {
  token: Scalars['String'];
};


export type QueryGetTransactionArgs = {
  skipCache?: InputMaybe<Scalars['Boolean']>;
  token: Scalars['String'];
  transactionId: Scalars['String'];
};


export type QueryGetTransactionDetailsArgs = {
  skipCache?: InputMaybe<Scalars['Boolean']>;
  txId: Scalars['String'];
};


export type QueryGetTransactionReceiptsArgs = {
  token: Scalars['String'];
  transactionId: Scalars['String'];
};


export type QueryGetTransactionsArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  skipCache?: InputMaybe<Scalars['Boolean']>;
  token?: InputMaybe<Scalars['String']>;
};


export type QueryGetTransactionsV2Args = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryGetWalletTokensV2Args = {
  cardId: Scalars['String'];
  token: Scalars['String'];
};


export type QueryGoogleInAppProvisioningTokenArgs = {
  cardId: Scalars['String'];
  inAppProvisioningInput: GoogleInAppProvisioningInput;
  token: Scalars['String'];
};


export type QueryGroupDebtsArgs = {
  groupId: Scalars['String'];
};


export type QueryGroupDetailsArgs = {
  groupId: Scalars['String'];
};


export type QueryGroupInvitationDetailsArgs = {
  invitationId: Scalars['String'];
};


export type QueryGroupSettlementStatusArgs = {
  groupId: Scalars['String'];
  settlementId: Scalars['String'];
};


export type QueryGroupTransactionDetailsArgs = {
  foreignTransactionId: Scalars['String'];
};


export type QueryGroupTransactionItemArgs = {
  groupId: Scalars['String'];
  transactionId: Scalars['String'];
};


export type QueryGroupTransactionsArgs = {
  groupId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  olderThanTx?: InputMaybe<Scalars['String']>;
};


export type QueryGroupsArgs = {
  filter?: InputMaybe<ParticipantFilter>;
  onlyWithStatus?: InputMaybe<GroupStatus>;
  skipCache?: InputMaybe<Scalars['Boolean']>;
};


export type QueryIntlAuthUrlArgs = {
  market: Market;
};


export type QueryIntlCustomerArgs = {
  token: Scalars['String'];
};


export type QueryIntlTokenArgs = {
  code: Scalars['String'];
  state: Scalars['String'];
};


export type QueryInvoicePdfArgs = {
  invoiceId: Scalars['String'];
};


export type QueryIsIntlJwtValidArgs = {
  token: Scalars['String'];
};


export type QueryListCategoryArgs = {
  skipCache?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLoanBrokerApplicationsArgs = {
  includeCompleted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLoanBrokerQuoteDecisionArgs = {
  applicationId: Scalars['String'];
};


export type QueryLoanBrokerQuotesArgs = {
  id: Scalars['String'];
};


export type QueryLoanBrokerStateArgs = {
  id: Scalars['String'];
};


export type QueryMemberArgs = {
  token: Scalars['String'];
};


export type QueryMessageAttachmentArgs = {
  input: MessageAttachmentInput;
};


export type QueryMobileWalletActivationCodeArgs = {
  cardId: Scalars['String'];
  token: Scalars['String'];
};


export type QueryMutualRockerContactsV2Args = {
  contacts: MutualContactInput;
  token: Scalars['String'];
};


export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['PaginationCursor']>;
  first: Scalars['Int'];
};


export type QueryPayInvoiceStatusArgs = {
  requestId: Scalars['String'];
};


export type QueryPinUrlArgs = {
  cardId: Scalars['String'];
  token: Scalars['String'];
};


export type QueryPlansArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryPredictedRecurringTransactionsArgs = {
  input: PredictedRecurringTxsInput;
};


export type QueryPromotionCodeArgs = {
  type: PromotionCodeType;
};


export type QueryPromotionLinkArgs = {
  type: PromotionCodeType;
};


export type QueryProvidersArgs = {
  providersQuery?: InputMaybe<ProvidersQuery>;
  skipCache?: InputMaybe<Scalars['Boolean']>;
  token?: InputMaybe<Scalars['String']>;
};


export type QueryQuickBalanceArgs = {
  quickBalanceToken: Scalars['String'];
};


export type QueryQuickBalanceTokenArgs = {
  token: Scalars['String'];
};


export type QueryQuickInsightsBetaArgs = {
  timeZone?: InputMaybe<Scalars['String']>;
};


export type QueryReadFirebasePushIdentifierRequestArgs = {
  token: Scalars['String'];
};


export type QueryRecurringGroupTransactionsArgs = {
  input?: InputMaybe<RecurringGroupTransactionsInput>;
};


export type QueryRecurringInsightsArgs = {
  input: FinancialInsightsInput;
};


export type QueryReplaceCardStatusArgs = {
  input: ReplaceCardStatusInput;
};


export type QueryResumeApplicationArgs = {
  token: Scalars['String'];
};


export type QueryRevolvingCreditTransactionStatusArgs = {
  token?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
};


export type QueryRockerPayOfferArgs = {
  merchantId: Scalars['String'];
  offerId: Scalars['String'];
};


export type QueryRockerPayPaymentInvoicesArgs = {
  merchantId: Scalars['String'];
  paymentId: Scalars['String'];
};


export type QueryRockerPayUnpaidInvoicesArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryRockerToRockerStatusArgs = {
  token: Scalars['String'];
  transferId: Scalars['String'];
};


export type QuerySamsungPayProvisioningDataArgs = {
  data: SamsungPayProvisioningDataInput;
  token: Scalars['String'];
};


export type QuerySavingsV2AccountTransactionsArgs = {
  accountId: Scalars['String'];
  skipCache?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySavingsV2AccountsArgs = {
  skipCache?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySavingsV2DepositStatusArgs = {
  id: Scalars['String'];
};


export type QuerySavingsV2KycUpdateStatusArgs = {
  kycReferenceId: Scalars['String'];
};


export type QuerySavingsV2OnboardingStatusArgs = {
  skipCache?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySavingsV2ProductsArgs = {
  skipCache?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySavingsV2WithdrawalCardStatusArgs = {
  transferId: Scalars['String'];
};


export type QuerySavingsV2WithdrawalStatusArgs = {
  txId: Scalars['String'];
};


export type QuerySearchAndFilterTransactionsArgs = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  from?: InputMaybe<Scalars['String']>;
  includeUpcoming?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderV2?: InputMaybe<SearchTransactionsOrder>;
  query: Scalars['String'];
  skipCache?: InputMaybe<Scalars['Boolean']>;
  sortV2?: InputMaybe<SearchTransactionsSort>;
  until?: InputMaybe<Scalars['String']>;
};


export type QuerySearchAndFilterTransactionsV2Args = {
  input: SearchAndFilterTransactionsV2Input;
};


export type QuerySellerBalanceArgs = {
  token: Scalars['String'];
};


export type QuerySignDisableInsuranceArgs = {
  loanId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


export type QuerySimilarTransactionsArgs = {
  skipCache?: InputMaybe<Scalars['Boolean']>;
  token: Scalars['String'];
  transactionId: Scalars['String'];
};


export type QuerySimilarTransactionsV2Args = {
  transactionId: Scalars['String'];
};


export type QuerySimilarTransactionsV3Args = {
  skipCache?: InputMaybe<Scalars['Boolean']>;
  transactionId: Scalars['String'];
};


export type QuerySpendingAnalysisPoemArgs = {
  request: RequestSpendingAnalysisPoemInput;
};


export type QuerySplitPaymentGroupsArgs = {
  token: Scalars['String'];
  transactionId?: InputMaybe<Scalars['String']>;
};


export type QuerySplitPaymentPayersArgs = {
  token: Scalars['String'];
};


export type QuerySubscriptionArgs = {
  skipCache?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySubscriptionDryRunArgs = {
  input: SubscriptionDryRunInput;
};


export type QuerySubscriptionOffersArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QuerySubscriptionSignatureStatusArgs = {
  signatureId: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};


export type QuerySwipeActionTransactionsArgs = {
  input?: InputMaybe<SwipeLoanTransactionsInput>;
};


export type QuerySwipeLoanTransactionsArgs = {
  input?: InputMaybe<SwipeLoanTransactionsInput>;
};


export type QuerySwipeTransactionsArgs = {
  input?: InputMaybe<SwipeTransactionsInput>;
};


export type QueryTerminationStatusArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryTransactionDetailsArgs = {
  skipCache?: InputMaybe<Scalars['Boolean']>;
  txId: Scalars['String'];
};


export type QueryWaitForSwishArgs = {
  waitForSwishInput: WaitForSwishInput;
};


export type QueryWaitForSwishPaymentStatusArgs = {
  token: Scalars['String'];
};

export type QuickInsightCategorySum = {
  __typename?: 'QuickInsightCategorySum';
  categorySum: CategorySum;
  period: QuickInsightPeriod;
  type: QuickInsightType;
};

export type QuickInsightCommonTransaction = {
  __typename?: 'QuickInsightCommonTransaction';
  commonTransaction: CommonTransaction;
  period: QuickInsightPeriod;
  type: QuickInsightType;
};

export type QuickInsightComparison = {
  __typename?: 'QuickInsightComparison';
  compareWith: Scalars['String'];
  comparison: Comparison;
  reference: Comparison;
  spendingType: SpendingType;
  type: QuickInsightType;
};

export type QuickInsightLargestTransaction = {
  __typename?: 'QuickInsightLargestTransaction';
  largestTransaction: HttpTransaction;
  period: QuickInsightPeriod;
  type: QuickInsightType;
};

export enum QuickInsightPeriod {
  PreviousMonth = 'PREVIOUS_MONTH',
  PreviousWeek = 'PREVIOUS_WEEK',
  PreviousYear = 'PREVIOUS_YEAR'
}

export type QuickInsightRecurringTransaction = {
  __typename?: 'QuickInsightRecurringTransaction';
  estimatedMonthlyExpense: MoneyMinor;
  largestGroup: RecurringTransactionGroup;
  type: QuickInsightType;
};

export enum QuickInsightType {
  CommonExpense = 'COMMON_EXPENSE',
  CompareExpense = 'COMPARE_EXPENSE',
  LargestExpense = 'LARGEST_EXPENSE',
  LargestExpensePrimaryCategory = 'LARGEST_EXPENSE_PRIMARY_CATEGORY',
  RecurringExpense = 'RECURRING_EXPENSE'
}

export type QuickInsightsBeta = QuickInsightCategorySum | QuickInsightCommonTransaction | QuickInsightComparison | QuickInsightLargestTransaction | QuickInsightRecurringTransaction;

export enum QuoteDecision {
  Accepted = 'Accepted',
  Rejected = 'Rejected'
}

export type RangedLoanPredictionResult = {
  __typename?: 'RangedLoanPredictionResult';
  input: OriginalLoanPredictionRequest;
  spans: Array<LoanPredictionResultSpan>;
  version: Scalars['String'];
};

export type RangedLoanPredictionResultSequence = {
  __typename?: 'RangedLoanPredictionResultSequence';
  sequence: Array<RangedLoanPredictionResult>;
};

export type ReachValueAchievementType = {
  __typename?: 'ReachValueAchievementType';
  achievementType: AchievementType;
  value: Scalars['Int'];
};

export type ReadFirebasePushIdentifierAction = {
  __typename?: 'ReadFirebasePushIdentifierAction';
  firebasePushIdentifiers?: Maybe<Array<Maybe<FirebaseIdentifier>>>;
  result?: Maybe<Scalars['String']>;
};

export type ReadFirebasePushIdentifierRequest = GatewayResponse & {
  __typename?: 'ReadFirebasePushIdentifierRequest';
  created?: Maybe<Scalars['String']>;
  msgType?: Maybe<Scalars['String']>;
  partition?: Maybe<Scalars['Int']>;
  payload?: Maybe<ReadFirebasePushIdentifierAction>;
  requestId?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type Receipt = {
  __typename?: 'Receipt';
  mediaType: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['Int'];
  uri: Scalars['String'];
};

export type RecurringGroupInput = {
  includeOutdated?: InputMaybe<Scalars['Boolean']>;
};

export type RecurringGroupTransactionsInput = {
  mock?: InputMaybe<Scalars['Boolean']>;
};

export type RecurringInsight = {
  __typename?: 'RecurringInsight';
  period: Scalars['String'];
  recurringGroupId: Scalars['String'];
  resolution: StatisticsResolution;
  value: Scalars['Float'];
};

export type RecurringPeriodDuration = {
  __typename?: 'RecurringPeriodDuration';
  maximum: Scalars['Int'];
  mean: Scalars['Float'];
  minimum: Scalars['Int'];
  standardDeviation: Scalars['Float'];
};

export enum RecurringPeriodLabel {
  BiMonthly = 'BI_MONTHLY',
  BiWeekly = 'BI_WEEKLY',
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

/** This plan feature i */
export type RecurringQuota = {
  __typename?: 'RecurringQuota';
  quota: Scalars['Int'];
  recurring: RecurringQuotaPeriod;
  type: Scalars['String'];
};

export enum RecurringQuotaPeriod {
  CalendarMonthly = 'CALENDAR_MONTHLY'
}

export type RecurringRemainingUsages = {
  __typename?: 'RecurringRemainingUsages';
  outOf: Scalars['Int'];
  remainingUsages: Scalars['Int'];
  type: Scalars['String'];
};

export type RecurringSubscriptionLink = {
  __typename?: 'RecurringSubscriptionLink';
  id: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type RecurringThresholds = {
  __typename?: 'RecurringThresholds';
  average: Scalars['Float'];
  low: Scalars['Float'];
};

export type RecurringTransaction = {
  __typename?: 'RecurringTransaction';
  accountId: Scalars['String'];
  amount: CurrencyDenominatedAmount;
  categoryId: Scalars['String'];
  date: RecurringTransactionDate;
  description: RecurringTransactionDescription;
  groupId: Scalars['String'];
  merchant?: Maybe<Merchant>;
  transactionId: Scalars['String'];
};

export type RecurringTransactionDate = {
  __typename?: 'RecurringTransactionDate';
  booked: Scalars['String'];
  value: Scalars['String'];
};

export type RecurringTransactionDescription = {
  __typename?: 'RecurringTransactionDescription';
  display: Scalars['String'];
  original: Scalars['String'];
};

export type RecurringTransactionGroup = {
  __typename?: 'RecurringTransactionGroup';
  amount: RecurringTransactionGroupAmount;
  cancellationLink?: Maybe<Scalars['String']>;
  categoryId: Scalars['String'];
  id: Scalars['String'];
  isOutdated: Scalars['Boolean'];
  merchant?: Maybe<Merchant>;
  name: Scalars['String'];
  occurrences: RecurringTransactionGroupOccurrences;
  period: RecurringTransactionGroupPeriod;
};

export type RecurringTransactionGroupAmount = {
  __typename?: 'RecurringTransactionGroupAmount';
  latest: CurrencyDenominatedAmount;
  maximum: CurrencyDenominatedAmount;
  mean: CurrencyDenominatedAmount;
  median: CurrencyDenominatedAmount;
  minimum: CurrencyDenominatedAmount;
  standardDeviation: CurrencyDenominatedAmount;
};

export type RecurringTransactionGroupOccurrences = {
  __typename?: 'RecurringTransactionGroupOccurrences';
  count: Scalars['Int'];
  dayOfMonth?: Maybe<OccurenceDayOf>;
  dayOfWeek?: Maybe<OccurenceDayOf>;
  firstDate: Scalars['String'];
  latestDate: Scalars['String'];
};

export type RecurringTransactionGroupPeriod = {
  __typename?: 'RecurringTransactionGroupPeriod';
  duration: RecurringPeriodDuration;
  label: RecurringPeriodLabel;
};

export type RecurringTransactionsGroup = {
  __typename?: 'RecurringTransactionsGroup';
  id: Scalars['String'];
  period?: Maybe<RecurringPeriodLabel>;
  transactions?: Maybe<Array<Maybe<RecurringTransaction>>>;
};

export type RecurringTransactionsResponse = {
  __typename?: 'RecurringTransactionsResponse';
  nextPageToken: Scalars['String'];
  recurringTransactions: Array<RecurringTransaction>;
};

export type RecurringTransactionsResponseV2 = {
  __typename?: 'RecurringTransactionsResponseV2';
  nextPageToken?: Maybe<Scalars['String']>;
  recurringTransactions?: Maybe<Array<Maybe<RecurringTransactionsGroup>>>;
};

export type RecurringTxsInput = {
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  pageSize?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<Scalars['String']>;
};

export type ReferralProgress = {
  __typename?: 'ReferralProgress';
  referralStatus: ReferralStatus;
  referralType: ReferralType;
  referredByCode: Scalars['String'];
  requirementStatus: ReferralRequirementStatus;
};

export type ReferralRequirementStatus = {
  __typename?: 'ReferralRequirementStatus';
  hasMadeThreePurchases?: Maybe<Scalars['Boolean']>;
  hasSignedUpForRockerCard?: Maybe<Scalars['Boolean']>;
  hasSignedUpForSavings?: Maybe<Scalars['Boolean']>;
  hasUsedTinkConnect?: Maybe<Scalars['Boolean']>;
  subscribedToPlusOrPremium?: Maybe<Scalars['Boolean']>;
};

export enum ReferralStatus {
  Finished = 'FINISHED',
  NotReferred = 'NOT_REFERRED',
  Pending = 'PENDING'
}

export enum ReferralType {
  LegacyCampaign = 'LEGACY_CAMPAIGN',
  PlusOrPremiumSubscriptionCashback = 'PLUS_OR_PREMIUM_SUBSCRIPTION_CASHBACK',
  ReferredByFriendDelayedBonusCampaign = 'REFERRED_BY_FRIEND_DELAYED_BONUS_CAMPAIGN',
  ReferredForCashback = 'REFERRED_FOR_CASHBACK',
  ThreePurchasesCashback = 'THREE_PURCHASES_CASHBACK',
  ThreePurchasesCashbackReduced = 'THREE_PURCHASES_CASHBACK_REDUCED'
}

export type ReferredBonusProgress = {
  __typename?: 'ReferredBonusProgress';
  hasMadeThreePurchases: Scalars['Boolean'];
  hasSignedUpForRockerCard: Scalars['Boolean'];
  hasSignedUpForSavings: Scalars['Boolean'];
  hasUsedTinkConnect: Scalars['Boolean'];
};

export type ReferredBy = {
  __typename?: 'ReferredBy';
  referralCode: Scalars['String'];
  referredBonusProgress: ReferredBonusProgress;
};

export type RefreshCredentialResponse = CardMutationResponse & {
  __typename?: 'RefreshCredentialResponse';
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type RefreshCredentialResponseV2 = {
  __typename?: 'RefreshCredentialResponseV2';
  credentialsId: Scalars['String'];
  result: RefreshCredentialsResponseResult;
};

export type RefreshCredentialsResponse = {
  __typename?: 'RefreshCredentialsResponse';
  success: Scalars['Boolean'];
};

export type RefreshCredentialsResponseResult = {
  __typename?: 'RefreshCredentialsResponseResult';
  reason?: Maybe<Scalars['String']>;
  status: RefreshCrendetialsStatus;
};

export enum RefreshCrendetialsStatus {
  Failure = 'FAILURE',
  NotFound = 'NOT_FOUND',
  Success = 'SUCCESS'
}

export type RefreshProviderResponse = CardMutationResponse & {
  __typename?: 'RefreshProviderResponse';
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type RegionAndEcommBlocking = {
  __typename?: 'RegionAndEcommBlocking';
  regionAndEcommBlocking?: Maybe<RegionsAndEcomm>;
};

export type RegionsAndEcomm = {
  __typename?: 'RegionsAndEcomm';
  africa: Scalars['Boolean'];
  asia: Scalars['Boolean'];
  ecomm: Scalars['Boolean'];
  europe: Scalars['Boolean'];
  home: Scalars['Boolean'];
  northAmerica: Scalars['Boolean'];
  oceania: Scalars['Boolean'];
  southAmerica: Scalars['Boolean'];
};

export type RegionsAndEcommInput = {
  africa: Scalars['Boolean'];
  asia: Scalars['Boolean'];
  ecomm: Scalars['Boolean'];
  europe: Scalars['Boolean'];
  home: Scalars['Boolean'];
  northAmerica: Scalars['Boolean'];
  oceania: Scalars['Boolean'];
  southAmerica: Scalars['Boolean'];
};

export type RegisterDeviceForNotificationsResponse = {
  __typename?: 'RegisterDeviceForNotificationsResponse';
  success: Scalars['Boolean'];
};

export type RejectGroupInvitationResponse = {
  __typename?: 'RejectGroupInvitationResponse';
  success: Scalars['Boolean'];
};

export type RemainingLoanPredictionQuota = {
  __typename?: 'RemainingLoanPredictionQuota';
  nextAvailableAttempt?: Maybe<Scalars['DateTime']>;
  remainingQuota: Scalars['Int'];
};

export type RemainingUsages = {
  __typename?: 'RemainingUsages';
  nonRecurring: Scalars['Int'];
  recurring: Array<RecurringRemainingUsages>;
};

export type RemoteConfig = {
  __typename?: 'RemoteConfig';
  minAppVersion: Scalars['String'];
  offerBanner: Scalars['Boolean'];
};

export enum RenewalStatus {
  DoNotRenew = 'DO_NOT_RENEW',
  Renew = 'RENEW'
}

export type ReplaceCardFreeInput = {
  cardId: Scalars['String'];
  renewalStatus: RenewalStatus;
};

export type ReplaceCardFreeResponse = {
  __typename?: 'ReplaceCardFreeResponse';
  success: Scalars['Boolean'];
};

export type ReplaceCardInput = {
  cardId: Scalars['String'];
  reason: ReplaceCardReason;
  replacementType: ReplacementType;
};

export type ReplaceCardPayload = {
  __typename?: 'ReplaceCardPayload';
  bankIdSigningInfo: BankIdSigningInfo;
  cardReplacementId: Scalars['String'];
};

export enum ReplaceCardReason {
  Lost = 'LOST',
  Other = 'OTHER',
  Stolen = 'STOLEN',
  UnauthorizedTransactions = 'UNAUTHORIZED_TRANSACTIONS'
}

export enum ReplaceCardStatus {
  Completed = 'COMPLETED',
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  PendingSignature = 'PENDING_SIGNATURE',
  SigningFailed = 'SIGNING_FAILED',
  UnexpectedFailure = 'UNEXPECTED_FAILURE'
}

export type ReplaceCardStatusInput = {
  cardId: Scalars['String'];
};

export type ReplaceCardStatusResponse = {
  __typename?: 'ReplaceCardStatusResponse';
  status: ReplaceCardStatus;
};

export enum ReplacementType {
  NewCardInfo = 'NEW_CARD_INFO',
  SameCardInfo = 'SAME_CARD_INFO'
}

export type RequestLoanPredictionInput = {
  accommodationType: AccomodationType;
  children: Children;
  email?: InputMaybe<Scalars['String']>;
  existingLoansToConsolidate: Scalars['Int'];
  existingLoansTotalAmount: Scalars['Int'];
  maritalStatus: MaritalStatus;
  monthlyIncome: Scalars['Int'];
  occupationType: OccupationTypeName;
  paymentRemark: Scalars['Boolean'];
  phone?: InputMaybe<Scalars['String']>;
};

export type RequestMetadata = {
  __typename?: 'RequestMetadata';
  id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
};

export type RequestSpendingAnalysisPoemInput = {
  memberId: Scalars['String'];
  month?: InputMaybe<SpendingAnalysisMonth>;
};

export type ResumeApplicationResponse = LoanApplicationMissing | LoanApplicationResumed | LoanExists | TopupApplicationResumed;

export enum ReviewResponse {
  Approved = 'APPROVED',
  NotAnswered = 'NOT_ANSWERED',
  Rejected = 'REJECTED'
}

export enum RevolvingCreditStatus {
  AwaitingBankIdSignature = 'AWAITING_BANK_ID_SIGNATURE',
  BankIdSigningFailed = 'BANK_ID_SIGNING_FAILED',
  Completed = 'COMPLETED',
  CreditReserved = 'CREDIT_RESERVED',
  RevolvingCreditCredited = 'REVOLVING_CREDIT_CREDITED',
  RevolvingCreditDebited = 'REVOLVING_CREDIT_DEBITED',
  RevolvingCreditFailed = 'REVOLVING_CREDIT_FAILED',
  Signed = 'SIGNED'
}

export type RevolvingCreditTransactionStatusResponse = {
  __typename?: 'RevolvingCreditTransactionStatusResponse';
  status: RevolvingCreditStatus;
  transactionId: Scalars['String'];
};

export type RewardsEarnedThroughReferrals = {
  __typename?: 'RewardsEarnedThroughReferrals';
  cashbackPercentage: Scalars['Float'];
  money: MoneyMinor;
};

export type RockerPayDashboard = {
  __typename?: 'RockerPayDashboard';
  buying: RockerPayItemsByStatus;
  needAction: Array<RockerPayOfferExtState>;
  selling: RockerPayItemsByStatus;
};

export type RockerPayDebt = {
  __typename?: 'RockerPayDebt';
  debt: MoneyMinor;
};

export type RockerPayDebtResponse = {
  __typename?: 'RockerPayDebtResponse';
  debts: Array<RockerPayDebt>;
};

export type RockerPayEngagement = {
  __typename?: 'RockerPayEngagement';
  adminFee: MoneyMinor;
  amortizationPeriodMonths: Scalars['Int'];
  interestRate: Scalars['Float'];
  isPartialPaymentPossible: Scalars['Boolean'];
  setupFee: MoneyMinor;
  totalDebt: MoneyMinor;
  totalPaid: MoneyMinor;
};

export type RockerPayInvoice = {
  __typename?: 'RockerPayInvoice';
  bankgiro: Scalars['String'];
  dueDate: Scalars['String'];
  id: Scalars['String'];
  isAutogiro: Scalars['Boolean'];
  issueDate: Scalars['String'];
  ocr: Scalars['String'];
  paidAmount: MoneyMinor;
  paidDate?: Maybe<Scalars['String']>;
  status: InvoiceStatus;
  totalAmount: MoneyMinor;
};

export type RockerPayInvoiceOffer = {
  __typename?: 'RockerPayInvoiceOffer';
  createdAt?: Maybe<Scalars['String']>;
  escrowValue?: Maybe<MoneyMinor>;
  id: Scalars['String'];
  offerUrl?: Maybe<Scalars['String']>;
  price?: Maybe<MoneyMinor>;
  productType?: Maybe<Scalars['String']>;
  renewedFrom?: Maybe<Scalars['String']>;
  sellerId?: Maybe<Scalars['String']>;
  serviceFeeItems?: Maybe<Array<ServiceFeeItems>>;
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
};

export type RockerPayInvoicePayment = {
  __typename?: 'RockerPayInvoicePayment';
  amount: MoneyMinor;
  createdAt: Scalars['String'];
  id: Scalars['String'];
  merchantId: Scalars['String'];
  offerId: Scalars['String'];
  paymentMethod: RockerPayPaymentMethod;
  status?: Maybe<InvoiceStatus>;
  title: Scalars['String'];
};

export type RockerPayInvoiceWithOffer = {
  __typename?: 'RockerPayInvoiceWithOffer';
  invoice: RockerPayInvoice;
  offer: RockerPayInvoiceOffer;
  payment: RockerPayPayment;
};

export type RockerPayItemsByStatus = {
  __typename?: 'RockerPayItemsByStatus';
  done: Array<RockerPayOfferExtState>;
  ongoing: Array<RockerPayOfferExtState>;
};

export type RockerPayMerchant = {
  __typename?: 'RockerPayMerchant';
  company: RockerPayMerchantCompany;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type RockerPayMerchantCompany = {
  __typename?: 'RockerPayMerchantCompany';
  address: Scalars['String'];
  name: Scalars['String'];
  organizationNumber: Scalars['String'];
  vatRegistrationNumber: Scalars['String'];
};

export type RockerPayOfferExtSelf = {
  __typename?: 'RockerPayOfferExtSelf';
  actionRequired: Scalars['Boolean'];
  done: Scalars['Boolean'];
  role: RockerPaySelfRole;
  status: RockerPayOfferExtStateStatus;
};

export type RockerPayOfferExtState = {
  __typename?: 'RockerPayOfferExtState';
  createdAt: Scalars['String'];
  escrowValue: MoneyMinor;
  id: Scalars['String'];
  merchant?: Maybe<RockerPayMerchant>;
  merchantId: Scalars['String'];
  offerPrice: MoneyMinor;
  payment?: Maybe<RockerPayPayment>;
  payout?: Maybe<RockerPayPayout>;
  self: RockerPayOfferExtSelf;
  status: RockerPayOfferExtStateStatus;
  title: Scalars['String'];
  updatedAt: Scalars['String'];
};

export enum RockerPayOfferExtStateStatus {
  Available = 'AVAILABLE',
  Booked = 'BOOKED',
  DealRefused = 'DEAL_REFUSED',
  FinishedDeleted = 'FINISHED_DELETED',
  FinishedSold = 'FINISHED_SOLD',
  InEscrow = 'IN_ESCROW',
  InPayout = 'IN_PAYOUT',
  MerchandiseAccepted = 'MERCHANDISE_ACCEPTED',
  MerchandiseRejected = 'MERCHANDISE_REJECTED',
  OtherBuyerSelected = 'OTHER_BUYER_SELECTED',
  PayoutBlocked = 'PAYOUT_BLOCKED',
  WaitingOnRenew = 'WAITING_ON_RENEW'
}

export type RockerPayPayment = {
  __typename?: 'RockerPayPayment';
  amount: MoneyMinor;
  buyerId: Scalars['String'];
  id: Scalars['String'];
  merchantId: Scalars['String'];
  offerId?: Maybe<Scalars['String']>;
  pauseState?: Maybe<Scalars['String']>;
  paymentMethod: RockerPayPaymentMethod;
  paymentMethodData?: Maybe<RockerPayPaymentMethodData>;
  payoutConsent: RockerPayPayoutConsent;
  reference?: Maybe<Scalars['String']>;
  sellerId?: Maybe<Scalars['String']>;
  status: RockerPayPaymentStatus;
  title?: Maybe<Scalars['String']>;
};

export type RockerPayPaymentInvoicesResponse = {
  __typename?: 'RockerPayPaymentInvoicesResponse';
  engagement: RockerPayEngagement;
  invoices: Array<RockerPayInvoice>;
  payment: RockerPayInvoicePayment;
};

export enum RockerPayPaymentMethod {
  External = 'EXTERNAL',
  Invoice = 'INVOICE',
  Loan = 'LOAN',
  RockerCard = 'ROCKER_CARD',
  Stripe = 'STRIPE',
  Swish = 'SWISH',
  Trustly = 'TRUSTLY'
}

export type RockerPayPaymentMethodData = {
  __typename?: 'RockerPayPaymentMethodData';
  accountBQID?: Maybe<Scalars['String']>;
  fundingOrganization?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum RockerPayPaymentStatus {
  BookkeepingFailed = 'BOOKKEEPING_FAILED',
  Failed = 'FAILED',
  Init = 'INIT',
  Refunded = 'REFUNDED',
  Settled = 'SETTLED',
  TimedOut = 'TIMED_OUT'
}

export type RockerPayPayout = {
  __typename?: 'RockerPayPayout';
  amount: MoneyMinor;
  customPayoutReference?: Maybe<Scalars['String']>;
  customPayoutReferenceyerId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  merchantId: Scalars['String'];
  paymentId: Scalars['String'];
  payoutAccountId?: Maybe<Scalars['String']>;
  payoutFee: MoneyMinor;
  payoutMethod: RockerPayPayoutMethod;
  serviceFee: MoneyMinor;
  status: RockerPayPayoutStatus;
  userId: Scalars['String'];
};

export enum RockerPayPayoutConsent {
  Blocked = 'BLOCKED',
  Confirmed = 'CONFIRMED',
  Declined = 'DECLINED',
  Undefined = 'UNDEFINED'
}

export enum RockerPayPayoutMethod {
  Autogiro = 'AUTOGIRO',
  RockerCard = 'ROCKER_CARD',
  RockerCardRefund = 'ROCKER_CARD_REFUND',
  Swish = 'SWISH',
  Trustly = 'TRUSTLY'
}

export enum RockerPayPayoutStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export enum RockerPaySelfRole {
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

export enum RockerProduct {
  Checkout = 'Checkout',
  RockerPay = 'RockerPay'
}

export type RockerToRockerStatusResponse = {
  __typename?: 'RockerToRockerStatusResponse';
  status: RockerToRockerStatusValue;
};

export enum RockerToRockerStatusValue {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  WaitingForBankId = 'WAITING_FOR_BANK_ID'
}

export type Ssn = {
  __typename?: 'SSN';
  type: Scalars['String'];
  value: Scalars['String'];
};

export type SamsungPayProvisioningData = {
  __typename?: 'SamsungPayProvisioningData';
  digitizationData: Scalars['String'];
};

export type SamsungPayProvisioningDataInput = {
  cardId: Scalars['String'];
  deviceId: Scalars['String'];
  walletId: Scalars['String'];
};

export type SavingsV2Account = {
  __typename?: 'SavingsV2Account';
  accountId: Scalars['String'];
  accountNumber: Scalars['String'];
  accountState: SavingsV2AccountState;
  accruedInterest: MoneyMinor;
  balance: MoneyMinor;
  interestRatePercentage: Scalars['Float'];
  interestRateTiers: Array<InterestRateTier>;
  name: Scalars['String'];
  productId: Scalars['String'];
  savingsTier: SavingsV2SavingsTier;
};

export enum SavingsV2AccountState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type SavingsV2AccountTransaction = {
  __typename?: 'SavingsV2AccountTransaction';
  accountId: Scalars['String'];
  amount: MoneyMinor;
  createdAt: Scalars['String'];
  id: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  transactionType: SavingsV2AccountTransactionType;
};

export enum SavingsV2AccountTransactionType {
  Deposit = 'Deposit',
  InterestApplied = 'InterestApplied',
  Unknown = 'Unknown',
  Withdrawal = 'Withdrawal'
}

export type SavingsV2AccountTransactionsResponse = {
  __typename?: 'SavingsV2AccountTransactionsResponse';
  transactions: Array<SavingsV2AccountTransaction>;
};

export type SavingsV2AccountsResponse = {
  __typename?: 'SavingsV2AccountsResponse';
  accounts: Array<SavingsV2Account>;
};

export type SavingsV2BufferResponse = {
  __typename?: 'SavingsV2BufferResponse';
  goal: MoneyMinor;
  progress: MoneyMinor;
};

export enum SavingsV2DepositMethod {
  Card = 'CARD',
  Swish = 'SWISH',
  Trustly = 'TRUSTLY'
}

export type SavingsV2DepositMethodPayloadCard = {
  __typename?: 'SavingsV2DepositMethodPayloadCard';
  autoStartToken: Scalars['String'];
  method: SavingsV2DepositMethod;
};

export type SavingsV2DepositMethodPayloadSwish = {
  __typename?: 'SavingsV2DepositMethodPayloadSwish';
  method: SavingsV2DepositMethod;
  token: Scalars['String'];
};

export type SavingsV2DepositMethodPayloadTrustly = {
  __typename?: 'SavingsV2DepositMethodPayloadTrustly';
  method: SavingsV2DepositMethod;
  selectAccountUrl: Scalars['String'];
};

export enum SavingsV2DepositStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type SavingsV2DepositStatusResponse = {
  __typename?: 'SavingsV2DepositStatusResponse';
  status: SavingsV2DepositStatus;
};

export enum SavingsV2KycAnswersDepositAmountPerMonth {
  Between100KAnd300K = 'BETWEEN100K_AND300K',
  Between300KAnd500K = 'BETWEEN300K_AND500K',
  Between500KAnd700K = 'BETWEEN500K_AND700K',
  MoreThan700K = 'MORE_THAN700K',
  To100K = 'TO100K'
}

export enum SavingsV2KycAnswersFrequencyOfDeposit {
  From1To3PerMonth = 'FROM1_TO3_PER_MONTH',
  From3To5PerMonth = 'FROM3_TO5_PER_MONTH',
  From5To7PerMonth = 'FROM5_TO7_PER_MONTH',
  LessThan1PerMonth = 'LESS_THAN1_PER_MONTH',
  MoreThan7PerMonth = 'MORE_THAN7_PER_MONTH'
}

export enum SavingsV2KycAnswersFrequencyOfWithdrawal {
  From1To3PerMonth = 'FROM1_TO3_PER_MONTH',
  From3To5PerMonth = 'FROM3_TO5_PER_MONTH',
  From5To7PerMonth = 'FROM5_TO7_PER_MONTH',
  LessThan1PerMonth = 'LESS_THAN1_PER_MONTH',
  MoreThan7PerMonth = 'MORE_THAN7_PER_MONTH'
}

export type SavingsV2KycAnswersInput = {
  citizenship: Country;
  depositAmountPerMonth: SavingsV2KycAnswersDepositAmountPerMonth;
  frequencyOfDeposit: SavingsV2KycAnswersFrequencyOfDeposit;
  frequencyOfWithdrawal: SavingsV2KycAnswersFrequencyOfWithdrawal;
  pepInformation?: InputMaybe<SavingsV2PepInformationInput>;
  purposeOfSavings: SavingsV2KycAnswersPurposeOfSavings;
  sourceOfFunds: SavingsV2KycAnswersSourceOfFunds;
  taxInformation: SavingsV2TaxInformationInput;
  yearlyIncome: SavingsV2KycAnswersYearlyIncome;
};

export enum SavingsV2KycAnswersPurposeOfSavings {
  FinancialSecurity = 'FINANCIAL_SECURITY',
  Gift = 'GIFT',
  Pension = 'PENSION',
  PrivateConsumption = 'PRIVATE_CONSUMPTION'
}

export enum SavingsV2KycAnswersSourceOfFunds {
  CapitalIncome = 'CAPITAL_INCOME',
  Gift = 'GIFT',
  Income = 'INCOME',
  Inheritance = 'INHERITANCE',
  Lottery = 'LOTTERY',
  Other = 'OTHER'
}

export enum SavingsV2KycAnswersYearlyIncome {
  Between100KAnd300KYearly = 'BETWEEN100K_AND300K_YEARLY',
  Between300KAnd500KYearly = 'BETWEEN300K_AND500K_YEARLY',
  Between500KAnd700KYearly = 'BETWEEN500K_AND700K_YEARLY',
  MoreThan700KYearly = 'MORE_THAN700K_YEARLY',
  To100KYearly = 'TO100K_YEARLY'
}

export enum SavingsV2KycUpdateStatus {
  Signed = 'SIGNED',
  WaitingForSignature = 'WAITING_FOR_SIGNATURE'
}

export type SavingsV2KycUpdateStatusResponse = {
  __typename?: 'SavingsV2KycUpdateStatusResponse';
  kycStatus: SavingsV2KycUpdateStatus;
};

export type SavingsV2LiableForTaxOtherInput = {
  country: Country;
  taxIdentificationNumber: Scalars['String'];
};

export enum SavingsV2MigrationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Pending = 'PENDING'
}

export type SavingsV2MigrationStatusResponse = {
  __typename?: 'SavingsV2MigrationStatusResponse';
  failureReason?: Maybe<Scalars['String']>;
  status: SavingsV2MigrationStatus;
};

export enum SavingsV2OnboardingStatus {
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  NotOnboarded = 'NOT_ONBOARDED',
  PendingSignature = 'PENDING_SIGNATURE'
}

export type SavingsV2OnboardingStatusResponse = {
  __typename?: 'SavingsV2OnboardingStatusResponse';
  status: SavingsV2OnboardingStatus;
};

export enum SavingsV2PepInformationFunction {
  AuditAuthority = 'AUDIT_AUTHORITY',
  CentralBank = 'CENTRAL_BANK',
  DiplomatOrMilitary = 'DIPLOMAT_OR_MILITARY',
  InternationalOrganisation = 'INTERNATIONAL_ORGANISATION',
  Other = 'OTHER',
  Parliament = 'PARLIAMENT',
  StateGovernment = 'STATE_GOVERNMENT',
  StateOrganisation = 'STATE_ORGANISATION',
  SupremeCourt = 'SUPREME_COURT'
}

export type SavingsV2PepInformationInput = {
  country: Country;
  function: SavingsV2PepInformationFunction;
  relation: SavingsV2PepInformationRelation;
};

export enum SavingsV2PepInformationRelation {
  Child = 'CHILD',
  Employee = 'EMPLOYEE',
  Me = 'ME',
  Other = 'OTHER',
  Parent = 'PARENT',
  Partner = 'PARTNER',
  PartnerOfChild = 'PARTNER_OF_CHILD'
}

export type SavingsV2Product = {
  __typename?: 'SavingsV2Product';
  interestRateTiers: Array<InterestRateTier>;
  productId: Scalars['String'];
  productType: SavingsV2ProductType;
  savingsTier: SavingsV2SavingsTier;
};

export enum SavingsV2ProductType {
  Flex = 'FLEX',
  Vault = 'VAULT'
}

export type SavingsV2ProductsResponse = {
  __typename?: 'SavingsV2ProductsResponse';
  products: Array<SavingsV2Product>;
};

export enum SavingsV2SavingsTier {
  Plus = 'PLUS',
  Premium = 'PREMIUM',
  Standard = 'STANDARD'
}

export type SavingsV2TaxInformationInput = {
  liableForTaxInUsa?: InputMaybe<Scalars['String']>;
  liableForTaxInterestIncome: Scalars['Boolean'];
  liableForTaxOther?: InputMaybe<Array<SavingsV2LiableForTaxOtherInput>>;
};

export enum SavingsV2WithdrawalCardStatus {
  AwaitingBankIdSignature = 'AWAITING_BANK_ID_SIGNATURE',
  BankIdSigningFailed = 'BANK_ID_SIGNING_FAILED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Signed = 'SIGNED'
}

export type SavingsV2WithdrawalCardStatusResponse = {
  __typename?: 'SavingsV2WithdrawalCardStatusResponse';
  status: SavingsV2WithdrawalCardStatus;
};

export enum SavingsV2WithdrawalMethod {
  Card = 'CARD',
  SeBankPayout = 'SE_BANK_PAYOUT',
  Trustly = 'TRUSTLY'
}

export type SavingsV2WithdrawalMethodCard = {
  __typename?: 'SavingsV2WithdrawalMethodCard';
  autoStartToken: Scalars['String'];
  method: SavingsV2WithdrawalMethod;
};

export type SavingsV2WithdrawalMethodSeBankPayout = {
  __typename?: 'SavingsV2WithdrawalMethodSEBankPayout';
  method: SavingsV2WithdrawalMethod;
};

export type SavingsV2WithdrawalMethodTrustly = {
  __typename?: 'SavingsV2WithdrawalMethodTrustly';
  method: SavingsV2WithdrawalMethod;
  selectAccountUrl: Scalars['String'];
};

export enum SavingsV2WithdrawalStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type SavingsV2WithdrawalStatusResponse = {
  __typename?: 'SavingsV2WithdrawalStatusResponse';
  status: SavingsV2WithdrawalStatus;
};

export type ScoreThresholds = {
  __typename?: 'ScoreThresholds';
  average: Scalars['Float'];
  high: Scalars['Float'];
  maximum: Scalars['Float'];
  recurringCostRatioThresholds: RecurringThresholds;
  savingsRatioThresholds: Thresholds;
};

export type SearchAndFilterTransactionsResponse = {
  __typename?: 'SearchAndFilterTransactionsResponse';
  count: Scalars['Int'];
  metrics: TransactionListMetrics;
  net: Scalars['Float'];
  periodAmounts: Array<TransactionListPeriodAmount>;
  transactions: Array<HttpTransaction>;
};

export type SearchAndFilterTransactionsResponseV2 = {
  __typename?: 'SearchAndFilterTransactionsResponseV2';
  count: Scalars['Int'];
  metrics: TransactionListMetrics;
  net: Scalars['Float'];
  periodAmounts: Array<TransactionListPeriodAmount>;
  transactions: Array<TinkTransactionV2>;
};

export type SearchAndFilterTransactionsV2Input = {
  accountIds?: InputMaybe<Array<Scalars['String']>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['String']>;
  includeUpcoming?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderV2?: InputMaybe<SearchTransactionsOrder>;
  query: Scalars['String'];
  skipCache?: InputMaybe<Scalars['Boolean']>;
  sortV2?: InputMaybe<SearchTransactionsSort>;
  until?: InputMaybe<Scalars['String']>;
};

export enum SearchTransactionsOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SearchTransactionsSort {
  Account = 'ACCOUNT',
  Amount = 'AMOUNT',
  Category = 'CATEGORY',
  Date = 'DATE',
  Description = 'DESCRIPTION',
  Score = 'SCORE'
}

export enum SelectAccountStatus {
  Done = 'Done',
  Missing = 'Missing',
  Waiting = 'Waiting'
}

export type SellerBalance = {
  __typename?: 'SellerBalance';
  payoutsForMerchants: Array<SellerMerchant>;
  showRockerCardPrompt: Scalars['Boolean'];
  unpaidFunds: MoneyMinor;
};

export enum SellerMerchant {
  Blocket = 'BLOCKET',
  Plick = 'PLICK',
  Unknown = 'UNKNOWN'
}

export type SendApplicationDataInput = {
  accommodation: AccommodationInput;
  amortizationPeriod: AmortizationPeriodInput;
  coApplicantData?: InputMaybe<CoApplicantDataInput>;
  consolidate?: InputMaybe<ConsolidateInput>;
  contactDetails: ContactDetailsInput;
  loanPurpose?: InputMaybe<LoanPurpose>;
  occupation: OccupationInput;
  personalDetails: PersonalDetailsInput;
  totalAmount: MoneyMinorInput;
};

export type SendApplicationDataResponse = {
  __typename?: 'SendApplicationDataResponse';
  id: Scalars['String'];
};

export type SendCreditSpaceApplicationResponse = {
  __typename?: 'SendCreditSpaceApplicationResponse';
  id: Scalars['String'];
};

export type SendQuoteDecisionInput = {
  /** If partnerBank is Avida, user needs to provide the account number */
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  decision: QuoteDecision;
  partnerBank: PartnerBanks;
};

export type SendQuotesDecisionResponse = {
  __typename?: 'SendQuotesDecisionResponse';
  error?: Maybe<Scalars['String']>;
  signingLink?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SendSettlementRemindersResponse = {
  __typename?: 'SendSettlementRemindersResponse';
  success: Scalars['Boolean'];
};

export type SendSettlementRequestResponse = {
  __typename?: 'SendSettlementRequestResponse';
  bankIdSigningInfo: BankIdSigningInfo;
  settlementId: Scalars['String'];
};

export type SendVerificationEmailResponse = {
  __typename?: 'SendVerificationEmailResponse';
  success: Scalars['Boolean'];
};

export type Serial = {
  __typename?: 'Serial';
  amountFirst: MoneyMinor;
  amountLast: MoneyMinor;
};

export type ServiceFeeItems = {
  __typename?: 'ServiceFeeItems';
  name: Scalars['String'];
  value: MoneyMinor;
};

export type SetBudgetResponse = {
  __typename?: 'SetBudgetResponse';
  amount: MonetaryAmount;
  archived: Scalars['Boolean'];
  filter: BudgetFilter;
  id: Scalars['String'];
  name: Scalars['String'];
  periodicity: Periodicity;
  reserveUpcomingRecurringCosts: Scalars['Boolean'];
};

export type SetBudgetV2Input = {
  amount: MonetaryAmountInput;
  reserveUpcomingRecurringCosts?: InputMaybe<Scalars['Boolean']>;
};

export type SetCardPinResponse = {
  __typename?: 'SetCardPinResponse';
  success: Scalars['Boolean'];
};

export type SettleUpRequestInput = {
  debts: Array<HttpDebtThatIOweOthersInput>;
};

export type SignAccountCreditResponse = {
  __typename?: 'SignAccountCreditResponse';
  id: Scalars['String'];
};

export type SignAppAccountCreditApplicationIncreaseResponse = {
  __typename?: 'SignAppAccountCreditApplicationIncreaseResponse';
  bankIdSigningInfo: BankIdSigningInfo;
  id: Scalars['String'];
};

export type SignCreditSpaceApplicationResponse = {
  __typename?: 'SignCreditSpaceApplicationResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SignDisableInsuranceResponse = {
  __typename?: 'SignDisableInsuranceResponse';
  code: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SignWebAccountCreditApplicationIncreaseResponse = {
  __typename?: 'SignWebAccountCreditApplicationIncreaseResponse';
  success: Scalars['Boolean'];
};

export type SignWebAccountCreditApplicationResponse = {
  __typename?: 'SignWebAccountCreditApplicationResponse';
  success: Scalars['Boolean'];
};

export type SimpleHttpTransaction = {
  __typename?: 'SimpleHttpTransaction';
  accountId: Scalars['String'];
  /** eg Privatkonto, Privat Spar, etc */
  accountName?: Maybe<Scalars['String']>;
  amount: CurrencyDenominatedAmount;
  /** eg SEB, Swedbank, etc */
  bankName?: Maybe<Scalars['String']>;
  category?: Maybe<TinkCategory>;
  categoryId: Scalars['String'];
  date: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  merchant?: Maybe<Merchant>;
  metadata?: Maybe<Scalars['Metadata']>;
  originalDescription: Scalars['String'];
  systemTags: Array<Scalars['String']>;
  transactionTags?: Maybe<Array<TransactionTag>>;
};

export type SingleCardTransaction = {
  __typename?: 'SingleCardTransaction';
  transaction: CardTransaction;
};

export type SpendingAnalysisMonth = {
  month: SpendingAnalysisMonthValue;
  year: Scalars['Int'];
};

export enum SpendingAnalysisMonthValue {
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  September = 'SEPTEMBER'
}

export type SpendingAnalysisPoemResponse = {
  __typename?: 'SpendingAnalysisPoemResponse';
  inProgress: Scalars['Boolean'];
  poem?: Maybe<Scalars['String']>;
  prompt: Scalars['String'];
};

export type SpendingType = {
  __typename?: 'SpendingType';
  categoryId: Scalars['String'];
  type: Scalars['String'];
};

export type Split = {
  __typename?: 'Split';
  ratio: Array<CostShare>;
};

export type SplitInput = {
  ratio: Array<CostShareInput>;
};

export type SplitPaymentAnswerResponse = {
  __typename?: 'SplitPaymentAnswerResponse';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SplitPaymentGroupResponseV2 = {
  __typename?: 'SplitPaymentGroupResponseV2';
  id: Scalars['String'];
  name: Scalars['String'];
  paymentRequests: Array<PaymentRequestV2>;
  receiver: SplitPaymentReceiverV2;
  status: SplitPaymentStatus;
  transactions: Array<SplitPaymentTransactionV2>;
};

export type SplitPaymentGroupsV2 = {
  __typename?: 'SplitPaymentGroupsV2';
  groups: Array<SplitPaymentGroupResponseV2>;
};

export type SplitPaymentPayerV2 = {
  __typename?: 'SplitPaymentPayerV2';
  memberId?: Maybe<Scalars['String']>;
  name: CustomerName;
  phone: Scalars['String'];
};

export type SplitPaymentReceiverV2 = {
  __typename?: 'SplitPaymentReceiverV2';
  memberId?: Maybe<Scalars['String']>;
  name: CustomerName;
};

export enum SplitPaymentStatus {
  Canceled = 'CANCELED',
  Ended = 'ENDED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Settled = 'SETTLED'
}

export type SplitPaymentTransactionInputV4 = {
  amount: MoneyMinorInput;
  id: Scalars['String'];
  merchant: CardTransactionMerchantInput;
  transactionDate: Scalars['String'];
};

export type SplitPaymentTransactionV2 = {
  __typename?: 'SplitPaymentTransactionV2';
  amount: MoneyMinor;
  id: Scalars['String'];
  merchant: CardTransactionMerchant;
  transactionDate: Scalars['String'];
};

export type StartCardWithdrawalInput = {
  amount: MoneyMinorInput;
  method: TrustlyPayoutMethod;
  redirectUrl: Scalars['String'];
};

export type StartCardWithdrawalResponse = {
  __typename?: 'StartCardWithdrawalResponse';
  id: Scalars['String'];
  url: Scalars['String'];
};

export type StartRevolvingCreditInput = {
  /** metadata: optional input */
  metadata?: InputMaybe<Array<TransferMetadata>>;
  method: TransferMethodV2;
  money: MoneyMinorInput;
};

export type StartRevolvingCreditResponse = {
  __typename?: 'StartRevolvingCreditResponse';
  bankIdSigningInfo: BankIdSigningInfo;
  transactionId: Scalars['String'];
};

export type StartSwishResponse = {
  __typename?: 'StartSwishResponse';
  code: Scalars['String'];
  success: Scalars['Boolean'];
  token: Scalars['String'];
  transactionId: Scalars['String'];
};

export type Statistics = {
  __typename?: 'Statistics';
  period: Scalars['String'];
  resolution: StatisticsResolution;
  /**
   * Note that the statisticsDataId (description in Tink docs) can represent different things depending on what the query type is
   * for example categoryId for expenses-by-category and accountId for balances-by-account
   */
  statisticsDataId: Scalars['String'];
  type: StatisticsType;
  value: Scalars['Float'];
};

export enum StatisticsResolution {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  MonthlyAdjusted = 'MONTHLY_ADJUSTED',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum StatisticsType {
  BalancesByAccount = 'BALANCES_BY_ACCOUNT',
  BalancesByAccountTypeGroup = 'BALANCES_BY_ACCOUNT_TYPE_GROUP',
  ExpensesByCategory = 'EXPENSES_BY_CATEGORY',
  ExpensesByCategoryByCount = 'EXPENSES_BY_CATEGORY_BY_COUNT',
  ExpensesByPrimaryCategory = 'EXPENSES_BY_PRIMARY_CATEGORY',
  ExpensesByPrimaryCategoryByCount = 'EXPENSES_BY_PRIMARY_CATEGORY_BY_COUNT',
  ExpensesByTag = 'EXPENSES_BY_TAG',
  ExpensesByTagByCount = 'EXPENSES_BY_TAG_BY_COUNT',
  IncomeAndExpenses = 'INCOME_AND_EXPENSES',
  IncomeByCategory = 'INCOME_BY_CATEGORY',
  IncomeByTag = 'INCOME_BY_TAG',
  IncomeByTagByCount = 'INCOME_BY_TAG_BY_COUNT',
  IncomingTransfersByCategory = 'INCOMING_TRANSFERS_BY_CATEGORY',
  IncomingTransfersByCategoryByCount = 'INCOMING_TRANSFERS_BY_CATEGORY_BY_COUNT',
  LeftToSpend = 'LEFT_TO_SPEND',
  LeftToSpendAverage = 'LEFT_TO_SPEND_AVERAGE',
  OutgoingTransfersByCategory = 'OUTGOING_TRANSFERS_BY_CATEGORY',
  OutgoingTransfersByCategoryByCount = 'OUTGOING_TRANSFERS_BY_CATEGORY_BY_COUNT'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** Date when the subscription ends. Null by default means indefinite. */
  endsAt?: Maybe<Scalars['String']>;
  memberId: Scalars['String'];
  nextSubscription?: Maybe<Subscription>;
  plan: Plan;
  startsAt?: Maybe<Scalars['String']>;
  subscriptionId: Scalars['String'];
};

export type SubscriptionDryRunInput = {
  plan: SubscriptionPlanCode;
};

export type SubscriptionDryRunResponse = {
  __typename?: 'SubscriptionDryRunResponse';
  newSubscriptionStartsAt?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['Any']>;
  requiresBankIdSigning?: Maybe<Scalars['Boolean']>;
};

/** The possible feature codes of a subscription plan feature. */
export enum SubscriptionFeatureCode {
  /** Additional cashback percentage */
  BaseCashbackPercentage = 'BASE_CASHBACK_PERCENTAGE',
  /** User can order and have a biometric card. */
  BiometricCard = 'BIOMETRIC_CARD',
  /** User can link other bank accounts */
  ConnectLinkBankAccounts = 'CONNECT_LINK_BANK_ACCOUNTS',
  /** Tiered feature representing increasing interest rates, e.g. tier 1 for freemium, tier 2 for paying customers. */
  InterestRate = 'INTEREST_RATE',
  /** Maximum allowed cashback percentage */
  MaxCashbackPercentage = 'MAX_CASHBACK_PERCENTAGE',
  /** No surcharges for purchases in different currency */
  NoCurrencySurcharge = 'NO_CURRENCY_SURCHARGE',
  /** User can order and have a physical card. */
  PhysicalCard = 'PHYSICAL_CARD',
  /** User can have fixed savings vault */
  SavingsVault = 'SAVINGS_VAULT',
  /** 	User can set pin when ordering a non-virtual card */
  SetPin = 'SET_PIN',
  /** User has travel insurance. */
  TravelInsurance = 'TRAVEL_INSURANCE',
  /** Unknown feature. Usually given when the back-end has added a new fetaure that is not handled yet. */
  Unknown = 'UNKNOWN',
  /** User can upload receipts. May be limited to a fixed number of usages per month. */
  UploadReceipt = 'UPLOAD_RECEIPT',
  /** User can order and have a virtual card */
  VirtualCard = 'VIRTUAL_CARD'
}

export type SubscriptionOffer = {
  __typename?: 'SubscriptionOffer';
  offerCode: SubscriptionOfferCode;
  planCode: Scalars['String'];
};

export enum SubscriptionOfferCode {
  FreeForRockerEmployee = 'FREE_FOR_ROCKER_EMPLOYEE',
  OneMonthFree = 'ONE_MONTH_FREE',
  SixMonthsFree = 'SIX_MONTHS_FREE',
  ThreeMonthsFree = 'THREE_MONTHS_FREE'
}

export type SubscriptionOfferV2 = {
  __typename?: 'SubscriptionOfferV2';
  offerCode: SubscriptionOfferCode;
  planCode: SubscriptionPlanCode;
};

export enum SubscriptionPlanCode {
  Basic = 'BASIC',
  Plus = 'PLUS',
  Premium = 'PREMIUM',
  Unknown = 'UNKNOWN'
}

export enum SubscriptionSignatureStatus {
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Signed = 'SIGNED'
}

export type SubscriptionSignatureStatusResponse = {
  __typename?: 'SubscriptionSignatureStatusResponse';
  status: SubscriptionSignatureStatus;
};

export type SuggestMerchantChangesInput = {
  comment?: InputMaybe<Scalars['String']>;
  problems: Array<MerchantChangesProblem>;
  suggestionReference?: InputMaybe<Scalars['String']>;
};

export type SuggestMerchantChangesResponse = {
  __typename?: 'SuggestMerchantChangesResponse';
  success: Scalars['Boolean'];
};

export type SuggestionReference = {
  __typename?: 'SuggestionReference';
  requestMetadata?: Maybe<RequestMetadata>;
  transactionQueryId?: Maybe<Scalars['String']>;
};

export type Sum = {
  __typename?: 'Sum';
  amount?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

export type SwipeActionTransactionsInput = {
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  until?: InputMaybe<Scalars['String']>;
};

export type SwipeActionTransactionsResponse = {
  __typename?: 'SwipeActionTransactionsResponse';
  actions: Array<ActionTransaction>;
};

export type SwipeLoanTransactionsInput = {
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  until?: InputMaybe<Scalars['String']>;
};

export type SwipeLoanTransactionsResponse = {
  __typename?: 'SwipeLoanTransactionsResponse';
  transactions: Array<SimpleHttpTransaction>;
};

export type SwipeTransactionsInput = {
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
  until?: InputMaybe<Scalars['String']>;
};

export type SwipeTransactionsResponse = {
  __typename?: 'SwipeTransactionsResponse';
  transactions: Array<SimpleHttpTransaction>;
};

export type SwishAmount = {
  currency: Scalars['String'];
  value: Scalars['Int'];
};

export type SwishFailed = {
  __typename?: 'SwishFailed';
  errors: Array<Maybe<SwishPaymentErrorMessage>>;
  type: BlocketPaymentResponseType;
};

export enum SwishMethods {
  AmortizeOnCredit = 'AMORTIZE_ON_CREDIT',
  AmortizeOnLoan = 'AMORTIZE_ON_LOAN',
  SavingsDeposit = 'SAVINGS_DEPOSIT',
  TopUpCard = 'TOP_UP_CARD'
}

export type SwishPaymentCompleted = {
  __typename?: 'SwishPaymentCompleted';
  ocr?: Maybe<Scalars['String']>;
  type: BlocketPaymentResponseType;
};

export enum SwishPaymentErrorMessage {
  FailedToCreatePayment = 'FailedToCreatePayment',
  InvoiceAlreadyPaid = 'InvoiceAlreadyPaid',
  InvoiceExpired = 'InvoiceExpired',
  InvoiceNotFound = 'InvoiceNotFound',
  PaymentCanceled = 'PaymentCanceled',
  PaymentDeclined = 'PaymentDeclined',
  PaymentTimedOut = 'PaymentTimedOut',
  RegistrationFailed = 'RegistrationFailed'
}

export type SwishPaymentInfo = {
  amount: SwishAmount;
  ocr: Scalars['String'];
  paymentType: BlocketPaymentType;
};

export type SwishPaymentStatus = {
  __typename?: 'SwishPaymentStatus';
  type: BlocketPaymentResponseType;
};

export type SwishTokenCreatedResponse = {
  __typename?: 'SwishTokenCreatedResponse';
  token: Scalars['String'];
  type: BlocketPaymentResponseType;
};

export type SwishTransferInput = {
  /** Card account id */
  account?: InputMaybe<Scalars['String']>;
  /** Amount to transfer in MAJOR unit, will be converted to MINOR in the resolver */
  amount: Scalars['Float'];
  id?: InputMaybe<Scalars['String']>;
  method: SwishMethods;
  token?: InputMaybe<Scalars['String']>;
};

export type TagMutationResponse = MutationResponse & {
  __typename?: 'TagMutationResponse';
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum TagType {
  NormalizedDescription = 'NORMALIZED_DESCRIPTION',
  RockerPayOfferRef = 'ROCKER_PAY_OFFER_REF',
  SetBySystem = 'SET_BY_SYSTEM',
  SetByUser = 'SET_BY_USER'
}

export type TerminateCustomerInput = {
  terminationReasons: Array<Scalars['String']>;
};

export type TerminateCustomerResponse = {
  __typename?: 'TerminateCustomerResponse';
  success: Scalars['Boolean'];
};

export enum TerminationStatus {
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type TerminationStatusResponse = {
  __typename?: 'TerminationStatusResponse';
  status: TerminationStatus;
};

export type Thresholds = {
  __typename?: 'Thresholds';
  average: Scalars['Float'];
  high: Scalars['Float'];
};

export type TierBased = {
  __typename?: 'TierBased';
  tier: Scalars['Int'];
  type: Scalars['String'];
};

export type TinkAccount = {
  __typename?: 'TinkAccount';
  accountExclusion: AccountExclusion;
  accountNumber?: Maybe<Scalars['String']>;
  balance: CurrencyDenominatedAmount;
  bankId: Scalars['String'];
  /** @deprecated Use provider field instead */
  bankName?: Maybe<Scalars['String']>;
  certainDate?: Maybe<Scalars['String']>;
  closed?: Maybe<Scalars['Boolean']>;
  /** credential is added in the resolver from the credentialsId */
  credential?: Maybe<TinkCredentialV3>;
  credentialsId: Scalars['String'];
  details?: Maybe<TinkAccountDetails>;
  favored: Scalars['Boolean'];
  financialInstitutionId?: Maybe<Scalars['String']>;
  flags?: Maybe<Scalars['String']>;
  holderName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identifiers?: Maybe<Scalars['String']>;
  images?: Maybe<IconImages>;
  name: Scalars['String'];
  ownership: Scalars['Float'];
  payload?: Maybe<Scalars['String']>;
  /** provider is added in the resolver from the financialInstitutionId */
  provider?: Maybe<TinkProvider>;
  refreshed?: Maybe<Scalars['String']>;
  transferDestinations?: Maybe<Array<TransferDestination>>;
  type: TinkAccountType;
  userId: Scalars['String'];
  userModifiedExcluded: Scalars['Boolean'];
  userModifiedName: Scalars['Boolean'];
  userModifiedType: Scalars['Boolean'];
};

export type TinkAccountDetails = {
  __typename?: 'TinkAccountDetails';
  interest?: Maybe<Scalars['Float']>;
  nextDayOfTermsChange?: Maybe<Scalars['Float']>;
  numMonthsBound?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export enum TinkAccountType {
  Checking = 'CHECKING',
  CreditCard = 'CREDIT_CARD',
  External = 'EXTERNAL',
  Investment = 'INVESTMENT',
  Loan = 'LOAN',
  Mortgage = 'MORTGAGE',
  Other = 'OTHER',
  Pension = 'PENSION',
  Savings = 'SAVINGS'
}

export type TinkCategory = {
  __typename?: 'TinkCategory';
  code: Scalars['String'];
  defaultChild: Scalars['Boolean'];
  id: Scalars['String'];
  parent?: Maybe<Scalars['String']>;
  primaryName?: Maybe<Scalars['String']>;
  searchTerms?: Maybe<Scalars['String']>;
  secondaryName?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
  type: Scalars['String'];
  typeName: Scalars['String'];
};

export type TinkCredential = {
  __typename?: 'TinkCredential';
  displayName: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  providerName: Scalars['String'];
  sessionExpiryDate?: Maybe<Scalars['String']>;
  status: CredentialStatus;
  statusPayload?: Maybe<Scalars['String']>;
  statusUpdated?: Maybe<Scalars['String']>;
  supplementalInformation?: Maybe<Scalars['String']>;
  type?: Maybe<CredentialType>;
  updated?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type TinkCredentialV3 = {
  __typename?: 'TinkCredentialV3';
  id: Scalars['String'];
  provider?: Maybe<TinkProvider>;
  providerName: Scalars['String'];
  sessionExpiryDate?: Maybe<Scalars['String']>;
  status: CredentialStatus;
  statusPayload?: Maybe<Scalars['String']>;
  statusUpdated?: Maybe<Scalars['String']>;
  supplementalInformation?: Maybe<Scalars['String']>;
  type?: Maybe<CredentialType>;
  updated?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type TinkProvider = {
  __typename?: 'TinkProvider';
  accessType: AccessType;
  authenticationFlow?: Maybe<Scalars['String']>;
  authenticationUserType: Scalars['String'];
  capabilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  credentialsType: CredentialType;
  currency: Scalars['String'];
  displayDescription?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  financialInstitutionId: Scalars['String'];
  financialInstitutionName: Scalars['String'];
  groupDisplayName?: Maybe<Scalars['String']>;
  images?: Maybe<IconImages>;
  market: Scalars['String'];
  multiFactor: Scalars['Boolean'];
  name: Scalars['String'];
  passwordHelpText?: Maybe<Scalars['String']>;
  popular: Scalars['Boolean'];
  status: Scalars['String'];
  transactional: Scalars['Boolean'];
  type: Scalars['String'];
};

export enum TinkTheme {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type TinkTransaction = {
  __typename?: 'TinkTransaction';
  accountId: Scalars['String'];
  bankName: Scalars['String'];
  categoryCode: Scalars['String'];
  categoryId: Scalars['String'];
  categoryPrimaryName?: Maybe<Scalars['String']>;
  categorySecondaryName?: Maybe<Scalars['String']>;
  categoryType: CategoryType;
  date: Scalars['String'];
  description: Scalars['String'];
  direction: Direction;
  dispensableAmount?: Maybe<Scalars['String']>;
  entityId: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  hasReceiptAttached: Scalars['Boolean'];
  id: Scalars['String'];
  isRockerExtraTransaction: Scalars['Boolean'];
  isRockerTransaction: Scalars['Boolean'];
  lastModified: Scalars['String'];
  merchant?: Maybe<Merchant>;
  metadata: Scalars['Metadata'];
  notes?: Maybe<Scalars['String']>;
  originalAmount: CurrencyDenominatedAmount;
  originalDate: Scalars['String'];
  originalDescription: Scalars['String'];
  paymentGroup?: Maybe<SplitPaymentGroupResponseV2>;
  pending: Scalars['Boolean'];
  pendingId?: Maybe<Scalars['String']>;
  settlementAmount: CurrencyDenominatedAmount;
  systemTags: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  timestamp: Scalars['String'];
  txType: Scalars['String'];
  upcoming?: Maybe<Scalars['Boolean']>;
  userId: Scalars['String'];
  userModified?: Maybe<Scalars['Boolean']>;
  userSetNotes?: Maybe<Scalars['String']>;
};

export type TinkTransactionV2 = {
  __typename?: 'TinkTransactionV2';
  account?: Maybe<TinkAccount>;
  accountId: Scalars['String'];
  category?: Maybe<TinkCategory>;
  categoryId: Scalars['String'];
  categoryType: CategoryType;
  date: Scalars['String'];
  description: Scalars['String'];
  direction: Direction;
  dispensableAmount?: Maybe<Scalars['Float']>;
  entityId: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  group?: Maybe<GroupSummary>;
  id: Scalars['String'];
  lastModified: Scalars['String'];
  merchant?: Maybe<Merchant>;
  metadata: Scalars['Metadata'];
  notes?: Maybe<Scalars['String']>;
  originalAmount: CurrencyDenominatedAmount;
  originalDate: Scalars['String'];
  originalDescription: Scalars['String'];
  parts?: Maybe<Array<TransactionPart>>;
  pending: Scalars['Boolean'];
  pendingId?: Maybe<Scalars['String']>;
  provider?: Maybe<TinkProvider>;
  settlementAmount: CurrencyDenominatedAmount;
  systemTags: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  timestamp: Scalars['String'];
  transactionTags?: Maybe<Array<TransactionTag>>;
  txType: Scalars['String'];
  upcoming?: Maybe<Scalars['Boolean']>;
  userId: Scalars['String'];
  userModified?: Maybe<Scalars['Boolean']>;
  userSetNotes?: Maybe<Scalars['String']>;
};

export type TopupApplicationResumed = {
  __typename?: 'TopupApplicationResumed';
  id: Scalars['String'];
  locked: Scalars['Boolean'];
};

export type TopupRule = {
  __typename?: 'TopupRule';
  threshold: MoneyMinor;
  topupAmount: MoneyMinor;
};

export enum TopupType {
  TopupFixedAmountWhenBelowThreshold = 'TopupFixedAmountWhenBelowThreshold'
}

export type TotalAmountOffer = {
  __typename?: 'TotalAmountOffer';
  totalAmount: Scalars['Float'];
};

export type Transaction = {
  __typename?: 'Transaction';
  amount?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
};

export type TransactionAmount = {
  __typename?: 'TransactionAmount';
  currency: Scalars['String'];
  value: Scalars['Int'];
};

export type TransactionAmountInput = {
  currency: Scalars['String'];
  value: Scalars['Int'];
};

export type TransactionId = {
  __typename?: 'TransactionId';
  txId: Scalars['String'];
};

export type TransactionListMetrics = {
  __typename?: 'TransactionListMetrics';
  avg: Scalars['String'];
  categories: Scalars['Any'];
  count: Scalars['Int'];
  net: Scalars['Float'];
  sum: Scalars['Float'];
};

export type TransactionListPeriodAmount = {
  __typename?: 'TransactionListPeriodAmount';
  amount?: Maybe<Scalars['Float']>;
  period?: Maybe<Scalars['String']>;
};

export type TransactionListResponse = {
  __typename?: 'TransactionListResponse';
  count: Scalars['Int'];
  metrics: TransactionListMetrics;
  net: Scalars['Float'];
  periodAmounts: Array<TransactionListPeriodAmount>;
  transactions: Array<TinkTransaction>;
};

export enum TransactionMethod {
  General = 'General',
  Points = 'Points',
  Swish = 'Swish'
}

export type TransactionMutationResponse = MutationResponse & {
  __typename?: 'TransactionMutationResponse';
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type TransactionPart = {
  __typename?: 'TransactionPart';
  amount: Scalars['Int'];
  counterpartDescription: Scalars['String'];
  id: Scalars['String'];
  lastModified: Scalars['String'];
};

export type TransactionSplitGroup = {
  __typename?: 'TransactionSplitGroup';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type TransactionTag = {
  __typename?: 'TransactionTag';
  tag?: Maybe<Scalars['String']>;
  tagType?: Maybe<TagType>;
};

export enum TransactionType {
  Cashback = 'Cashback',
  ExtraAmortization = 'ExtraAmortization',
  InvoicePayment = 'InvoicePayment',
  Invoicing = 'Invoicing',
  LoanPayout = 'LoanPayout',
  OwnExpense = 'OwnExpense',
  SetupFee = 'SetupFee',
  SubscriptionFeePlus = 'SubscriptionFeePlus',
  SubscriptionFeePremium = 'SubscriptionFeePremium',
  TransactionFee = 'TransactionFee'
}

export type TransferBetweenParticipants = {
  __typename?: 'TransferBetweenParticipants';
  created: Scalars['String'];
  foreignTransactions: TransferForeignTransactions;
  from: Scalars['String'];
  to: Scalars['String'];
  transactionType: GroupTransactionType;
  transferAmount: MonetaryAmount;
  transferId: Scalars['String'];
};

export enum TransferCurrency {
  Eur = 'EUR',
  Sek = 'SEK'
}

export type TransferDestination = {
  __typename?: 'TransferDestination';
  balance?: Maybe<Scalars['Float']>;
  displayAccountNumber?: Maybe<Scalars['String']>;
  displayBankName?: Maybe<Scalars['String']>;
  matchesMultiple?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type TransferForeignTransactions = {
  __typename?: 'TransferForeignTransactions';
  depositTo: Scalars['String'];
  withdrawalFrom: Scalars['String'];
};

export type TransferMetadata = {
  key: Scalars['String'];
};

export enum TransferMethodNames {
  RevolvingCredit = 'RevolvingCredit',
  RevolvingCreditPaySlowerV2 = 'RevolvingCreditPaySlowerV2',
  Swish = 'Swish'
}

export enum TransferMethodNamesV2 {
  Instant = 'INSTANT',
  PaySlower = 'PAY_SLOWER'
}

export type TransferMethodV2 = {
  name: TransferMethodNamesV2;
  payload?: InputMaybe<TransferPayload>;
};

export type TransferParticipant = {
  __typename?: 'TransferParticipant';
  memberId: Scalars['String'];
  name: Name;
  phone: Scalars['String'];
};

export type TransferParticipantInfo = {
  __typename?: 'TransferParticipantInfo';
  lastUsedAt: Scalars['String'];
  member: TransferParticipant;
  totalTimesUsed: Scalars['Int'];
};

export type TransferPayload = {
  entityId: Scalars['String'];
  tinkTransactionId: Scalars['String'];
};

export type TransferRockerToRockerInput = {
  comment?: InputMaybe<Scalars['String']>;
  money: MoneyMinorInput;
  toMemberId: Scalars['String'];
};

export type TransferRockerToRockerResponse = {
  __typename?: 'TransferRockerToRockerResponse';
  bankIdSigningInfo: BankIdSigningInfo;
  transferId: Scalars['String'];
};

export type TriggerYearlyReviewResponse = {
  __typename?: 'TriggerYearlyReviewResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type TruslyPayload = {
  __typename?: 'TruslyPayload';
  trustlyId: Scalars['String'];
};

export type TrustlyAccountSelectedWithdrawInput = {
  amount: CurrencyAmountInput;
};

export type TrustlyAccountSelectedWithdrawResponse = {
  __typename?: 'TrustlyAccountSelectedWithdrawResponse';
  id: Scalars['String'];
};

export type TrustlyAccountSelectionStatusResponse = {
  __typename?: 'TrustlyAccountSelectionStatusResponse';
  status: SelectAccountStatus;
};

export enum TrustlyPayoutMethod {
  DelayedWithoutFee = 'DELAYED_WITHOUT_FEE',
  InstantWithFee = 'INSTANT_WITH_FEE'
}

export type UcReport = {
  __typename?: 'UcReport';
  customerInfo?: Maybe<UcReportCustomerInfo>;
  debtBalance?: Maybe<UcReportDebtBalance>;
  incomes?: Maybe<Array<Scalars['Any']>>;
  inquiries?: Maybe<UcReportInquiries>;
  otherLoans?: Maybe<UcReportOtherLoans>;
  ownedProperties?: Maybe<UcReportOwnedProperties>;
  remarks?: Maybe<UcReportRemarks>;
  utilizationRate?: Maybe<Scalars['Int']>;
};

export type UcReportCustomerInfo = {
  __typename?: 'UcReportCustomerInfo';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
};

export type UcReportDebtBalance = {
  __typename?: 'UcReportDebtBalance';
  countACases?: Maybe<Scalars['Int']>;
  countECases?: Maybe<Scalars['Int']>;
  sumACases?: Maybe<Scalars['Any']>;
  sumECases?: Maybe<Scalars['Any']>;
};

export type UcReportInquiries = {
  __typename?: 'UcReportInquiries';
  count?: Maybe<Scalars['Int']>;
  inquiries?: Maybe<Array<Scalars['Any']>>;
};

export type UcReportOtherLoans = {
  __typename?: 'UcReportOtherLoans';
  countAccountCredit?: Maybe<Scalars['Int']>;
  countBlanco?: Maybe<Scalars['Int']>;
  countDownPayment?: Maybe<Scalars['Int']>;
  countHouseLoan?: Maybe<Scalars['Int']>;
  countTenantOwner?: Maybe<Scalars['Int']>;
  limitAccountCredit?: Maybe<Scalars['Int']>;
  limitBlanco?: Maybe<Scalars['Int']>;
  limitDownPayment?: Maybe<Scalars['Int']>;
  limitHouseLoan?: Maybe<Scalars['Int']>;
  limitTenantOwner?: Maybe<Scalars['Int']>;
  usedAccountCredit?: Maybe<Scalars['Int']>;
  usedBlanco?: Maybe<Scalars['Int']>;
  usedDownPayment?: Maybe<Scalars['Int']>;
  usedHouseLoan?: Maybe<Scalars['Int']>;
  usedTenantOwner?: Maybe<Scalars['Int']>;
};

export type UcReportOwnedProperties = {
  __typename?: 'UcReportOwnedProperties';
  count?: Maybe<Scalars['Int']>;
};

export type UcReportRemarks = {
  __typename?: 'UcReportRemarks';
  count?: Maybe<Scalars['Int']>;
  sum?: Maybe<Scalars['Int']>;
};

export type UnarchiveGroupResponse = {
  __typename?: 'UnarchiveGroupResponse';
  success: Scalars['Boolean'];
};

export type UnlockAchievementType = {
  __typename?: 'UnlockAchievementType';
  achievementType: AchievementType;
};

export type UnreadCountMessagesResponse = {
  __typename?: 'UnreadCountMessagesResponse';
  unreadCount: Scalars['Int'];
};

export type Unrestricted = {
  __typename?: 'Unrestricted';
  type: Scalars['String'];
};

export type UpdateAccountRequest = {
  accountExclusion?: InputMaybe<AccountExclusion>;
  accountNumber?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<TinkAccountType>;
  favored?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<Scalars['Float']>;
};

export type UpdateAccountResponse = CardMutationResponse & {
  __typename?: 'UpdateAccountResponse';
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type UpdateBudgetResponse = {
  __typename?: 'UpdateBudgetResponse';
  success: Scalars['Boolean'];
};

export type UpdateCardKycInput = {
  estimatedMonthlyDepositRange?: InputMaybe<EstimatedMonthlyDepositRange>;
  otherCitizenships?: InputMaybe<Array<Scalars['String']>>;
  reasonsForUsingCard?: InputMaybe<Array<CardUsageReason>>;
  sourcesOfFunds?: InputMaybe<Array<FundsSource>>;
};

export type UpdateCardKycInputV2 = {
  estimatedMonthlyDepositRange?: InputMaybe<EstimatedMonthlyDepositRangeV2>;
  gamblingInfo?: InputMaybe<GamblingInfoInput>;
  otherCitizenships?: InputMaybe<Array<Scalars['String']>>;
  reasonsForUsingCard?: InputMaybe<Array<CardUsageReason>>;
  sourcesOfFunds?: InputMaybe<Array<FundsSource>>;
};

export type UpdateCardKycResponse = {
  __typename?: 'UpdateCardKycResponse';
  success: Scalars['Boolean'];
};

export type UpdateCustomerInfoResponse = GatewayResponse & {
  __typename?: 'UpdateCustomerInfoResponse';
  action?: Maybe<CustomerInfo>;
  created?: Maybe<Scalars['String']>;
  msgType?: Maybe<Scalars['String']>;
  partition?: Maybe<Scalars['Int']>;
  requestId?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type UpdateCustomerInfoV2Response = {
  __typename?: 'UpdateCustomerInfoV2Response';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type UpdateGroupExpenseResponse = {
  __typename?: 'UpdateGroupExpenseResponse';
  success: Scalars['Boolean'];
};

export type UpdateRegionsAndEcommInput = {
  cardId: Scalars['String'];
  regionsAndEcomm: RegionsAndEcommInput;
};

export type UpdateSavingsV2KycInput = {
  depositAmountPerMonth: SavingsV2KycAnswersDepositAmountPerMonth;
  frequencyOfDeposit: SavingsV2KycAnswersFrequencyOfDeposit;
  frequencyOfWithdrawal: SavingsV2KycAnswersFrequencyOfWithdrawal;
  purposeOfSavings: SavingsV2KycAnswersPurposeOfSavings;
  sourceOfFunds: SavingsV2KycAnswersSourceOfFunds;
  taxInformation: SavingsV2TaxInformationInput;
};

export type UpdateSavingsV2KycRequestInput = {
  kyc: UpdateSavingsV2KycInput;
  tier: SavingsV2SavingsTier;
};

export type UpdateSavingsV2KycResponse = {
  __typename?: 'UpdateSavingsV2KYCResponse';
  autoStartToken: Scalars['String'];
  kycReferenceId: Scalars['String'];
};

export type UpdateTransactionInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Direction>;
  metadata?: InputMaybe<Scalars['Metadata']>;
  notes?: InputMaybe<Scalars['String']>;
};

export type UpdateTransactionTagsResponse = {
  __typename?: 'UpdateTransactionTagsResponse';
  success: Scalars['Boolean'];
};

export type UsedAmount = {
  __typename?: 'UsedAmount';
  amount: Scalars['Float'];
  currency: Scalars['String'];
  unit?: Maybe<MonetaryAmountUnit>;
};

export type UserClaims = {
  __typename?: 'UserClaims';
  member_id: Scalars['String'];
  ssn: Scalars['String'];
};

export enum UserType {
  External = 'External',
  Rocker = 'Rocker'
}

export type UtmTracking = {
  trackingUrl: Scalars['String'];
};

export type ValidationErrorDetails = InvalidExistingLoansToConsolidate | InvalidExistingLoansTotalAmount | InvalidMonthlyIncome;

export type VerifyCodeEmailResponse = {
  __typename?: 'VerifyCodeEmailResponse';
  to: Scalars['String'];
  verifiedAt: Scalars['String'];
};

export type VirtualCard = Card & {
  __typename?: 'VirtualCard';
  accountId: Scalars['String'];
  cardRenewalStatus?: Maybe<CardRenewalStatus>;
  customerId: Scalars['String'];
  digitalLayout: CardDigitalLayout;
  expiration?: Maybe<CardExpiration>;
  id: Scalars['String'];
  maskedCardNumber: Scalars['String'];
  model: CardModel;
  regionAndEcommBlocking: RegionsAndEcomm;
  status: CardStatus;
};

export type WaitForSwishInput = {
  method: SwishMethods;
  rest?: InputMaybe<Scalars['Boolean']>;
  token?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type WaitForSwishPaymentStatusResponse = {
  __typename?: 'WaitForSwishPaymentStatusResponse';
  errors?: Maybe<Array<Maybe<SwishPaymentErrorMessage>>>;
  message?: Maybe<BlocketPaymentResponseType>;
};

export type WaitForSwishResponse = {
  __typename?: 'WaitForSwishResponse';
  code: Scalars['String'];
  /** If using "rest", this is the status of the current swish transaction. "null" if not using "rest". */
  status?: Maybe<WaitForSwishStatus>;
  success: Scalars['Boolean'];
};

export enum WaitForSwishStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  RefundFailed = 'REFUND_FAILED',
  RefundRequested = 'REFUND_REQUESTED',
  Successful = 'SUCCESSFUL'
}

export enum WalletProvider {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  M4M = 'M4M',
  Samsung = 'SAMSUNG',
  Unknown = 'UNKNOWN'
}

export type WalletToken = {
  __typename?: 'WalletToken';
  tokenUniqueReferenceId: Scalars['String'];
  walletProvider: WalletProvider;
};

export type WalletTokens = {
  __typename?: 'WalletTokens';
  tokens?: Maybe<Array<WalletToken>>;
};

export type WebAccountCreditApplicationResponse = {
  __typename?: 'WebAccountCreditApplicationResponse';
  address?: Maybe<Address>;
  contactInformation?: Maybe<AccountContactInformation>;
  created: Scalars['String'];
  creditLimit?: Maybe<CreditLimit>;
  effectiveInterestRate?: Maybe<Scalars['Float']>;
  fundingOrganization?: Maybe<FundingOrganization>;
  id: Scalars['String'];
  interestRate?: Maybe<Scalars['Float']>;
  loanNumber?: Maybe<Scalars['String']>;
  signedContractDate?: Maybe<Scalars['String']>;
  ssn?: Maybe<Identity>;
  status: Scalars['String'];
};

export type GetAccountCreditApplicationResponse = {
  __typename?: 'getAccountCreditApplicationResponse';
  address?: Maybe<Address>;
  contactInformation?: Maybe<ContactInformation>;
  created?: Maybe<Scalars['String']>;
  creditLimit?: Maybe<CreditLimit>;
  effectiveInterestRate?: Maybe<Scalars['Float']>;
  fundingOrganization?: Maybe<FundingOrganization>;
  id: Scalars['ID'];
  interestRate?: Maybe<Scalars['Float']>;
  loanNumber?: Maybe<Scalars['String']>;
  signedContractDate?: Maybe<Scalars['String']>;
  ssn?: Maybe<Ssn>;
  status?: Maybe<ApplicationStatus>;
};

export type GetAccountCreditTransactionsResponse = GatewayResponse & {
  __typename?: 'getAccountCreditTransactionsResponse';
  action?: Maybe<AccountCreditTransactions>;
  created: Scalars['String'];
  msgType: Scalars['String'];
  partition: Scalars['Int'];
  requestId: Scalars['String'];
  user: Scalars['String'];
};

export type GetCanApplyForAccountCreditResponse = GatewayResponse & {
  __typename?: 'getCanApplyForAccountCreditResponse';
  action?: Maybe<CanApplyForAccountCredit>;
  created?: Maybe<Scalars['String']>;
  msgType?: Maybe<Scalars['String']>;
  partition?: Maybe<Scalars['Int']>;
  requestId?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type GetCustomerBySsnResponse = GatewayResponse & {
  __typename?: 'getCustomerBySSNResponse';
  action?: Maybe<CustomerData>;
  created?: Maybe<Scalars['String']>;
  msgType?: Maybe<Scalars['String']>;
  partition?: Maybe<Scalars['Int']>;
  requestId?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type GetNotificationPreferencesResponse = GatewayResponse & {
  __typename?: 'getNotificationPreferencesResponse';
  created?: Maybe<Scalars['String']>;
  msgType?: Maybe<Scalars['String']>;
  partition?: Maybe<Scalars['Int']>;
  payload?: Maybe<NotificationPreferencesPayload>;
  requestId?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type CreateNewApplicationMutationVariables = Exact<{
  adtractionId?: InputMaybe<Scalars['String']>;
  adwordsId?: InputMaybe<Scalars['String']>;
}>;


export type CreateNewApplicationMutation = { __typename?: 'Mutation', createNewApplication: { __typename?: 'CreateNewApplicationResponse', applicationId: string, mayApply: boolean } };

export type LoanBrokerApplicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoanBrokerApplicationsQuery = { __typename?: 'Query', loanBrokerApplications: Array<{ __typename?: 'LoanBrokerApplicationResponse', applicationId: string, status: LoanApplicationStatus, createdAt: string }> };

export type SendApplicationDataMutationVariables = Exact<{
  id: Scalars['String'];
  input: SendApplicationDataInput;
}>;


export type SendApplicationDataMutation = { __typename?: 'Mutation', sendApplicationData: { __typename?: 'SendApplicationDataResponse', id: string } };

export type LoanPredictionMutationVariables = Exact<{
  request: RequestLoanPredictionInput;
}>;


export type LoanPredictionMutation = { __typename?: 'Mutation', loanPrediction: { __typename: 'LoanPredictionQuotaExceeded', message: string } | { __typename: 'LoanPredictionValidationError' } | { __typename: 'RangedLoanPredictionResult', version: string, spans: Array<{ __typename?: 'LoanPredictionResultSpan', amount: number, loanPrediction: { __typename?: 'LoanPredictionResult', likelihood: number, bounds: { __typename?: 'PredictedInterestRateBounds', lower: number, upper: number } } }>, input: { __typename?: 'OriginalLoanPredictionRequest', maritalStatus: MaritalStatus, children: Children, accommodationType: AccomodationType, occupationType: OccupationTypeName, monthlyIncome: number, paymentRemark: boolean, existingLoansToConsolidate: number, existingLoansTotalAmount: number } } };

export type LoanPredictionModelVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type LoanPredictionModelVersionQuery = { __typename?: 'Query', loanPredictionModelVersion?: { __typename: 'LoanPredictionModelVersionDetails', version: string, releaseDate: any, accuracy: number, isDefault: boolean } | null };

export type FetchMemberQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type FetchMemberQuery = { __typename?: 'Query', fetchMember?: { __typename?: 'MemberInfoResponse', payload?: { __typename?: 'MemberInfo', user: { __typename?: 'Member', preferredName?: string | null, firstName?: string | null, id: string } } | null } | null };

export type LoanBrokerApplicationDetailsQueryVariables = Exact<{
  includeCompleted?: InputMaybe<Scalars['Boolean']>;
}>;


export type LoanBrokerApplicationDetailsQuery = { __typename?: 'Query', loanBrokerApplications: Array<{ __typename?: 'LoanBrokerApplicationResponse', applicationId: string, status: LoanApplicationStatus, createdAt: string, updatedAt?: string | null, applicationData?: { __typename?: 'LoanApplicationData', loanPurpose?: LoanPurpose | null, totalAmount: { __typename?: 'MoneyMinor', amount: any, currency: string, unit: string }, consolidate?: { __typename?: 'Consolidate', ofTotalToConsolidate: { __typename?: 'MoneyMinor', amount: any, currency: string, unit: string } } | null, amortizationPeriod: { __typename?: 'AmortizationPeriod', length: number, chronoUnit: { __typename?: 'ChronoUnitField', name: ChronoUnit } }, contactDetails: { __typename?: 'ContactDetails', phoneNumber: string, email: string }, personalDetails: { __typename?: 'PersonalDetails', maritalStatus: MaritalStatus, children: Children }, accommodation: { __typename?: 'Accommodation', accommodationType: AccomodationType, monthlyCost: { __typename?: 'MoneyMinor', amount: any, currency: string, unit: string } }, occupation: { __typename?: 'Occupation', occupationType: { __typename?: 'OccupationType', occupation_type_name: OccupationTypeName, companyName?: string | null, companyPhone?: string | null, since: string, to?: string | null }, monthlyIncome: { __typename?: 'MoneyMinor', amount: any, currency: string, unit: string } }, coApplicantData?: { __typename?: 'CoApplicantApplicationData', contactDetails: { __typename?: 'ContactDetails', phoneNumber: string, email: string }, personalDetails: { __typename?: 'PersonalDetails', maritalStatus: MaritalStatus, children: Children }, accommodation: { __typename?: 'Accommodation', accommodationType: AccomodationType, monthlyCost: { __typename?: 'MoneyMinor', amount: any, currency: string, unit: string } }, occupation: { __typename?: 'Occupation', occupationType: { __typename?: 'OccupationType', occupation_type_name: OccupationTypeName, companyName?: string | null, companyPhone?: string | null, since: string, to?: string | null }, monthlyIncome: { __typename?: 'MoneyMinor', amount: any, currency: string, unit: string } } } | null } | null }> };

export type LoanBrokerQuotesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type LoanBrokerQuotesQuery = { __typename?: 'Query', loanBrokerQuotes: { __typename?: 'LoanBrokerQuotesResponse', pending: number, quotes?: Array<{ __typename?: 'LoanBrokerQuote', partnerBank: PartnerBanks, interestRateNominal: number, interestRateEffective: number, validTo?: string | null, amount: { __typename?: 'MoneyMinor', amount: any, currency: string, unit: string }, amortizationPeriod: { __typename?: 'AmortizationPeriod', length: number, chronoUnit: { __typename?: 'ChronoUnitField', name: ChronoUnit } }, amountToSolveExternal?: { __typename?: 'MoneyMinor', amount: any, currency: string, unit: string } | null, monthlyInstallment: { __typename: 'Annuity', amount: { __typename?: 'MoneyMinor', amount: any, currency: string, unit: string } } | { __typename: 'Serial', amountFirst: { __typename?: 'MoneyMinor', amount: any, currency: string, unit: string }, amountLast: { __typename?: 'MoneyMinor', amount: any, currency: string, unit: string } }, setupFee: { __typename?: 'MoneyMinor', amount: any, currency: string, unit: string }, monthlyFee: { __typename?: 'MoneyMinor', amount: any, currency: string, unit: string }, totalCost: { __typename?: 'MoneyMinor', amount: any, currency: string, unit: string }, conditions?: Array<{ __typename: 'CoApplicant', CoApplicant: { __typename?: 'CoApplicantData', message: string, complements?: Array<{ __typename?: 'Message', text: string }> | null } } | { __typename: 'Complements', Complements: { __typename?: 'ComplementsData', values?: Array<{ __typename?: 'Message', text: string }> | null } } | { __typename: 'ConsolidateDebts', ConsolidateDebts: { __typename?: 'ConsolidateDebtsData', amount: { __typename?: 'CurrencyAmount', amount: number, currency: string } } }> | null }> | null } };

export type LoanBrokerApplicationStateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type LoanBrokerApplicationStateQuery = { __typename?: 'Query', loanBrokerState: { __typename?: 'LoanBrokerStateResponse', done: boolean } };

export type LoanBrokerQuoteDecisionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type LoanBrokerQuoteDecisionQuery = { __typename?: 'Query', loanBrokerQuoteDecision?: { __typename?: 'LoanBrokerQuoteDecisionResponse', partnerBank: PartnerBanks, signingLink?: string | null } | null };

export type CancelApplicationMutationVariables = Exact<{
  applicationId: Scalars['String'];
}>;


export type CancelApplicationMutation = { __typename?: 'Mutation', cancelApplication?: any | null };

export type SendQuotesDecisionMutationVariables = Exact<{
  applicationId: Scalars['String'];
  input: SendQuoteDecisionInput;
}>;


export type SendQuotesDecisionMutation = { __typename?: 'Mutation', sendQuotesDecision?: { __typename?: 'SendQuotesDecisionResponse', success: boolean, signingLink?: string | null, error?: string | null } | null };

export type LastLoanPredictionQueryVariables = Exact<{ [key: string]: never; }>;


export type LastLoanPredictionQuery = { __typename?: 'Query', lastLoanPrediction?: { __typename: 'RangedLoanPredictionResult', input: { __typename?: 'OriginalLoanPredictionRequest', maritalStatus: MaritalStatus, children: Children, accommodationType: AccomodationType, occupationType: OccupationTypeName, monthlyIncome: number, paymentRemark: boolean, existingLoansToConsolidate: number, existingLoansTotalAmount: number }, spans: Array<{ __typename?: 'LoanPredictionResultSpan', amount: number, loanPrediction: { __typename?: 'LoanPredictionResult', likelihood: number, bounds: { __typename?: 'PredictedInterestRateBounds', lower: number, upper: number } } }> } | null };

export type InitAuthMutationVariables = Exact<{ [key: string]: never; }>;


export type InitAuthMutation = { __typename?: 'Mutation', postAuth: { __typename?: 'PostAuthResponse', authJwt: string, launchInfo: { __typename?: 'LaunchInfo', autoStartToken?: string | null, qrAuthData?: string | null } } };

export type GetAuthStatusQueryVariables = Exact<{
  authJwt: Scalars['String'];
}>;


export type GetAuthStatusQuery = { __typename?: 'Query', getAuth: { __typename?: 'GetAuthResponse', status: AuthStatus, qrAuthData?: string | null, rockerJwt?: string | null } };

export type PartnerLoanQueryVariables = Exact<{ [key: string]: never; }>;


export type PartnerLoanQuery = { __typename?: 'Query', partnerLoan: Array<{ __typename?: 'PartnerLoanResponse', id: string, partner: PartnerBanks, disbursedAt: string, partnerLink: string, applicationId: string, amount: { __typename?: 'CurrencyAmount', amount: number, currency: string }, amortizationPeriod: { __typename?: 'AmortizationPeriod', length: number, chronoUnit: { __typename?: 'ChronoUnitField', name: ChronoUnit } } }> };

export type InitAuthForSsnMutationVariables = Exact<{
  ssn: Scalars['String'];
}>;


export type InitAuthForSsnMutation = { __typename?: 'Mutation', postAuth: { __typename?: 'PostAuthResponse', authJwt: string } };

export type GetAuthForSsnStatusQueryVariables = Exact<{
  authJwt: Scalars['String'];
}>;


export type GetAuthForSsnStatusQuery = { __typename?: 'Query', getAuth: { __typename?: 'GetAuthResponse', status: AuthStatus, rockerJwt?: string | null } };

export type AddWebAccountCreditApplicationMutationVariables = Exact<{
  input: ApplyForAccountCreditInput;
}>;


export type AddWebAccountCreditApplicationMutation = { __typename?: 'Mutation', addWebAccountCreditApplication?: { __typename?: 'AddWebAccountCreditApplicationResponse', decision?: string | null } | null };

export type SignWebAccountCreditApplicationMutationVariables = Exact<{ [key: string]: never; }>;


export type SignWebAccountCreditApplicationMutation = { __typename?: 'Mutation', signWebAccountCreditApplication: { __typename?: 'SignWebAccountCreditApplicationResponse', success: boolean } };

export type AddWebAccountCreditApplicationIncreaseMutationVariables = Exact<{
  input: ApplyForAccountCreditInput;
}>;


export type AddWebAccountCreditApplicationIncreaseMutation = { __typename?: 'Mutation', addWebAccountCreditApplicationIncrease?: { __typename?: 'AddWebAccountCreditApplicationResponse', decision?: string | null } | null };

export type SignWebAccountCreditApplicationIncreaseMutationVariables = Exact<{ [key: string]: never; }>;


export type SignWebAccountCreditApplicationIncreaseMutation = { __typename?: 'Mutation', signWebAccountCreditApplicationIncrease: { __typename?: 'SignWebAccountCreditApplicationIncreaseResponse', success: boolean } };

export type GetWebAccountCreditQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebAccountCreditQuery = { __typename?: 'Query', getWebAccountCredit?: { __typename?: 'AccountCreditData', status: AccountCreditStatus } | null };

export type GetWebAccountCreditApplicationIncreaseQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebAccountCreditApplicationIncreaseQuery = { __typename?: 'Query', getWebAccountCreditApplicationIncrease?: { __typename: 'WebAccountCreditApplicationResponse', status: string, created: string, effectiveInterestRate?: number | null, fundingOrganization?: FundingOrganization | null, id: string, interestRate?: number | null, loanNumber?: string | null, signedContractDate?: string | null, address?: { __typename: 'Address', city: string, street: string, streetExtra: string, streetExtra2: string, zip: string } | null, ssn?: { __typename?: 'Identity', value?: string | null } | null, contactInformation?: { __typename: 'AccountContactInformation', email?: { __typename?: 'EmailAddress', value?: string | null } | null, phone?: { __typename?: 'MobilePhoneNumber', given?: string | null } | null } | null, creditLimit?: { __typename: 'CreditLimit', amount: number, currency: string } | null } | null };

export type GetWebAccountCreditApplicationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebAccountCreditApplicationQuery = { __typename?: 'Query', getWebAccountCreditApplication?: { __typename: 'WebAccountCreditApplicationResponse', status: string, created: string, effectiveInterestRate?: number | null, fundingOrganization?: FundingOrganization | null, id: string, interestRate?: number | null, loanNumber?: string | null, signedContractDate?: string | null, address?: { __typename: 'Address', city: string, street: string, streetExtra: string, streetExtra2: string, zip: string } | null, ssn?: { __typename?: 'Identity', value?: string | null } | null, contactInformation?: { __typename: 'AccountContactInformation', email?: { __typename?: 'EmailAddress', value?: string | null } | null, phone?: { __typename?: 'MobilePhoneNumber', given?: string | null } | null } | null, creditLimit?: { __typename: 'CreditLimit', amount: number, currency: string } | null } | null };

export type WebAccountCreditApplicationFragment = { __typename: 'WebAccountCreditApplicationResponse', status: string, created: string, effectiveInterestRate?: number | null, fundingOrganization?: FundingOrganization | null, id: string, interestRate?: number | null, loanNumber?: string | null, signedContractDate?: string | null, address?: { __typename: 'Address', city: string, street: string, streetExtra: string, streetExtra2: string, zip: string } | null, ssn?: { __typename?: 'Identity', value?: string | null } | null, contactInformation?: { __typename: 'AccountContactInformation', email?: { __typename?: 'EmailAddress', value?: string | null } | null, phone?: { __typename?: 'MobilePhoneNumber', given?: string | null } | null } | null, creditLimit?: { __typename: 'CreditLimit', amount: number, currency: string } | null };

export type IsJwtValidQueryVariables = Exact<{ [key: string]: never; }>;


export type IsJwtValidQuery = { __typename?: 'Query', isJwtValid: { __typename: 'CustomClaims', user: { __typename?: 'UserClaims', member_id: string, ssn: string } } };

export const WebAccountCreditApplicationFragmentDoc = gql`
    fragment WebAccountCreditApplication on WebAccountCreditApplicationResponse {
  __typename
  address {
    __typename
    city
    street
    streetExtra
    streetExtra2
    zip
  }
  ssn {
    value
  }
  status
  contactInformation {
    email {
      value
    }
    phone {
      given
    }
    __typename
  }
  created
  creditLimit {
    amount
    currency
    __typename
  }
  effectiveInterestRate
  fundingOrganization
  id
  interestRate
  loanNumber
  signedContractDate
}
    `;
export const CreateNewApplicationDocument = gql`
    mutation CreateNewApplication($adtractionId: String, $adwordsId: String) {
  createNewApplication(adtractionId: $adtractionId, adwordsId: $adwordsId) {
    applicationId
    mayApply
  }
}
    `;

export function useCreateNewApplicationMutation() {
  return Urql.useMutation<CreateNewApplicationMutation, CreateNewApplicationMutationVariables>(CreateNewApplicationDocument);
};
export const LoanBrokerApplicationsDocument = gql`
    query LoanBrokerApplications {
  loanBrokerApplications {
    applicationId
    status
    createdAt
  }
}
    `;

export function useLoanBrokerApplicationsQuery(options?: Omit<Urql.UseQueryArgs<LoanBrokerApplicationsQueryVariables>, 'query'>) {
  return Urql.useQuery<LoanBrokerApplicationsQuery, LoanBrokerApplicationsQueryVariables>({ query: LoanBrokerApplicationsDocument, ...options });
};
export const SendApplicationDataDocument = gql`
    mutation SendApplicationData($id: String!, $input: SendApplicationDataInput!) {
  sendApplicationData(id: $id, input: $input) {
    id
  }
}
    `;

export function useSendApplicationDataMutation() {
  return Urql.useMutation<SendApplicationDataMutation, SendApplicationDataMutationVariables>(SendApplicationDataDocument);
};
export const LoanPredictionDocument = gql`
    mutation LoanPrediction($request: RequestLoanPredictionInput!) {
  loanPrediction(request: $request) {
    __typename
    ... on LoanPredictionQuotaExceeded {
      message
    }
    ... on RangedLoanPredictionResult {
      spans {
        amount
        loanPrediction {
          bounds {
            lower
            upper
          }
          likelihood
        }
      }
      input {
        maritalStatus
        children
        accommodationType
        occupationType
        monthlyIncome
        paymentRemark
        existingLoansToConsolidate
        existingLoansTotalAmount
      }
      version
    }
  }
}
    `;

export function useLoanPredictionMutation() {
  return Urql.useMutation<LoanPredictionMutation, LoanPredictionMutationVariables>(LoanPredictionDocument);
};
export const LoanPredictionModelVersionDocument = gql`
    query LoanPredictionModelVersion {
  loanPredictionModelVersion {
    __typename
    version
    releaseDate
    accuracy
    isDefault
  }
}
    `;

export function useLoanPredictionModelVersionQuery(options?: Omit<Urql.UseQueryArgs<LoanPredictionModelVersionQueryVariables>, 'query'>) {
  return Urql.useQuery<LoanPredictionModelVersionQuery, LoanPredictionModelVersionQueryVariables>({ query: LoanPredictionModelVersionDocument, ...options });
};
export const FetchMemberDocument = gql`
    query FetchMember($token: String!) {
  fetchMember(token: $token) {
    payload {
      user {
        preferredName
        firstName
        id
      }
    }
  }
}
    `;

export function useFetchMemberQuery(options: Omit<Urql.UseQueryArgs<FetchMemberQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchMemberQuery, FetchMemberQueryVariables>({ query: FetchMemberDocument, ...options });
};
export const LoanBrokerApplicationDetailsDocument = gql`
    query LoanBrokerApplicationDetails($includeCompleted: Boolean) {
  loanBrokerApplications(includeCompleted: $includeCompleted) {
    applicationId
    status
    createdAt
    updatedAt
    applicationData {
      totalAmount {
        amount
        currency
        unit
      }
      consolidate {
        ofTotalToConsolidate {
          amount
          currency
          unit
        }
      }
      amortizationPeriod {
        length
        chronoUnit {
          name
        }
      }
      loanPurpose
      contactDetails {
        phoneNumber
        email
      }
      personalDetails {
        maritalStatus
        children
      }
      accommodation {
        accommodationType
        monthlyCost {
          amount
          currency
          unit
        }
      }
      occupation {
        occupationType {
          occupation_type_name
          companyName
          companyPhone
          since
          to
        }
        monthlyIncome {
          amount
          currency
          unit
        }
      }
      coApplicantData {
        contactDetails {
          phoneNumber
          email
        }
        personalDetails {
          maritalStatus
          children
        }
        accommodation {
          accommodationType
          monthlyCost {
            amount
            currency
            unit
          }
        }
        occupation {
          occupationType {
            occupation_type_name
            companyName
            companyPhone
            since
            to
          }
          monthlyIncome {
            amount
            currency
            unit
          }
        }
      }
    }
  }
}
    `;

export function useLoanBrokerApplicationDetailsQuery(options?: Omit<Urql.UseQueryArgs<LoanBrokerApplicationDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<LoanBrokerApplicationDetailsQuery, LoanBrokerApplicationDetailsQueryVariables>({ query: LoanBrokerApplicationDetailsDocument, ...options });
};
export const LoanBrokerQuotesDocument = gql`
    query LoanBrokerQuotes($id: String!) {
  loanBrokerQuotes(id: $id) {
    quotes {
      partnerBank
      amount {
        amount
        currency
        unit
      }
      amortizationPeriod {
        length
        chronoUnit {
          name
        }
      }
      amountToSolveExternal {
        amount
        currency
        unit
      }
      interestRateNominal
      interestRateEffective
      monthlyInstallment {
        ... on Annuity {
          __typename
          amount {
            amount
            currency
            unit
          }
        }
        ... on Serial {
          __typename
          amountFirst {
            amount
            currency
            unit
          }
          amountLast {
            amount
            currency
            unit
          }
        }
      }
      setupFee {
        amount
        currency
        unit
      }
      monthlyFee {
        amount
        currency
        unit
      }
      totalCost {
        amount
        currency
        unit
      }
      conditions {
        ... on ConsolidateDebts {
          __typename
          ConsolidateDebts {
            amount {
              amount
              currency
            }
          }
        }
        ... on Complements {
          __typename
          Complements {
            values {
              text
            }
          }
        }
        ... on CoApplicant {
          __typename
          CoApplicant {
            complements {
              text
            }
            message
          }
        }
      }
      validTo
    }
    pending
  }
}
    `;

export function useLoanBrokerQuotesQuery(options: Omit<Urql.UseQueryArgs<LoanBrokerQuotesQueryVariables>, 'query'>) {
  return Urql.useQuery<LoanBrokerQuotesQuery, LoanBrokerQuotesQueryVariables>({ query: LoanBrokerQuotesDocument, ...options });
};
export const LoanBrokerApplicationStateDocument = gql`
    query LoanBrokerApplicationState($id: String!) {
  loanBrokerState(id: $id) {
    done
  }
}
    `;

export function useLoanBrokerApplicationStateQuery(options: Omit<Urql.UseQueryArgs<LoanBrokerApplicationStateQueryVariables>, 'query'>) {
  return Urql.useQuery<LoanBrokerApplicationStateQuery, LoanBrokerApplicationStateQueryVariables>({ query: LoanBrokerApplicationStateDocument, ...options });
};
export const LoanBrokerQuoteDecisionDocument = gql`
    query LoanBrokerQuoteDecision($id: String!) {
  loanBrokerQuoteDecision(applicationId: $id) {
    partnerBank
    signingLink
  }
}
    `;

export function useLoanBrokerQuoteDecisionQuery(options: Omit<Urql.UseQueryArgs<LoanBrokerQuoteDecisionQueryVariables>, 'query'>) {
  return Urql.useQuery<LoanBrokerQuoteDecisionQuery, LoanBrokerQuoteDecisionQueryVariables>({ query: LoanBrokerQuoteDecisionDocument, ...options });
};
export const CancelApplicationDocument = gql`
    mutation CancelApplication($applicationId: String!) {
  cancelApplication(applicationId: $applicationId)
}
    `;

export function useCancelApplicationMutation() {
  return Urql.useMutation<CancelApplicationMutation, CancelApplicationMutationVariables>(CancelApplicationDocument);
};
export const SendQuotesDecisionDocument = gql`
    mutation SendQuotesDecision($applicationId: String!, $input: SendQuoteDecisionInput!) {
  sendQuotesDecision(id: $applicationId, input: $input) {
    success
    signingLink
    error
  }
}
    `;

export function useSendQuotesDecisionMutation() {
  return Urql.useMutation<SendQuotesDecisionMutation, SendQuotesDecisionMutationVariables>(SendQuotesDecisionDocument);
};
export const LastLoanPredictionDocument = gql`
    query LastLoanPrediction {
  lastLoanPrediction {
    __typename
    input {
      maritalStatus
      children
      accommodationType
      occupationType
      monthlyIncome
      paymentRemark
      existingLoansToConsolidate
      existingLoansTotalAmount
    }
    spans {
      amount
      loanPrediction {
        bounds {
          lower
          upper
        }
        likelihood
      }
    }
  }
}
    `;

export function useLastLoanPredictionQuery(options?: Omit<Urql.UseQueryArgs<LastLoanPredictionQueryVariables>, 'query'>) {
  return Urql.useQuery<LastLoanPredictionQuery, LastLoanPredictionQueryVariables>({ query: LastLoanPredictionDocument, ...options });
};
export const InitAuthDocument = gql`
    mutation InitAuth {
  postAuth(input: {usage: {usageType: WEB}}) {
    authJwt
    launchInfo {
      autoStartToken
      qrAuthData
    }
  }
}
    `;

export function useInitAuthMutation() {
  return Urql.useMutation<InitAuthMutation, InitAuthMutationVariables>(InitAuthDocument);
};
export const GetAuthStatusDocument = gql`
    query GetAuthStatus($authJwt: String!) {
  getAuth(token: $authJwt) {
    status
    qrAuthData
    rockerJwt
  }
}
    `;

export function useGetAuthStatusQuery(options: Omit<Urql.UseQueryArgs<GetAuthStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAuthStatusQuery, GetAuthStatusQueryVariables>({ query: GetAuthStatusDocument, ...options });
};
export const PartnerLoanDocument = gql`
    query PartnerLoan {
  partnerLoan {
    id
    partner
    amount {
      amount
      currency
    }
    amortizationPeriod {
      length
      chronoUnit {
        name
      }
    }
    disbursedAt
    partnerLink
    applicationId
  }
}
    `;

export function usePartnerLoanQuery(options?: Omit<Urql.UseQueryArgs<PartnerLoanQueryVariables>, 'query'>) {
  return Urql.useQuery<PartnerLoanQuery, PartnerLoanQueryVariables>({ query: PartnerLoanDocument, ...options });
};
export const InitAuthForSsnDocument = gql`
    mutation InitAuthForSsn($ssn: String!) {
  postAuth(input: {usage: {usageType: WEB, ssn: $ssn}}) {
    authJwt
  }
}
    `;

export function useInitAuthForSsnMutation() {
  return Urql.useMutation<InitAuthForSsnMutation, InitAuthForSsnMutationVariables>(InitAuthForSsnDocument);
};
export const GetAuthForSsnStatusDocument = gql`
    query GetAuthForSsnStatus($authJwt: String!) {
  getAuth(token: $authJwt) {
    status
    rockerJwt
  }
}
    `;

export function useGetAuthForSsnStatusQuery(options: Omit<Urql.UseQueryArgs<GetAuthForSsnStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAuthForSsnStatusQuery, GetAuthForSsnStatusQueryVariables>({ query: GetAuthForSsnStatusDocument, ...options });
};
export const AddWebAccountCreditApplicationDocument = gql`
    mutation AddWebAccountCreditApplication($input: ApplyForAccountCreditInput!) {
  addWebAccountCreditApplication(input: $input) {
    decision
  }
}
    `;

export function useAddWebAccountCreditApplicationMutation() {
  return Urql.useMutation<AddWebAccountCreditApplicationMutation, AddWebAccountCreditApplicationMutationVariables>(AddWebAccountCreditApplicationDocument);
};
export const SignWebAccountCreditApplicationDocument = gql`
    mutation SignWebAccountCreditApplication {
  signWebAccountCreditApplication {
    success
  }
}
    `;

export function useSignWebAccountCreditApplicationMutation() {
  return Urql.useMutation<SignWebAccountCreditApplicationMutation, SignWebAccountCreditApplicationMutationVariables>(SignWebAccountCreditApplicationDocument);
};
export const AddWebAccountCreditApplicationIncreaseDocument = gql`
    mutation AddWebAccountCreditApplicationIncrease($input: ApplyForAccountCreditInput!) {
  addWebAccountCreditApplicationIncrease(input: $input) {
    decision
  }
}
    `;

export function useAddWebAccountCreditApplicationIncreaseMutation() {
  return Urql.useMutation<AddWebAccountCreditApplicationIncreaseMutation, AddWebAccountCreditApplicationIncreaseMutationVariables>(AddWebAccountCreditApplicationIncreaseDocument);
};
export const SignWebAccountCreditApplicationIncreaseDocument = gql`
    mutation SignWebAccountCreditApplicationIncrease {
  signWebAccountCreditApplicationIncrease {
    success
  }
}
    `;

export function useSignWebAccountCreditApplicationIncreaseMutation() {
  return Urql.useMutation<SignWebAccountCreditApplicationIncreaseMutation, SignWebAccountCreditApplicationIncreaseMutationVariables>(SignWebAccountCreditApplicationIncreaseDocument);
};
export const GetWebAccountCreditDocument = gql`
    query GetWebAccountCredit {
  getWebAccountCredit {
    status
  }
}
    `;

export function useGetWebAccountCreditQuery(options?: Omit<Urql.UseQueryArgs<GetWebAccountCreditQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWebAccountCreditQuery, GetWebAccountCreditQueryVariables>({ query: GetWebAccountCreditDocument, ...options });
};
export const GetWebAccountCreditApplicationIncreaseDocument = gql`
    query GetWebAccountCreditApplicationIncrease {
  getWebAccountCreditApplicationIncrease {
    ...WebAccountCreditApplication
  }
}
    ${WebAccountCreditApplicationFragmentDoc}`;

export function useGetWebAccountCreditApplicationIncreaseQuery(options?: Omit<Urql.UseQueryArgs<GetWebAccountCreditApplicationIncreaseQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWebAccountCreditApplicationIncreaseQuery, GetWebAccountCreditApplicationIncreaseQueryVariables>({ query: GetWebAccountCreditApplicationIncreaseDocument, ...options });
};
export const GetWebAccountCreditApplicationDocument = gql`
    query GetWebAccountCreditApplication {
  getWebAccountCreditApplication {
    ...WebAccountCreditApplication
  }
}
    ${WebAccountCreditApplicationFragmentDoc}`;

export function useGetWebAccountCreditApplicationQuery(options?: Omit<Urql.UseQueryArgs<GetWebAccountCreditApplicationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWebAccountCreditApplicationQuery, GetWebAccountCreditApplicationQueryVariables>({ query: GetWebAccountCreditApplicationDocument, ...options });
};
export const IsJwtValidDocument = gql`
    query IsJwtValid {
  isJwtValid {
    __typename
    user {
      member_id
      ssn
    }
  }
}
    `;

export function useIsJwtValidQuery(options?: Omit<Urql.UseQueryArgs<IsJwtValidQueryVariables>, 'query'>) {
  return Urql.useQuery<IsJwtValidQuery, IsJwtValidQueryVariables>({ query: IsJwtValidDocument, ...options });
};